import React from 'react';
import { fromJS  } from 'immutable';
import BezierPlugin from "gsap/BezierPlugin";
import { CSSTransition } from 'react-transition-group';
import config from '../config/app.json';
import TransformManager from '../containers/TransformManager';
import ItemToolBar from '../containers/ItemToolBar';
import Player from '../containers/Player';
import Text from '../containers/Text';
import {TweenMax, TimelineMax, Linear,Back, Bounce, SteppedEase,  Power1, Ease } from 'gsap';
import CustomEase from "gsap/CustomEase";
import axios from 'axios';
import { getPath, setControlPoints, getRatio } from '../helpers/ShapeHelper';
import PreviewEffects from '../helpers/previewHelper';
import Crop from '../containers/Crop';
import ErrorHandler from '../helpers/ErrorHandler';
import ProgressiveImage from '../containers/ProgressiveImage';
import { errorlog } from '../helpers/ErrorLogService';
import { FormattedMessage } from 'react-intl';
import uuid from 'uuid/v1';
import * as Utility from '../helpers/utilityMethods';
import { OrderedMap } from 'immutable';
import Frames from '../containers/Frame/Frames';
import Grid from '../containers/Grid';


import {ReturnSvgFilter} from "./ReturnSvgFilter"
import HyperLinkToolBar from '../containers/HyperLinkToolBar';


class RenderSvg extends React.Component {
  constructor(props) {
    super(props);
    this.wkspcObj = new WorkspaceComponent();
    this.state = { svgElement: null }
    this.svgData = [];
    this.isLoaded = false;
    this.appUrl = config['APPICONS'][config['APPICONS']['current']];
    this.assetUrl = config["ASSETS"][config["ASSETS"]["current"]];
    this.isSceneClick=false;
  }

  componentWillMount() {    
    var setClass = 'scene-item-inner';
    if (this.props.isBG) {
      setClass = '';
    }
    else if (this.props.isKeyframe) {
      setClass = 'keyframe-item-inner';
    }
    if(this.props.thumbnail)
    {
      this.svgData.push(<div key={this.props.data_id} className={setClass} id={this.props.data_id + "inner"} style={{ width: "100%", height: "100%", position: "absolute" }} data-id={this.props.data_id}>
      <img alt="thumbnail" src={this.props.thumbnail}/>
      </div>);
      this.setState({ svgElement: this.svgData });
    }
    axios({
      method: 'GET',
      url: this.props.src,
      mode: 'cors',
      withCredentials: false, 
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',          
        'Content-Type': 'image/svg+xml'
      },
      data:{},
      
    }).then(function (res) {
      this.svgData = [];
      if (!this.isLoaded) {
        if (this.props.colors) {
          this.props.colors.entrySeq().forEach(([_className, _color]) => {
            var cols = res.request.responseXML.documentElement.getElementsByClassName(_className);
            for (var i = 0; i < cols.length; i++) {
              if (cols[i].getAttribute("ue") !== null) {
                var newColor = _iHSL10(_color.substr(1), cols[i].getAttribute("ue"), cols[i].getAttribute("sa"), cols[i].getAttribute("li"));
                cols[i].setAttribute('fill', newColor);
              } else {
                cols[i].setAttribute('fill', _color);
              }
            }
          });
        }
      }
     
      this.svgData.push(<div key={this.props.data_id} className={setClass} id={this.props.data_id + "inner"} style={{ width: "100%", height: "100%", position: "absolute" }} data-id={this.props.data_id} dangerouslySetInnerHTML={{ __html: res.request.responseXML.documentElement.outerHTML }} />)
      this.setState({ svgElement: this.svgData });
    }.bind(this)).catch(function (error) {
      errorlog("Custom character svg source failed to load componentWillMount " ,error, "WorkspaceComponent-componentWillMount");
    });
    
  }

  componentDidUpdate(prevProps, prevState) {
    this.isLoaded = true;
  }

  render() {
   
    return this.state.svgElement;
  }
}

class SVGConstructor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      svgItem:""
    }    
  }

  componentDidMount(){
    var svgItem = this.getCustomPath();
    this.setState({svgItem:svgItem})
    
    if (this.props.isPlayAll || this.props.isPlay) {
      if (this.props.itemId)
        window.totalArr = window.totalArr.filter(e => e !== this.props.itemId);
      else
        window.totalArr = window.totalArr.filter(e => e !== this.props.data_id);


      if (window.totalArr.length === 0)
        this.props.startPlay("workspace")
    }
  }
  

  componentDidUpdate(prevProps, prevState){
    if(prevProps.zoomFactor !== this.props.zoomFactor || prevProps.item.get("pathData") !== this.props.item.get("pathData") || prevProps.item.get("colors") !== this.props.item.get("colors") || prevProps.item.get("width") !== this.props.item.get("width") || prevProps.item.get("height") !== this.props.item.get("height")){
      var svgItem = this.getCustomPath();
      this.setState({svgItem:svgItem});
    }
  }

  getCustomPath() {
    let item = this.props.item;

    let paths = [];
    let pathDetails = getPath(item, this.props.zoomFactor);
    let pathData = pathDetails.pathDetails;
    let colors = item.get("colors");
    if (Array.isArray(pathData)) {
      for (var i = 0; i < pathData.length; i++) {

        let style = {};
        if (pathData[i].pathStyle !== undefined)
          style = { transform: "translate(" + pathData[i].pathStyle.left + "px, " + pathData[i].pathStyle.top + "px)" };

        paths.push(<g xmlns="http://www.w3.org/2000/svg" key={i} style={style}><path xmlns="http://www.w3.org/2000/svg" d={pathData[i].data} className={"path" + i} strokeWidth="4px" stroke={(pathData[i].isStroke) ? pathData[i].color : "none"} fill={(pathData[i].isFill) ? pathData[i].color : "none"}></path></g>)

      }
    }

    return <svg xmlns="http://www.w3.org/2000/svg" width={pathDetails.shapeStyle === undefined ? item.get("width") * this.props.zoomFactor : pathDetails.shapeStyle.width} height={pathDetails.shapeStyle === undefined ? item.get("height") * this.props.zoomFactor : pathDetails.shapeStyle.height} style={pathDetails.shapeStyle !== undefined ? pathDetails.shapeStyle : {}}>{paths}</svg>;
  }

  render() {
    return (this.state.svgItem);
  }
}

export class Callout extends React.Component {

  pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  componentDidMount(){
    
    
  }
  
  render() {
    var xRatio = this.props.data.get("xRatio") !== undefined ? this.props.data.get("xRatio") : 5;
    var yRatio = this.props.data.get("yRatio") !== undefined ? this.props.data.get("yRatio") : 5;
    var widthRatio = this.props.data.get("widthRatio") !== undefined ? this.props.data.get("widthRatio") : 90;
    var heightRatio = this.props.data.get("heightRatio") !== undefined ? this.props.data.get("heightRatio") : 90;

    var textX = ((xRatio * this.props.data.get("width")) / 100) * this.props.zoomFactor;

    var textY = ((yRatio * this.props.data.get("height")) / 100) * this.props.zoomFactor;

    var textWidth = ((widthRatio * this.props.data.get("width")) / 100) * this.props.zoomFactor;

    var textHeight = ((heightRatio * this.props.data.get("height")) / 100) * this.props.zoomFactor;

   
    var flip = getFlipPosition(this.props.data.get("flipPosition"));
    let configBasePath = this.assetUrl+config[this.props.data.get('type')][config[this.props.data.get('type')][(this.props.data.get('subType')) ? 'workspace_' + this.props.data.get('subType') : 'workspace']];
    
    let svgImage = null;
    if((this.props.data.get("type") === "SHAPE" && this.props.data.get("subType") === "CSTMPTH") || (this.props.data.get("type") === "TEXT" && this.props.data.get("subType") === "BANNER")){
      
      svgImage = <SVGConstructor data_id={this.props.data_id} item = {this.props.data} zoomFactor = {this.props.zoomFactor} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} startPlay={this.props.startPlay} itemId = {this.props.itemId}/>
    }
    else{
      svgImage = <CustomSVGRender animakerType = {this.props.animakerType} uploadSVG={false} workspaceWidth={this.props.workspaceWidth} workspaceHeight={this.props.workspaceHeight} parentItem = {this.parentItem} completeWorkspaceItems={this.props.data} startPlay={this.props.startPlay} addTween={null} workspaceItems={this.props.workspaceItems} changePlayTime={null} playHeadValue={this.props.playHeadValue} pose={this.props.data.get("pose")} expression={this.props.data.get("expression")} zoomFactor = {this.props.zoomFactor} assetType={this.props.data.get("type")} data_id={this.props.data_id} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} key={this.props.itemId} selectedItems={this.props.selectedItems} src={configBasePath + this.props.data.get("src")} colors={this.props.data.get("colors")} parts={this.props.data.get("parts")} animdata={this.props.data.get("animdata")} socket={this.props.socket} updateItem={this.props.updateItem} selectedScene={this.props.selectedScene}/>;
    }
    return (
      <React.Fragment>
            {svgImage}
            <div className="callout-text-container" style={{ transform: "translate(" + textX + "px, " + textY + "px)" + flip, width: textWidth + "px", height: textHeight + "px", position: "absolute" }} data-id={this.props.itemId}>
              <Text text={this.props.data} data_id={this.props.data_id} currentScene = {this.props.selectedScene} itemId = {this.props.itemId} linkEnabled={this.props.isPlay} isGrouped = {this.props.isGrouped}  socket={this.props.socket}/>
            </div>
      </React.Fragment>
    );
  }
}

function getFlipPosition(value, angle) {
  let flip = (value === 1) ? " scaleX(-1)" : (value === 2) ? " scaleY(-1)" : (value === 3) ? " scaleX(-1) scaleY(-1)" : "";
  return flip;
}


export class CustomBGRender extends React.Component {

  constructor(props)
  {
    super(props);
    this.state = { svgElement: null }
    this.svgData = [];
    this.isLoaded = false;
    this.loadSVGData = this.loadSVGData.bind(this);
  }

  setColors(colors, element, hasGradient)
  {

    colors.entrySeq().forEach(([_className, _color]) =>
    {
      var cols = element.querySelectorAll("[class*='" + _className + "']");
    
      for (var i = 0; i < cols.length; i++)
      {
        if (_className === "prop1" && hasGradient === "1")
        {
          this.setGradient(_color, _iHSL10(_color.substr(1), -0.009, -0.622, -0.221), element);
          return;
        }
        else
        {
          var resa = cols[i].className.animVal.replace(/zf/g, '.');
          resa = resa.split("_");
          if (cols[i].firstChild && !cols[i].className.animVal.includes("Mc"))
          {
            if (resa.length !== 1)
            {
              var newColor = _iHSL10(_color.substr(1), parseFloat(resa[1]), parseFloat(resa[2]), parseFloat(resa[3]));
              if (cols[i].children.length > 0)
              {
                if (cols[i].firstChild.hasAttribute("fill"))
                  cols[i].firstChild.setAttribute('fill', newColor);
                if (cols[i].firstChild.hasAttribute("stroke"))
                  cols[i].firstChild.setAttribute('stroke', newColor);
              }
            }
            else
            {
              if (cols[i].children.length > 0)
              {
                if (cols[i].firstChild.hasAttribute("fill"))
                  cols[i].firstChild.setAttribute('fill', _color);
                if (cols[i].firstChild.hasAttribute("stroke"))
                  cols[i].firstChild.setAttribute('stroke', _color);
              }
            }
          }
          else
          {
            if (cols[i].hasAttribute("fill"))
              cols[i].setAttribute('fill', _color);
          }
        }
      }
    
    });
  }

  setGradient(color, subColor, element){
    var color1 = hex2rgb(color.substr(1))
    var color2 = hex2rgb(subColor.substr(1))

    var r1=color1[0]
    var g1=color1[1]
    var b1=color1[2]
    //color2
    var r2=color2[0]
    var g2=color2[1]
    var b2=color2[2]
    
    var r_mid=r1+((r2-r1)/2)
    var g_mid=g1+((g2-g1)/2)
    var b_mid=b1+((b2-b1)/2)
    var id="gr_eKkwrvfwvE"
    
    var defs = element.querySelectorAll("stop");
    defs[0].setAttribute('stop-color',"rgb("+r1+","+g1+","+b1+")");
    defs[1].setAttribute('stop-color',"rgb("+r_mid+","+g_mid+","+b_mid+")");
    defs[2].setAttribute('stop-color',"rgb("+r2+","+g2+","+b2+")");
    
  }

  componentWillMount()
  {
      this.loadSVGData(this.props.src, false);
  }

  

  loadSVGData(srcVal, fromExpression)
  {
   
    if (document.getElementById(this.props.data_id) && !this.props.isPlay && document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0] && this.props.assetType !== "PROP" && this.props.assetType !== "SCREEN")
      document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "flex";
      let sceneBGData = this.props.completeWorkspaceItems.get("workspaceBG");
      if(sceneBGData.get('type') === 'BG'){
        let bgPreview = document.getElementById('bgWrkspcPreview');
        if(bgPreview)
          bgPreview.style.display = 'none';

      this.setState({ svgElement:<img alt="bg" className="bg-image" key={sceneBGData.get('src')} src={this.props.proxyImg} style={this.props.bgImgStyles} />});
      }
    axios({
      method: 'GET',
      url: srcVal,
      mode: 'cors',
      withCredentials: false,
      credentials: 'same-origin',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'image/svg+xml'
      },
      data: {},
    }).then(function (res)
    {
    
      this.svgData = [];
     
      if (!this.isLoaded)
      {
        if (this.props.colors)
        {
          this.setColors(this.props.colors, res.request.responseXML.documentElement, this.props.hasGradient);
        }
      }
  
        var setClass = 'scene-item-inner';
        if (this.props.isBG) {
          setClass = '';
        }
        var svgEle = res.request.responseXML.documentElement;
        for (var i = 0; i < svgEle.getElementsByTagName("mask").length; i++) {
          var random = Math.random().toString(12).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()
          svgEle.querySelectorAll("[mask=\"url(#" + svgEle.getElementsByTagName("mask")[i].id + ")\"]")[0].setAttribute("mask", "url(#" + random + ")")
          svgEle.getElementsByTagName("mask")[i].id = random
        }
        for (var i = 0; i < svgEle.getElementsByTagName("filter").length; i++) {
          var random = Math.random().toString(12).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()
          svgEle.querySelectorAll("[filter=\"url(#" + svgEle.getElementsByTagName("filter")[i].id + ")\"]")[0].setAttribute("filter", "url(#" + random + ")")
          svgEle.getElementsByTagName("filter")[i].id = random
        }
        for (var i = 0; i < svgEle.getElementsByTagName("clipPath").length; i++) {
          var random = Math.random().toString(12).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()
          svgEle.querySelectorAll("[clip-path=\"url(#" + svgEle.getElementsByTagName("clipPath")[i].id + ")\"]")[0].setAttribute("clipPath", "url(#" + random + ")")
          svgEle.getElementsByTagName("clipPath")[i].id = random
        }
       
        this.svgData.push(<div key={this.props.data_id} className={setClass} id={this.props.data_id + "inner"} style={this.props.bgImgStyles} data-id={this.props.data_id} dangerouslySetInnerHTML={{ __html: res.request.responseXML.documentElement.outerHTML }} />)
       
      this.setState({ svgElement: this.svgData }, function ()
      {
        if (this.props.assetType === "PROP" || this.props.assetType === "SCREEN")
        {
          if (document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])
            document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "none";
        }
  
      });
    }.bind(this)).catch(function (error)
    {
      errorlog("Custom character svg source failed to load loadSVGData " ,error, "WorkspaceComponent-loadSVGData");    
    });
  }

  componentWillReceiveProps(nextProps)
  {  
      if(this.props.colors !== nextProps.colors && this.props.src === nextProps.src && document.getElementById(nextProps.data_id+"inner") !== null){
        this.setColors(nextProps.colors, document.getElementById(nextProps.data_id+"inner"), nextProps.hasGradient);
      }


      if(this.props.bgImgStyles !== nextProps.bgImgStyles){
        if(document.getElementById(nextProps.data_id+"inner") !== null){
          document.getElementById(nextProps.data_id+"inner").style.width = nextProps.bgImgStyles.width;
          document.getElementById(nextProps.data_id+"inner").style.height = nextProps.bgImgStyles.height;
          document.getElementById(nextProps.data_id+"inner").style.transform = nextProps.bgImgStyles.transform;
          document.getElementById(nextProps.data_id+"inner").style.filter = nextProps.bgImgStyles.filter;
        }
        
      }
  }

  componentDidUpdate(prevProps, prevState)
  {
    if((this.props.src !== prevProps.src) || (this.props.data_id !== prevProps.data_id) || (this.props.bgImgStyles.width!==prevProps.bgImgStyles.width)){
      this.loadSVGData(this.props.src, false);
    }
  }

  componentWillUnmount()
  {
  }
  
  render()
  {
   
    var sourceThumb = "";
 
    if (!this.props.isPlay)
    {
      return (
        <div style={{ width: "inherit", height: "inherit", pointerEvents: "none", position : "absolute" }}>
          {this.state.svgElement}
        </div>
      )
    }
    else
      return (
        <React.Fragment>
          {this.state.svgElement}</React.Fragment>)
  }
}

export class TransitionPreview extends React.Component {
  constructor(props) {
      super(props);
      this.state = {status: "loaded", svgSource : null, svgData : null, effect : null, animSrc : null, animData : null, colors : null, src : null};
      this.assetUrl = config["ASSETS"][config["ASSETS"]["current"]];
      this.appUrl = config["APPICONS"][config["APPICONS"]["current"]];
      this.overAllBenzValues = [];
      this.t1 = null;
      this.random = Math.random();
      this.scenePreview = new PreviewEffects({zoomFactor : props.zoomFactor, width : props.width, height : props.height, browserName : props.browserName});
  }

  static getDerivedStateFromProps(props, state) {
    let toReturn = {};
    if(props.effect !== state.effect){
      toReturn = Object.assign(toReturn, {effect : props.effect});
    }
    if(props.colors !== state.colors && props.colors !== undefined && props.colors.size > 0){
        
        let svgSource = config["ASSETS"][config["ASSETS"]["current"]] + config["SCREEN"][config["SCREEN"]["workspace"]]+(props.width > props.height?"horizontal":props.width < props.height?"vertical":"square")+"/"+props.effect+".svg";
        let animSrc = config["ASSETS"][config["ASSETS"]["current"]] + config["SCREEN"]["animdata"]+(props.width > props.height?"horizontal":props.width < props.height?"vertical":"square")+"/"+props.effect+".json";
        toReturn = Object.assign(toReturn, {colors : props.colors, svgSource : svgSource, animSrc : animSrc, svgAnimation : true});
    }
    else{
        toReturn = Object.assign(toReturn, {svgAnimation : false});
    }
     
    return toReturn;
  }

  componentDidMount(){
    if(this.state.svgAnimation){
      this.loadSvgData(this.state.svgSource).then(data =>{
        this.setColors(this.state.colors, this.slideSvg.getElementsByTagName("svg")[0], false);
        this.loadAnimData(this.state.animSrc).then(data =>{
          this.random = Math.random();
        });
      });
    }
  }

  setColors(colors, element, hasGradient)
  {
   
      colors.entrySeq().forEach(([_className, _color]) =>
      {
      var cols = element.querySelectorAll("[class*='" + _className + "']");
      for (var i = 0; i < cols.length; i++)
      {
          if (_className === "prop1" && hasGradient === "1")
          {
          this.setGradient(_color, _iHSL10(_color.substr(1), -0.009, -0.622, -0.221), element);
          return;
          }
          else
          {
          var resa = cols[i].className.animVal.replace(/zf/g, '.');
          resa = resa.split("_");
          if (cols[i].firstChild && !cols[i].className.animVal.includes("Mc"))
          {
              if (resa.length !== 1)
              {
              var newColor = _iHSL10(_color.substr(1), parseFloat(resa[1]), parseFloat(resa[2]), parseFloat(resa[3]));
              if (cols[i].children.length > 0)
              {
                  if (cols[i].firstChild.hasAttribute("fill"))
                  cols[i].firstChild.setAttribute('fill', newColor);
                  if (cols[i].firstChild.hasAttribute("stroke"))
                  cols[i].firstChild.setAttribute('stroke', newColor);
              }
              }
              else
              {
              if (cols[i].children.length > 0)
              {
                  if (cols[i].firstChild.hasAttribute("fill"))
                  cols[i].firstChild.setAttribute('fill', _color);
                  if (cols[i].firstChild.hasAttribute("stroke"))
                  cols[i].firstChild.setAttribute('stroke', _color);
              }
              }
          }
          else
          {
              if (cols[i].hasAttribute("fill"))
              cols[i].setAttribute('fill', _color);
          }
          }
      }
      });
  }

  assignTweenValues(res, easeCount){
    document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow = "hidden";
    this.isPlaying = true;
    this.isLoaded = true;
    var parent = {"essentials": res.essentials}
    var animateValues = res.animateValues;
    var originalValues = {}

    for (var child in parent.essentials) {
      var thisName = child;
      originalValues[child] = {
        "positionX": parent.essentials[thisName].p.split(",")[0], "positionY": parent.essentials[thisName].p.split(",")[1],
      }
    
    }

    var isRepeated = 0;
   
    this.t1 = new TimelineMax({ repeat: isRepeated, repeatDelay: 0, yoyo: false, paused: true });
    var easeVal = Linear.easeNone
    if(easeCount === undefined)
    var easeCount = 0;
    var currentEase = {};

      for (var idVal in animateValues) 
      {
        for(var valueData of animateValues[idVal])
        {
       

        if (valueData.a === "P")
        {
          let bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined)
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount
              currentEase[valueData.e] = bezValues;
              easeCount++
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }

          var posXval = valueData.v.split(",")[0];
          var posYval = valueData.v.split(",")[1], hipMCPosition;

          if (posXval < 0)
            posXval = "-=" + Math.abs(posXval)
          else
            posXval = "+=" + Math.abs(posXval)

          if (posYval < 0)
            posYval = "-=" + Math.abs(posYval)
          else
            posYval = "+=" + Math.abs(posYval)

          if (this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0])
            if (this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0].firstChild) {
              
              this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0], valueData.d, {
                immediateRender: false, y: posYval, x: posXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues, onComplete: function () {
                }
              }, valueData.t);
            
            }

        }

        if (valueData.a === "O") {
          var bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined)
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount;
              easeCount++;
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }
          var opacity = valueData.v / 100;
          if(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0])
          {
            this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0], 0.001, { immediateRender: false, opacity: opacity, ease: Linear.easeNone }, valueData.t + (valueData.d / 2));
          }
        }

        if (valueData.a === "S") {

          var bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined)
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount
              easeCount++
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }
          var scaleXval = valueData.v.split(",")[0] / 100;
          var scaleYval = valueData.v.split(",")[1] / 100;

          if (this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0])
          {
              this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0], valueData.d, { scaleY: scaleYval, scaleX: scaleXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, valueData.t);

          }

        }

        if (valueData.a === "R") {
          var bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined) 
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount;
              easeCount++;
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }
          var rotateVal = "";
          if (valueData.v < 0) {
            rotateVal = "-=" + Math.abs(valueData.v)
          }
          else {
            rotateVal = "+=" + Math.abs(valueData.v)
          }

            this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0], valueData.d, { immediateRender: false, rotation: rotateVal, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, valueData.t);
           
        }

        if (valueData.a === "PA") {
          if(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0]!= undefined && this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0].firstChild !== undefined) 
          {
            this.t1.to(this.slideSvg.firstElementChild.getElementsByClassName(idVal)[0].firstChild, valueData.d, { attr: { d: valueData.v } }, Math.abs(valueData.t));
           
          }
        }
      }
    }

    currentEase = {}
     
    this.t1.eventCallback("onComplete", function(e){
      e.pause(0);
      document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow = "unset";
  }, ["{self}"]).play();
     
    //Clearing the objects due to the memeory leak
    
    originalValues = {}
    animateValues = {}

    return easeCount;

  }

  setGradient(color, subColor, element){
      var color1 = hex2rgb(color.substr(1))
      var color2 = hex2rgb(subColor.substr(1))

      var r1=color1[0]
      var g1=color1[1]
      var b1=color1[2]
      //color2
      var r2=color2[0]
      var g2=color2[1]
      var b2=color2[2]
      
      var r_mid=r1+((r2-r1)/2)
      var g_mid=g1+((g2-g1)/2)
      var b_mid=b1+((b2-b1)/2)
      var id="gr_eKkwrvfwvE"
      
      var defs = element.querySelectorAll("stop");
      if(defs && defs[0] !== undefined){
          defs[0].setAttribute('stop-color',"rgb("+r1+","+g1+","+b1+")");
          defs[1].setAttribute('stop-color',"rgb("+r_mid+","+g_mid+","+b_mid+")");
          defs[2].setAttribute('stop-color',"rgb("+r2+","+g2+","+b2+")");
      }
  }

  clearTimeLineMax() {
    if (this.t1 !== null) {
      for (var name in this.overAllBenzValues) {
        delete Ease.map[this.overAllBenzValues[name]];
      }
    
      this.t1.clear()
      this.t1.getChildren().map(val => this.t1.remove(val));
      this.t1.kill();
      this.t1 = null;
      this.overAllBenzValues = [];
    }
  }

  componentDidUpdate(prevProps, prevState){

    if (this.t1 !== null) 
    {
      this.clearTimeLineMax();
    }
    if(this.state.effect !== prevState.effect || this.state.colors !== prevState.colors){
      if(this.state.svgAnimation){
        if(this.state.effect !== prevState.effect){
          this.loadSvgData(this.state.svgSource).then(data =>{
            this.setColors(this.state.colors, this.slideSvg.getElementsByTagName("svg")[0], false);
            this.loadAnimData(this.state.animSrc).then(data =>{
              this.assignTweenValues(this.state.animData);
              this.random = Math.random();
            });
          });
        }
        else{
          this.setColors(this.state.colors, this.slideSvg.getElementsByTagName("svg")[0], false);
          this.assignTweenValues(this.state.animData);
          this.random = Math.random();
        }
      }
      else{
        this.scenePreview.previewScene(this.state.effect);
      }
    }
  }


  loadAnimData(src){
     
    this._axiosRequest = this.fetchByAxios(src).then(
        animData => {
            this._axiosRequest = null;
            this.setState({animData});
        }
    );
    return this._axiosRequest;
}

  loadSvgData(src){
    this.setState({status : "loading"});
      this._axiosRequest = this.fetchByAxios(src).then(
          svgData => {
              this._axiosRequest = null;
              this.setState({svgData:svgData, status : "loaded"});
          }
      );
      return this._axiosRequest;
  }

  fetchByAxios(src){
     
      return axios.get(src).then(response => {
          return response.data
        })
  }


  render(){
   
      let returnElem = null;
      
      if(this.state.svgSource !== null){
        if(this.state.status === "loaded")
          returnElem = <div key = {this.state.src+this.random} ref = {e => this.slideSvg = e} style = {{position : "absolute", left : 0, right : 0, bottom : 0, top : 0, pointerEvents : "none"}} className="scene-transition" dangerouslySetInnerHTML={{ __html: this.state.svgData }}></div>;
        else 
          returnElem = <div key = {this.state.src+this.random} ref = {e => this.slideSvg = e} style = {{position : "absolute", left : 0, right : 0, bottom : 0, top : 0, pointerEvents : "none", display : "flex"}} className="scene-transition"><img id ="transition-loader" src = {this.appUrl +"/images/chr-loading.svg"} alt = "font-name-loader" style={{margin : "0 auto"}} /></div>;
      }
      return(returnElem);
  }
}

export class CustomSVGRender extends React.Component {

  constructor(props)
  {
    super(props);
    this.state = { svgElement: null }
    this.svgData = [];
    this.isLoaded = false;
    this.t1 = new TimelineMax({ paused: true });
    this.mouthT1 = new TimelineMax({ paused: true });
    this.isPlaying = false;
    this.loadSVGData = this.loadSVGData.bind(this);
    this.loadSVGAnimation = this.loadSVGAnimation.bind(this);
    this.loadParts = this.loadParts.bind(this);
    this.changePartHandler = this.changePartHandler.bind(this);
    this.assignTweenValues = this.assignTweenValues.bind(this);
    this.changeExpression = this.changeExpression.bind(this);
    this.clearTimeLineMax = this.clearTimeLineMax.bind(this);
    this.DomParser = new DOMParser();
			
		this.overAllBenzValues = [];
    
    this.partsCount = 0;
    this.partsLoadCount = 0;
    this.ComponentWillMounted = false;
    this.appUrl = config['APPICONS'][config['APPICONS']['current']];
    this.assetUrl = config["ASSETS"][config["ASSETS"]["current"]];

    this.cancelSrcToken = axios.CancelToken;
    this.cancelSrc;
    this.currentExpression = props.expression;
    this.currentExpressionType = props.assetSubType;
    }
// upload, prop
  setColors(colors, element)
  {
    if(!element) return;
    if(this.props.assetSubType === "GRAD"){
      this.setGradient(colors.get("prop1"), colors.get("prop2"), element);
      colors = colors.remove("prop1").remove("prop2");
      if(colors.size > 0){
        colors.entrySeq().forEach(([_className, _color]) => {
          var cols = element.querySelectorAll("[class*='" + _className + "']");
          for (var i = 0; i < cols.length; i++) {
            if (cols[i].getElementsByTagName("path")[0].hasAttribute("fill"))
              cols[i].getElementsByTagName("path")[0].setAttribute('fill', _color);
          }
        })
      }
      return;
    } else {
      colors.entrySeq().forEach(([_className, _color]) =>
      {
        var cols = element.querySelectorAll(`[class${this.props.assetSubType !== "GETTYICON" ? "*" : ""}=${_className}]`);
        if (_color !== "") {
          for (var i = 0; i < cols.length; i++) {
            var resa = cols[i].className.animVal.replace(/zf/g, '.');
            resa = resa.split("_");
            if (cols[i].firstChild && cols[i].firstChild.hasAttribute && !cols[i].className.animVal.includes("Mc")) {
              if (resa.length !== 1) {
                var newColor = _iHSL10(_color.substr(1), parseFloat(resa[1]), parseFloat(resa[2]), parseFloat(resa[3]));
                if (cols[i].children.length > 0) {
                  if (cols[i].firstChild.hasAttribute("fill")){
                      cols[i].firstChild.setAttribute('fill', newColor);
                  }
                  if (cols[i].firstChild.hasAttribute("stroke")){
                      cols[i].firstChild.setAttribute('stroke', newColor);
                  }
                }
              }
              else {
                if (cols[i].children.length > 0) {
                  if (cols[i].firstChild.hasAttribute("fill"))
                    cols[i].firstChild.setAttribute('fill', _color);
                  if (cols[i].firstChild.hasAttribute("stroke"))
                    cols[i].firstChild.setAttribute('stroke', _color);
                }
              }
            }else if(cols[i].hasAttribute('fill') || cols[i].hasAttribute("stroke")){
              if(cols[i].hasAttribute("stroke")){ 
                cols[i].setAttribute("stroke", _color);
              }
              cols[i].setAttribute('fill', _color);
            }
            else if(cols[i].getAttribute('class') && cols[i].getAttribute('class').includes('cls')){
              if(cols[i].getAttribute('class').includes('applyStroke')){
                cols[i].style.stroke = _color
              }else{
                cols[i].style.fill = _color;
              }
            }else {
              if (cols[i].firstChild !== null && cols[i].firstChild.hasAttribute("fill"))
                cols[i].firstChild.setAttribute('fill', _color);
            }
          }
        }
      });
    }
  }
  setGradient(color, subColor, element) {
		
    var color1 = hex2rgb(color.substr(1))
    var color2 = hex2rgb(subColor.substr(1))

    var r1 = color1[0]
    var g1 = color1[1]
    var b1 = color1[2]
    //color2
    var r2 = color2[0]
    var g2 = color2[1]
    var b2 = color2[2]

    var r_mid = r1 + ((r2 - r1) / 2)
    var g_mid = g1 + ((g2 - g1) / 2)
    var b_mid = b1 + ((b2 - b1) / 2)

    
    var grads = element.querySelectorAll("linearGradient");
    for(let i = 0; i<grads.length; i++){
      let defs = grads[i].querySelectorAll("stop");
      if (defs && defs[0] !== undefined) {
        defs[0].setAttribute('stop-color', "rgb(" + r1 + "," + g1 + "," + b1 + ")");
        defs[1].setAttribute('stop-color', "rgb(" + r_mid + "," + g_mid + "," + b_mid + ")");
        defs[2].setAttribute('stop-color', "rgb(" + r2 + "," + g2 + "," + b2 + ")");
      }
    }
    

  }

  componentWillMount()
  {

      if((this.props.isPlay || this.props.isPlayAll) && this.props.assetType ==="PROP" && this.props.isAnimated)
      this.loadSVGData(this.props.animsrc, false);
      else
      this.loadSVGData(this.props.src, false);

  }

  clearTimeLineMax() {
    if (this.t1 !== null) {
      for (var name in this.overAllBenzValues) {
        delete Ease.map[this.overAllBenzValues[name]];
      }

      this.t1.clear()
      this.t1.getChildren().map(val => this.t1.remove(val));
      this.t1.kill();
      this.t1 = null;
      this.overAllBenzValues = []
    }
  }

    drawQcurve(l2, t2, calloutPath){
	
			var x1,y1,x0,y0,x2,y2;
			var miiddleDist=l2+((t2-l2)/2);
			x0 = calloutPath.getPointAtLength(l2).x;
			y0 = calloutPath.getPointAtLength(l2).y;
			x1 = calloutPath.getPointAtLength(miiddleDist).x;
			y1 = calloutPath.getPointAtLength(miiddleDist).y;
			x2 = calloutPath.getPointAtLength(t2).x;
			y2 = calloutPath.getPointAtLength(t2).y;
			x1 = x1 * 2 - ((x0 + x2) / 2);
			y1 = y1 * 2 - ((y0 + y2) / 2);
			return " Q"+ x1+" "+y1+" " + x2 +" "+ y2 +" ";
			
  }
  
  getCubicBezierPoints(pointDataArr,t) {


    var helperPoints = [];
 
     for (var i = 1; i < 4; i++) {
     var p = this.lerp(pointDataArr[i - 1], pointDataArr[i], t);
     helperPoints.push(p);
     }
 
     helperPoints.push(this.lerp(helperPoints[0], helperPoints[1], t));
     helperPoints.push(this.lerp(helperPoints[1], helperPoints[2], t));
 
 
     helperPoints.push(this.lerp(helperPoints[3], helperPoints[4], t));
 
     let firstBezier = [
     pointDataArr[0],
     helperPoints[0],
     helperPoints[3],
     helperPoints[5]
     ];
     let secondBezier = [
     helperPoints[5],
     helperPoints[4],
     helperPoints[2],
     pointDataArr[3]
     ];
 
     // returns 2 array of points for the new bezier curves;
     return [firstBezier, secondBezier];
   }
 
   lerp(A, B, t) {
 
     return [
     (Number(B[0]) - Number(A[0])) * t + Number(A[0]), // the x coordinate;
     (Number(B[1]) - Number(A[1])) * t + Number(A[1])  // the y coordinate;
     ];
     
   }
   sfix(arr){
     var num1=Number(arr[0]);
     var num2=Number(arr[1]);
     num1 = num1 < 0 ? Math.floor(Math.abs(num1) * 100) * -1 / 100 : num1.toFixed(2);
     num2 = num2 < 0 ? Math.floor(Math.abs(num2) * 100) * -1 / 100 : num2.toFixed(2);
     return num1+","+num2
   }

sFix2(num1,num2){
  num1=Number(num1);
  num2=Number(num2);
  num1 = num1 < 0 ? Math.floor(Math.abs(num1) * 100) * -1 / 100 : num1.toFixed(2);
  num2 = num2 < 0 ? Math.floor(Math.abs(num2) * 100) * -1 / 100 : num2.toFixed(2);
  return num1+","+num2
}

  loadSVGData(srcVal, fromExpression, newAnimData, isSwap, isAnimDataDifferent)
  {
    if (document.getElementById(this.props.data_id) && !this.props.isPlay && document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0] && this.props.assetType !== "PROP" && this.props.assetType !== "UPLOADS" && this.props.assetType !== "SCREEN")
    {
      document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "flex";
      if(document.getElementById(this.props.data_id + "inner"))
      document.getElementById(this.props.data_id + "inner").style.display = "none";
    }
    else if (document.getElementById(this.props.data_id) && !this.props.isPlay && document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0] && isSwap){
      document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "flex";
      if(document.getElementById(this.props.data_id + "inner"))
        document.getElementById(this.props.data_id + "inner").style.display = "none";
    }
    if (this.currentExpressionType === "CCHR" || this.currentExpressionType === "CHR") {
      const [src, extension] = /[^/]*$/.exec(srcVal)[0].split('.');
      srcVal = srcVal.replace(/\/[^\/]*$/, `/${src}-${this.currentExpression}.${extension}`);
    }  

    if (this.cancelSrc)
      this.cancelSrc();
    axios({
      method: 'GET',
      url: srcVal,
      mode: 'cors',
      withCredentials: false,
      credentials: 'same-origin',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'image/svg+xml'
      },
      data: {},
      cancelToken: new this.cancelSrcToken(function executor(c) {
        this.cancelSrc = c;
      }.bind(this))
    }).then(function (res)
    {
      let svgEle = '';
      if(this.props.uploadSVG){
        let tempEle = document.createElement('div');
        tempEle.innerHTML = res.data;
        svgEle = tempEle.children[0];
      }else{
        svgEle = res.request.responseXML.documentElement;
      }
      
      this.svgData = [];
      if(this.props.colors) {
          this.setColors(this.props.colors, svgEle);
      }
  
        var setClass = 'scene-item-inner';
        if (this.props.isBG) {
          setClass = '';
        }
        else if (this.props.isKeyframe) {
          setClass = 'keyframe-item-inner';
        }

        for (var i = 0; i < svgEle.getElementsByTagName("mask").length; i++) {
          let random = Math.random().toString(12).substr(0, 10).replace(".", "") + (new Date().getTime()).toString()
          let masks = svgEle.querySelectorAll("[mask=\"url(#" + svgEle.getElementsByTagName("mask")[i].id + ")\"]");
          for (var m = 0; m < masks.length; m++) {
            masks[m].setAttribute("mask", "url(#" + random + ")")
          }
          svgEle.getElementsByTagName("mask")[i].id = random
        }
        for (var i = 0; i < svgEle.getElementsByTagName("filter").length; i++) {
          let random = Math.random().toString(12).substr(0, 10).replace(".", "") + (new Date().getTime()).toString()
          let filters = svgEle.querySelectorAll("[filter=\"url(#" + svgEle.getElementsByTagName("filter")[i].id + ")\"]");
          for (var f = 0; f < filters.length; f++) {
            filters[f].setAttribute("filter", "url(#" + random + ")")
          }
          svgEle.getElementsByTagName("filter")[i].id = random
        }

        for (var i = 0; i < svgEle.getElementsByTagName("clipPath").length; i++) {
          let random = Math.random().toString(12).substr(0, 10).replace(".", "") + (new Date().getTime()).toString();
          let clips = svgEle.querySelectorAll("[clip-path=\"url(#" + svgEle.getElementsByTagName("clipPath")[i].id + ")\"]");
          for (var c = 0; c < clips.length; c++) {
            clips[c].setAttribute("clip-path", "url(#" + random + ")")
          }
          svgEle.getElementsByTagName("clipPath")[i].id = random
        }
        for (var i = 0; i < svgEle.getElementsByTagName("linearGradient").length; i++) {
          let random = Math.random().toString(12).substr(0, 10).replace(".", "") + (new Date().getTime()).toString();
          let clips = svgEle.querySelectorAll("[fill=\"url(#" + svgEle.getElementsByTagName("linearGradient")[i].id + ")\"]");
          for (var c = 0; c < clips.length; c++) {
            clips[c].setAttribute("fill", "url(#" + random + ")")
          }
          svgEle.getElementsByTagName("linearGradient")[i].id = random
        }
        for (var i = 0; i < svgEle.getElementsByTagName("radialGradient").length; i++) {
          let random = Math.random().toString(12).substr(0, 10).replace(".", "") + (new Date().getTime()).toString();
          let clips = svgEle.querySelectorAll("[fill=\"url(#" + svgEle.getElementsByTagName("radialGradient")[i].id + ")\"]");
          for (var c = 0; c < clips.length; c++) {
            clips[c].setAttribute("fill", "url(#" + random + ")")
          }
          svgEle.getElementsByTagName("radialGradient")[i].id = random
        }
        let uses = svgEle.getElementsByTagName("use");
        for (var i = 0; i < uses.length; i++) {
          let random = "a" + Math.random().toString(12).substr(0, 10).replace(".", "") + (new Date().getTime()).toString();
          let hrefAttr = uses[i].getAttribute("xlink:href")
          let useTags = svgEle.querySelectorAll("[*|href='" + hrefAttr + "']");
          for (var j = 0; j < useTags.length; j++) {
            useTags[j].setAttribute("xlink:href", "#" + random)
          }
          let usePahts = svgEle.querySelectorAll(hrefAttr);
          for (var u = 0; u < usePahts.length; u++) {
            usePahts[u].setAttribute("id", random)
          }
        }
        this.svgData.push(<div key={this.props.data_id} className={setClass} id={this.props.data_id + "inner"} style={{ width: "100%", height: "100%", position: "absolute" }} data-id={this.props.data_id} dangerouslySetInnerHTML={{ __html:  svgEle.outerHTML}} />)
      this.setState({ svgElement: this.svgData }, function ()
      {
        if (this.props.assetType === "PROP" || this.props.assetType === "UPLOADS" || this.props.assetType === "SCREEN")
        {
          this.isPlaying = false;
          if (document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])
            document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "none";
          document.getElementById(this.props.data_id + "inner").style.display = "block";
          
          if (this.props.selectedItems.size === 1 && this.props.selectedItems.get(0) === this.props.data_id || this.props.isPlay || this.props.isPlayAll)
          {
            if (this.props.isAnimated)
              this.loadSVGAnimation(this.props.animdata);
            if(this.props.assetType === "SCREEN")
              this.loadSVGAnimation(this.props.animdata);
          }


          if(this.props.assetType === "PROP" && !this.props.isAnimated && (this.props.isPlayAll || this.props.isPlay))
          {
            window.totalArr = window.totalArr.filter(e => e !== this.props.data_id); 
            if(window.totalArr.length === 0)
              this.props.startPlay("workspace")              
          }

        }
       
          else if(!this.props.isPlay){          
           if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])
            document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "none";

          document.getElementById(this.props.data_id + "inner").style.display = "block";

          }

        if (this.props.assetSubType === "CHR") {
          var changeArr = ["EYEBROW", "EYE", "MOUTH"];
          changeArr.map(function (item, key) {
            this.changeExpression(item, this.currentExpression)
          }.bind(this))
          if(isAnimDataDifferent || (this.props.isPlay || this.props.isPlayAll)){
            this.loadSVGAnimation(this.props.animdata);
          }
        }

        if (this.props.assetSubType === "ANIMAL" || this.props.assetSubType === "ECHR") {
          if(isAnimDataDifferent || this.props.isPlay || this.props.isPlayAll){
            this.loadSVGAnimation(this.props.animdata);
          }
        }
         
          if(this.props.parts !== undefined)
          {
            this.partsCount = this.props.parts.size;
            this.partsLoadCount = 0;

            if(!this.props.isPlay){
              if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])
              document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "flex";

              document.getElementById(this.props.data_id + "inner").style.display = "none";

          }
          this.props.parts.map(function (item, key)
          {
            if (item !== "" && item !== "undefined")
            {
              this.loadParts(item, key, this.props.pose, this.props.expression);
            }
            else
            {
              this.partsLoadCount++;
              if(this.partsLoadCount === this.partsCount)
                this.loadSVGAnimation(this.props.animdata);
            }
          }.bind(this))
        }
      });
    }.bind(this)).catch(function (error)
    {
     if(!axios.isCancel(error)) {
      errorlog("failed to load", error, "WorkspaceComponent-loadSVGData");
     }
    });
  }

  loadParts(partData, part, pose, expression)
  {
   if(part.toLowerCase() === "mouth"){
     const[src,extension] = partData.split('.')
     var urlSrc = this.assetUrl+config["CCHR"]["part_src"] + pose + "/" + part.toLowerCase() + "/" +`${src}-${expression}.${extension}`;
   }else{
    var urlSrc = this.assetUrl+config["CCHR"]["part_src"] + pose + "/" + part.toLowerCase() + "/" +partData;
   }
    axios({
      method: 'GET',
      url: urlSrc,
      mode: 'cors',
      withCredentials: false,
      credentials: 'same-origin',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'image/svg+xml'
      },
      data: {},
    }).then(function (res)
    {
      let parsedHtml = this.DomParser.parseFromString(res.request.responseText, "text/xml").firstChild;
      this.clearTimeLineMax();
      this.changePartHandler(parsedHtml, part, expression);

      this.partsLoadCount++
      if (this.partsLoadCount === this.partsCount)
      {
        if (this.props.selectedItems.size === 1 && this.props.selectedItems.get(0) === this.props.data_id || this.props.isPlay || this.props.isPlayAll)
        {
          if (this.props.assetType !== "PROP" && this.props.assetType !== "UPLOADS" && this.props.assetType !== "SCREEN" && this.props.assetType !== "SHAPE")
          {
            this.loadSVGAnimation(this.props.animdata);
          }
        }

       

        
          this.setColors(this.props.colors, document.getElementById(this.props.data_id).getElementsByTagName("svg")[0]);
          
          if (!this.props.isPlay){
            if(document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0])
            document.getElementById(this.props.data_id).getElementsByClassName("loaderElement")[0].style.display = "none";

            document.getElementById(this.props.data_id + "inner").style.display = "block";

        }

      }
    }.bind(this)).catch(function (error)
    {
      errorlog(error, error.message, "WorkspaceComponent-loadParts");

    });
  }

  changePartHandler(svgText, partName, expression) {
    if (expression === undefined || expression === "normal")
      expression = ""

    var curPart;
    var currentPart = partName.toLowerCase()


    if (currentPart === "hair")
      curPart = ["middlehairMc", "backhairMc", "tophairMc", "backfronthairMc"];
    else if (currentPart === "facehair")
      curPart = ["mustacheMc", "beardMc"];
    else if (currentPart === "shoe")
      curPart = ["rshoeMc", "lshoeMc","rsocksMc","lsocksMc","lshoetopMc","rshoetopMc" ];
    else if (currentPart === "nose")
      curPart = ["noseMc"];
    else if (currentPart === "ear")
      curPart = ["learMc", "rearMc"];
    else if (currentPart === "face")
      curPart = ["faceMc", "chinMc"];
    else if (currentPart === "mouth")
      curPart = ["mouthMc", "mouthMcbored", "mouthMchypnotism", "mouthMcconfident", "mouthMcrelaxed", "mouthMcfear", "mouthMctough", "mouthMcevil", "mouthMcthoughtful", "mouthMcsleepy", "mouthMcshocking", "mouthMcexcited", "mouthMcconfused", "mouthMcangry", "mouthMcsad", "mouthMchappy", "animmouthMcevil", "animmouthMcexcited", "animmouthMcshocking", "animmouthMcconfused", "animmouthMcangry", "animmouthMcsad", "animmouthMchappy", "animmouthMc", "actmouthMc1", "actmouthMc2", "actmouthMc3", "actmouthMc4", "actmouthMc5", "actmouthMc6", "actmouthMc7", "actmouthMc8", , "actmouthMc9", "actmouthMc10", "actmouthMc11", "actmouthMc12", "actmouthMc13", "actmouthMc14"];
    else if (currentPart === "watch")
      curPart = ["watchMc"];
    else if (currentPart === "mask")
      curPart = ["maskMc"];
    else if (currentPart === "cap")
      curPart = ["capMc", "backcapMc", "hathairMc"];
    else if (currentPart === "wband")
      curPart = ["wristbandMc"];
    else if (currentPart === "headphone")
      curPart = ["headphoneMc"];
    else if (currentPart === "glass")
      curPart = ["glassMc"];
    else if (currentPart === "neckwear")
      curPart = ["mufflertopMc", "mufflerbottomMc"];
    else if (currentPart === "jewel")
      curPart = ["chainMc"];
    else if (currentPart === "tattoo")
      curPart = ["rtattooMc", "ltattooMc"];
    else if (currentPart === "cheekline")
      curPart = ["cheeklinesMc"];
    else if (currentPart === "foreheadline")
      curPart = ["foreheadlinesMc"];
    else if (currentPart === "eyeline")
      curPart = ["eyelinesMc"];
    else if (currentPart === "freckle")
      curPart = ["frecklesMc"];
    else if (currentPart === "earring")
      curPart = ["rearringMc", "learringMc"];
    else if (currentPart === "eyebrow")
      curPart = ["leyebrowMc", "leyebrowMchappy", "leyebrowMcsad", "leyebrowMcangry", "leyebrowMcexcited", "leyebrowMcfrustration", "leyebrowMcconfused", "leyebrowMcthoughtful", "leyebrowMcbored", "leyebrowMcevil", "leyebrowMcconfident", "leyebrowMctough", "leyebrowMcworried", "leyebrowMcdisappointed", "leyebrowMcshocking", "leyebrowMcrelaxed", "leyebrowMcsleepy", "leyebrowMclove", "leyebrowMchypnotism", "leyebrowMcfear", "leyebrowMcsurprise", "reyebrowMc", "reyebrowMchappy", "reyebrowMcsad", "reyebrowMcangry", "reyebrowMcexcited", "reyebrowMcfrustration", "reyebrowMcconfused", "reyebrowMcthoughtful", "reyebrowMcbored", "reyebrowMcevil", "reyebrowMcconfident", "reyebrowMctough", "reyebrowMcworried", "reyebrowMcdisappointed", "reyebrowMcshocking", "reyebrowMcrelaxed", "reyebrowMcsleepy", "reyebrowMclove", "reyebrowMchypnotism", "reyebrowMcfear", "reyebrowMcsurprise"];
    else if (currentPart === "eye")
      curPart = ["reyeMc", "reyeMchappy", "reyeMcsad", "reyeMcangry", "reyeMcexcited", "reyeMcfrustration", "reyeMcconfused", "reyeMcthoughtful", "reyeMcbored", "reyeMcevil", "reyeMcconfident", "reyeMctough", "reyeMcworried", "reyeMcdisappointed", "reyeMcshocking", "reyeMcrelaxed", "reyeMcsleepy", "reyeMclove", "reyeMchypnotism", "reyeMcfear", "reyeMcsurprise", "leyeMc", "leyeMchappy", "leyeMcsad", "leyeMcangry", "leyeMcexcited", "leyeMcfrustration", "leyeMcconfused", "leyeMcthoughtful", "leyeMcbored", "leyeMcevil", "leyeMcconfident", "leyeMctough", "leyeMcworried", "leyeMcdisappointed", "leyeMcshocking", "leyeMcrelaxed", "leyeMcsleepy", "leyeMclove", "leyeMchypnotism", "leyeMcfear", "leyeMcsurprise"];


    if (currentPart === "facehair" || currentPart === "tattoo" || currentPart === "earring" || currentPart === "mouth" || currentPart === "shoe" || currentPart === "neckwear" || currentPart === "hair" || currentPart === "face" || currentPart === "cap" || currentPart === "eyebrow" || currentPart === "eye" || currentPart === "ear") {

      for (let val of curPart) {
        let svgVal = val

        if (document.getElementById(this.props.data_id).getElementsByClassName(val)[0]) {
          if (svgText.getElementsByClassName(svgVal).length === 0) {
            document.getElementById(this.props.data_id).getElementsByClassName(val)[0].innerHTML = "";
            if (currentPart === "hat")
              document.getElementById(this.props.data_id).getElementsByClassName("tophairMc")[0].setAttribute("opacity", "1")

          }
          else {
            let svgData = svgText;
            if (currentPart === "eye") {
              for (let i = 0; i < document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children.length; i++) {
                if (document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal.indexOf("eyeglow") > -1 || document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal.indexOf("eyepupil") > -1) {
                  if (svgData.getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal)[0]) {
                    svgData.getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal)[0].parentNode.replaceChild(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i], svgData.getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(val)[0].children[i].className.animVal)[0])
                    i--
                  }
                }
              }
            }
            document.getElementById(this.props.data_id).getElementsByClassName(val)[0].innerHTML = svgData.getElementsByClassName(svgVal)[0].innerHTML

            if (currentPart === "hat")
              document.getElementById(this.props.data_id).getElementsByClassName("tophairMc")[0].setAttribute("opacity", "0")
            if (currentPart === "mouth" && this.props.expFlag != "1" && this.props.expFlag != "2") 
            {

              if (expression === "frustration")
                expression = "angry"
              else if (expression === "love" || expression === "surprise")
                expression = "excited"
              else if (expression === "worried" || expression === "disappointed")
                expression = "sad"

              document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity", "0")
              if (document.getElementById(this.props.data_id).getElementsByClassName("mouthMc" + expression)[0]) 
              {
                document.getElementById(this.props.data_id).getElementsByClassName("mouthMc" + expression)[0].setAttribute("opacity", "1")
                document.getElementById(this.props.data_id).getElementsByClassName("mouthMc" + expression)[0].style.display = "block"
              }
              else 
              {
              if(this.props.expFlag!="1" && this.props.expFlag!="2" && this.props.expFlag!=undefined){
                document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].setAttribute("opacity", "1")
                document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].style.display = "block"
              }
            }
          }
            else if (currentPart === "mouth" && (this.props.expFlag == "1" || this.props.expFlag == "2")) 
            {
              document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity", "0")
              document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].setAttribute("opacity", "1")
              document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].style.display = "block"

            }

            if (currentPart === "eyebrow") 
            {
              document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity", "0")
              if (document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc" + expression)[0])
                document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc" + expression)[0].setAttribute("opacity", "1")
              document.getElementById(this.props.data_id).getElementsByClassName("reyebrowMc" + expression)[0].setAttribute("opacity", "1")
            }
            else if (currentPart === "eye") 
            {
              document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity", "0")

              document.getElementById(this.props.data_id).getElementsByClassName("reyeMc" + expression)[0].setAttribute("opacity", "1")
              if (document.getElementById(this.props.data_id).getElementsByClassName("leyeMc" + expression)[0])
                document.getElementById(this.props.data_id).getElementsByClassName("leyeMc" + expression)[0].setAttribute("opacity", "1")
            }
            svgData = null;
          }
        }
      }
    }
    else if (currentPart !== "topwear" && currentPart !== "bottomwear") 
    {
      if (document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0] === undefined) {
        if (currentPart === "mustache" || currentPart === "beard" || currentPart === "glass") {
        {
          document.getElementById(this.props.data_id).getElementsByClassName("faceMc")[0].appendChild(svgText.getElementsByClassName(curPart)[0]);
        }

        }
      }
      else if (svgText.getElementsByClassName(curPart).length === 0) 
      {
        document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0].innerHTML = "";
      }
      else 
      {
        document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0].parentNode.replaceChild(svgText.getElementsByClassName(curPart)[0], document.getElementById(this.props.data_id).getElementsByClassName(curPart)[0]);
      }
    }
    else if (currentPart === "bottomwear") 
    {
      var pantArr = ["hipwearshape1", "hipwearshape2", "hipwearshape3", "hipwearshape4", "hipwearshape5", "hipwearshape6", "hipwearshape7", "hipwearshape8", "hipwearshape9", "hipwearshape10", "hipwearshape11", "hipwearshape12", "hipwearshape13", "hipwearshape14", "hipwearshape15", "hipwearshape16", "hipwearshape17", "hipwearshape18", "hipwearshape19", "hipwearshape20", "hipwearshape21", "hipwearshape22", "hipwearshape23", "hipwearshape24", "hipwearshape25", "hipwearshape26", "hipwearshape27", "hipwearshape28", "hipwearshape29", "hipwearshape30", "hipwearshape31", "hipChildMc", "rlowerlegChildMc", "llowerlegChildMc", "rupperlegChildMc", "lupperlegChildMc", "tophipMc"]
      var pantObj = {}
      for (var n = 0; n < pantArr.length; n++) 
      {
        if (document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0] !== undefined) 
        {
          for (var j = 0; j < document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes.length; j++) {
            if (!document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal.includes("skin")) {
              if (document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal.includes("Mc"))
                pantObj[document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal] = document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal)[0].innerHTML
              document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal)[0].parentNode.removeChild(document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].childNodes[j].className.baseVal)[0]);

              j = j - 1;
            }
          }
        }
      }
      for (var n = 0; n < pantArr.length; n++) 
      {
        if (svgText.getElementsByClassName(pantArr[n])[0] !== undefined) 
        {
          for (var m = 0; m < svgText.getElementsByClassName(pantArr[n])[0].childNodes.length; m++) 
          {
            if (!svgText.getElementsByClassName(pantArr[n])[0].childNodes[m].className.baseVal.includes("skin")) 
            {
              if (document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n]).length > 0) 
              {
                document.getElementById(this.props.data_id).getElementsByClassName(pantArr[n])[0].appendChild(svgText.getElementsByClassName(pantArr[n])[0].childNodes[m]);
                m = m - 1;
              }
            }
          }
        }
      }
      for (var key in pantObj) 
      {
        if (!key.includes("regpivot") && document.getElementById(this.props.data_id).getElementsByClassName(key)[0])
          document.getElementById(this.props.data_id).getElementsByClassName(key)[0].innerHTML = pantObj[key];
      }
      pantObj = {};
    }
    else if (currentPart === "topwear") 
    {
      var shirtArr = ["bodyChildMc", "lupperarmChildMc", "rupperarmChildMc", "rlowerarmChildMc", "llowerarmChildMc"]
      let shirtObj = {}
      let domParser = svgText
      for (var n = 0; n < shirtArr.length; n++) 
      {
        for (var j = 0; j < document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes.length; j++) 
        {
          if (!document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal.includes("skin")) {
            if (document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal.includes("Mc")) {
              shirtObj[document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal] = document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal)[0].innerHTML
            }
            document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal)[0].parentNode.removeChild(document.getElementById(this.props.data_id).getElementsByClassName(document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].childNodes[j].className.baseVal)[0]);
            j = j - 1;
          }
        }
      }
      for (let n = 0; n < shirtArr.length; n++) {
        if (domParser.getElementsByClassName(shirtArr[n]).length > 0) 
        {
          for (let m = 0; m < domParser.getElementsByClassName(shirtArr[n])[0].childNodes.length; m++) 
          {
            if (!domParser.getElementsByClassName(shirtArr[n])[0].childNodes[m].className.baseVal.includes("skin")) {
              document.getElementById(this.props.data_id).getElementsByClassName(shirtArr[n])[0].appendChild(domParser.getElementsByClassName(shirtArr[n])[0].childNodes[m]);
              m = m - 1;
            }
          }

        }
      }

      for (let key in shirtObj) {
        if (!key.includes("regpivot") && document.getElementById(this.props.data_id).getElementsByClassName(key)[0]) 
          document.getElementById(this.props.data_id).getElementsByClassName(key)[0].innerHTML = shirtObj[key];
        shirtObj[key] = {}
      }
      shirtObj = {};
      domParser = {}
    }
  }

    isBetween(n, a, b) {
      return (n - a) * (n - b) <= 0
   }

  wait(ms) {
    var d = new Date();
    var d2 = null;
    do { d2 = new Date(); }
    while (d2 - d < ms);
  }


  assignTweenValues(res, isLipsync, easeCount){
    const prefetchFlag = isLipsync;
    const prefetchToken = this.props.prefetchToken;
    this.isPlaying = true;
    this.isLoaded = true;
    var parent = {"essentials": res.data.essentials}
    var animateValues = res.data.animateValues;
    var originalValues = {}

    for (var child in parent.essentials) {
      var thisName = child;
      originalValues[child] = {
        "positionX": parent.essentials[thisName].p.split(",")[0], "positionY": parent.essentials[thisName].p.split(",")[1],
      }

    }

    var isRepeated = (this.props.isRepeated === "0") ? 0 : -1;
    if (!this.props.isRepeated)
      isRepeated = -1
    if(this.props.assetType === "PROP" && this.props.isAnimated)
      isRepeated = this.props.repeatLoop -1;

    if (!isLipsync)
      this.t1 = new TimelineMax({ repeat: isRepeated, repeatDelay: 0, yoyo: false, paused: true });
    var easeVal = Linear.easeNone
    var characterAnimateVal = []
    var mouthAnimateVal = []
    if(!easeCount)
      var easeCount = 0;
    var currentEase = {};

      for (var idVal in animateValues) 
      {
        for(var valueData of animateValues[idVal])
        {
        if (valueData.isLipsync !== undefined)
        {
          if (valueData.isLipsync)
            isLipsync = true;
          else
            isLipsync = false
        }

        if (valueData.a === "P")
        {
          let bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined)
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount
              currentEase[valueData.e] = bezValues;
              easeCount++
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }

          var posXval = valueData.v.split(",")[0];
          var posYval = valueData.v.split(",")[1], hipMCPosition;

          if (posXval < 0)
            posXval = "-=" + Math.abs(posXval)
          else
            posXval = "+=" + Math.abs(posXval)

          if (posYval < 0)
            posYval = "-=" + Math.abs(posYval)
          else
            posYval = "+=" + Math.abs(posYval)

          if (document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0])
            if (document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild) {
              if (idVal === "hipMc" || idVal === "skateboardMc") {
                if (!hipMCPosition) {
                  hipMCPosition = { x: parseFloat(originalValues[idVal].positionX), y: parseFloat(originalValues[idVal].positionY) }
                }
                else {
                  hipMCPosition.x += parseFloat(valueData.p.split(",")[0]);
                  hipMCPosition.y += parseFloat(valueData.p.split(",")[1]);
                }
                this.t1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], valueData.d, {
                  immediateRender: false, y: posYval, x: posXval, svgOrigin: hipMCPosition.x + 'px ' + hipMCPosition.y + 'px', ease: bezValues
                }, valueData.t);
                characterAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration: valueData.d, toVal: { y: posYval, x: posXval, svgOrigin: hipMCPosition.x + 'px ' + hipMCPosition.y + 'px', ease: bezValues, immediateRender: false }, time: valueData.t })

              }
              else if (isLipsync) {
                this.mouthT1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], valueData.d, {
                  immediateRender: false, y: posYval, x: posXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues, onComplete: function () {
                  }
                }, valueData.t);
                mouthAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration: valueData.d, toVal: { y: posYval, x: posXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues, immediateRender: false }, time: valueData.t })
              }
              else {
                this.t1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], valueData.d, {
                  immediateRender: false, y: posYval, x: posXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues, onComplete: function () {
                  }
                }, valueData.t);
                characterAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration: valueData.d, toVal: { y: posYval, x: posXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues, immediateRender: false }, time: valueData.t })

              }
            }

        }

        if (valueData.a === "O") {
          var bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined)
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount;
              easeCount++;
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }
          var opacity = valueData.v / 100;
          if(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0])
          {

            if (isLipsync) {
              this.mouthT1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], 0.001, { immediateRender: false, opacity: opacity, ease: Linear.easeNone }, valueData.t + (valueData.d / 2));
              mouthAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration: 0.001, toVal: { immediateRender: false, opacity: opacity, ease: Linear.easeNone }, time: valueData.t + (valueData.d / 2) })
            }
            else
            {
              this.t1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], 0.001, { immediateRender: false, opacity: opacity, ease: Linear.easeNone }, valueData.t + (valueData.d / 2));
              characterAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration: 0.001, toVal: { immediateRender: false, opacity: opacity, ease: Linear.easeNone }, time: valueData.t + (valueData.d / 2) })
            }
          }
        }

        if (valueData.a === "S") {

          var bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined)
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount
              easeCount++
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }
          var scaleXval = valueData.v.split(",")[0] / 100;
          var scaleYval = valueData.v.split(",")[1] / 100;

          if (document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0])
          {
            if (isLipsync) {
              this.mouthT1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], valueData.d, { scaleY: scaleYval, scaleX: scaleXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, valueData.t);

              mouthAnimateVal.push({domVal : document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration : valueData.d, toVal : { scaleY: scaleYval, scaleX: scaleXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, time : valueData.t})
            }
            else
            {
              this.t1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], valueData.d, { scaleY: scaleYval, scaleX: scaleXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, valueData.t);

              characterAnimateVal.push({domVal : document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration : valueData.d, toVal : {immediateRender:false, scaleY: scaleYval, scaleX: scaleXval, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, time : valueData.t})
            }
          }

        }

        if (valueData.a === "R") {
          var bezValues;
          if (valueData.e === "no Ease") {
            bezValues = easeVal;
          }
          else {
            if(currentEase[valueData.e] === undefined) 
            {
              bezValues = valueData.e.split("[")[1].split("]")[0].split(",")
              CustomEase.create("easeName" + easeCount, "\"" + bezValues[0] + "," + bezValues[1] + "," + bezValues[2] + "," + bezValues[3] + "\"")
              this.overAllBenzValues.push("easeName" + easeCount);
              bezValues = "easeName" + easeCount;
              easeCount++;
            }
            else
            {
              bezValues = currentEase[valueData.e]
            }
          }
          var rotateVal = "";
          if (valueData.v < 0) {
            rotateVal = "-=" + Math.abs(valueData.v)
          }
          else {
            rotateVal = "+=" + Math.abs(valueData.v)
          }


          if (idVal === "hipMc" || idVal === "skateboardMc") {
            if (!hipMCPosition) {
              hipMCPosition = { x: parseFloat(originalValues[idVal].positionX), y: parseFloat(originalValues[idVal].positionY) }
            }
            else {
              hipMCPosition.x += parseFloat(valueData.p.split(",")[0]);
              hipMCPosition.y += parseFloat(valueData.p.split(",")[1]);
            }
            if (document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0]) {
              this.t1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], valueData.d, { rotation: rotateVal, svgOrigin: hipMCPosition.x + 'px ' + hipMCPosition.y + 'px', ease: bezValues }, valueData.t);
              characterAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration: valueData.d, toVal: { immediateRender: false, rotation: rotateVal, svgOrigin: hipMCPosition.x + 'px ' + hipMCPosition.y + 'px', ease: bezValues }, time: valueData.t })
            }
          }
          else {
            if (document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0]) {
              this.t1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], valueData.d, { immediateRender: false, rotation: rotateVal, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, valueData.t);
              characterAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0], duration: valueData.d, toVal: { immediateRender: false, rotation: rotateVal, svgOrigin: parseFloat(originalValues[idVal].positionX) + 'px ' + parseFloat(originalValues[idVal].positionY) + 'px', ease: bezValues }, time: valueData.t })
            }
          }
        }

        if (valueData.a === "PA") {
          if(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0]!= undefined && document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild !== undefined) 
          {
            this.t1.to(document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild, valueData.d, { attr: { d: valueData.v } }, Math.abs(valueData.t));
            characterAnimateVal.push({ domVal: document.getElementById(this.props.data_id + "inner").firstElementChild.getElementsByClassName(idVal)[0].firstChild, duration: valueData.d, toVal: { immediateRender: false, attr: { d: valueData.v } }, time: Math.abs(valueData.t) })
          }
        }
      }
    }

    currentEase = {}


    var firsttrack = "";
    if (this.props.isPlay || this.props.isPlayAll) {
      var voiceArr = [];
      var lipSyncStartArr = [];
      var lipSyncEndArr = [];
      var playStartArr = [];
      var voiceData = "";
      var lipSyncStart = 0;
      var playStart = 0;
      var lipSyncEnd = 0;
      
      


      var startTimeVal = this.props.completeWorkspaceItems.get('enterStart')
      if(this.props.isPlayAll && this.props.assetType !== "SCREEN")
        startTimeVal = this.props.scenStart + startTimeVal;

      var endTimeVal = this.props.completeWorkspaceItems.get('exitEnd')
      if(this.props.isPlayAll && this.props.assetType !== "SCREEN")
        endTimeVal = this.props.scenStart + endTimeVal;


      this.props.addTween({ type: this.props.assetType, isRepeated: this.props.isRepeated, isAnimated:this.props.isAnimated, repeatLoop:this.props.repeatLoop, timeline: characterAnimateVal, mouthValues: mouthAnimateVal, voiceData: voiceArr, startTime: startTimeVal, endTime: endTimeVal, idVal: this.props.data_id, lipSyncStart: lipSyncStartArr, lipSyncEnd: lipSyncEndArr, playStart: playStartArr, from: "workspace" }, "addchartween");

      window.totalArr = window.totalArr.filter(e => e !== this.props.data_id); 
      if(window.totalArr.length === 0)
      this.props.startPlay("workspace")
    }
    else 
    {
      if(this.props.assetType !== "CHR") 
      {
        this.t1.play();
      }
      // else if(isLipsync && this.props.assetType === "CHR") 
      // {
      //   this.t1.play();
      // }
    }

    //Clearing the objects due to the memeory leak
    characterAnimateVal = {}
    mouthAnimateVal = {}
    originalValues = {}
    animateValues = {}

    return easeCount;

  }

  loadSVGAnimation(animdataVal) 
  {
    if (!this.isPlaying) {
      let projectType = this.props.workspaceWidth > this.props.workspaceHeight?"horizontal":this.props.workspaceHeight > this.props.workspaceWidth?"vertical":"square";
      let url = this.assetUrl+config[this.props.assetType].animdata + animdataVal;

      if(this.props.assetSubType === "CCHR" || this.props.assetSubType === "ECHR" || this.props.assetSubType === 'EPROP')
        url =this.assetUrl+ config[this.props.assetSubType].animdata + animdataVal;
      else if(this.props.assetType === 'SCREEN'){
        url = this.assetUrl + config[this.props.assetType].animdata + projectType+'/' + animdataVal;
      }
      if (this.props.assetSubType === "CCHR" || this.props.assetSubType === "CHR") {
        const [src, extension] = animdataVal.split('.');
        url = this.assetUrl + config[this.props.assetSubType].animdata + `${src}-${this.props.expression}.${extension}`;
      }
      axios({
        method: 'GET',
        url: url,
        mode: 'cors',
        withCredentials: false,
        credentials: 'same-origin',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'image/svg+xml',
          'Accept': 'application/json',
        },
        data: {},
      }).then(function (res) {
        var easeCount = this.assignTweenValues(res, false)

        if (this.props.assetType !== "PROP" && this.props.assetType !== "UPLOADS" && this.props.assetType !== "SCREEN" && this.props.assetSubType !== "CHR" && this.props.assetSubType !== "ECHR") {
          var urlSrc;
          if (this.props.assetSubType === "CHR")
          urlSrc = this.assetUrl +config["CCHR"]["part_src"] + this.props.pose + "/mouth/m01-mouth-001.json";
          else
          urlSrc = this.assetUrl+config["CCHR"]["part_src"] + this.props.pose + "/mouth/" + this.props.parts.get("MOUTH").split(".")[0] +`-${this.props.expression}`+ ".json";
          axios({
            method: 'GET',
            url: urlSrc,
            mode: 'cors',
            withCredentials: false,
            credentials: 'same-origin',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'image/svg+xml',
              'Accept': 'application/json',
            },
            data: {},
          }).then(function (res) {
            this.assignTweenValues(res, true,easeCount)
          }.bind(this)
          ).catch(function (error) {
            errorlog("failed to load", error, "WorkspaceComponent-loadSVGAnimation");
          }.bind(this));
        }

      }.bind(this)
      )
        .catch(function (error) {
          errorlog("failed to load", error, "WorkspaceComponent-loadSVGAnimation");
        }.bind(this));
    }
  }

  changeExpression(partName, expression)
  {
    var currentPart = partName.toLowerCase(), curPart

    if (expression === undefined || expression === "normal")
      expression = ""

    if (currentPart === "mouth")
      curPart = ["mouthMc","mouthMcbored","mouthMchypnotism","mouthMcconfident","mouthMcrelaxed","mouthMcfear","mouthMctough","mouthMcevil","mouthMcthoughtful","mouthMcsleepy","mouthMcshocking","mouthMcexcited","mouthMcconfused","mouthMcangry","mouthMcsad","mouthMchappy","animmouthMcevil","animmouthMcexcited","animmouthMcshocking","animmouthMcconfused","animmouthMcangry","animmouthMcsad","animmouthMchappy","animmouthMc","actmouthMc1","actmouthMc2","actmouthMc3","actmouthMc4","actmouthMc5","actmouthMc6","actmouthMc7","actmouthMc8",,"actmouthMc9","actmouthMc10","actmouthMc11","actmouthMc12","actmouthMc13","actmouthMc14"];
    else if (currentPart === "eyebrow")
      curPart = ["leyebrowMc","leyebrowMchappy","leyebrowMcsad","leyebrowMcangry","leyebrowMcexcited","leyebrowMcfrustration","leyebrowMcconfused","leyebrowMcthoughtful","leyebrowMcbored","leyebrowMcevil","leyebrowMcconfident","leyebrowMctough","leyebrowMcworried","leyebrowMcdisappointed","leyebrowMcshocking","leyebrowMcrelaxed","leyebrowMcsleepy","leyebrowMclove","leyebrowMchypnotism","leyebrowMcfear","leyebrowMcsurprise","reyebrowMc","reyebrowMchappy","reyebrowMcsad","reyebrowMcangry","reyebrowMcexcited","reyebrowMcfrustration","reyebrowMcconfused","reyebrowMcthoughtful","reyebrowMcbored","reyebrowMcevil","reyebrowMcconfident","reyebrowMctough","reyebrowMcworried","reyebrowMcdisappointed","reyebrowMcshocking","reyebrowMcrelaxed","reyebrowMcsleepy","reyebrowMclove","reyebrowMchypnotism","reyebrowMcfear","reyebrowMcsurprise"];
    else if (currentPart === "eye")
      curPart = ["reyeMc","reyeMchappy","reyeMcsad","reyeMcangry","reyeMcexcited","reyeMcfrustration","reyeMcconfused","reyeMcthoughtful","reyeMcbored","reyeMcevil","reyeMcconfident","reyeMctough","reyeMcworried","reyeMcdisappointed","reyeMcshocking","reyeMcrelaxed","reyeMcsleepy","reyeMclove","reyeMchypnotism","reyeMcfear","reyeMcsurprise","leyeMc","leyeMchappy","leyeMcsad","leyeMcangry","leyeMcexcited","leyeMcfrustration","leyeMcconfused","leyeMcthoughtful","leyeMcbored","leyeMcevil","leyeMcconfident","leyeMctough","leyeMcworried","leyeMcdisappointed","leyeMcshocking","leyeMcrelaxed","leyeMcsleepy","leyeMclove","leyeMchypnotism","leyeMcfear","leyeMcsurprise"];

    for (var val of curPart)
    {
      var svgVal = val
      var firstNode = document.getElementById(this.props.data_id).getElementsByClassName(val)[0];

      if (firstNode)
      {
        if (currentPart === "mouth" && this.props.expFlag != "1" && this.props.expFlag != "2")
        {

          if (expression === "frustration")
            expression = "angry"
          else if (expression === "love" || expression === "surprise")
            expression = "excited"
          else if (expression === "worried" || expression === "disappointed")
            expression = "sad"

          document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity", "0")
          if (document.getElementById(this.props.data_id).getElementsByClassName("mouthMc" + expression)[0])
          {
            document.getElementById(this.props.data_id).getElementsByClassName("mouthMc" + expression)[0].setAttribute("opacity", "1")
            document.getElementById(this.props.data_id).getElementsByClassName("mouthMc" + expression)[0].style.display = "block"
          }
          else
          {
            document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].setAttribute("opacity", "1")
            document.getElementById(this.props.data_id).getElementsByClassName("mouthMc")[0].style.display = "block"
          }
        }
        else if (currentPart === "mouth" && (this.props.expFlag == "1" || this.props.expFlag == "2"))
        {
          document.getElementById(this.props.data_id).getElementsByClassName(val)[0].setAttribute("opacity", "0")
          if(document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0])
          {
            document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].setAttribute("opacity", "1")
            document.getElementById(this.props.data_id).getElementsByClassName(this.props.mouthAction)[0].style.display = "block"
          }
        }
        if (currentPart === "eyebrow")
        {
          firstNode.setAttribute("opacity", "0")
          if (document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc" + expression)[0])
            document.getElementById(this.props.data_id).getElementsByClassName("leyebrowMc" + expression)[0].setAttribute("opacity", "1")
          document.getElementById(this.props.data_id).getElementsByClassName("reyebrowMc" + expression)[0].setAttribute("opacity", "1")
        }
        else if (currentPart === "eye")
        {
          firstNode.setAttribute("opacity", "0")

          document.getElementById(this.props.data_id).getElementsByClassName("reyeMc" + expression)[0].setAttribute("opacity", "1")
          if (document.getElementById(this.props.data_id).getElementsByClassName("leyeMc" + expression)[0])
            document.getElementById(this.props.data_id).getElementsByClassName("leyeMc" + expression)[0].setAttribute("opacity", "1")
        }
      }
    }
  }

  componentWillReceiveProps(nextProps)
  {
    if (this.props.decibelVal !== nextProps.decibelVal)
    {
      this.mouthT1.pause(nextProps.decibelVal);
    }

  if(nextProps.assetSubType !== "CCHR" && nextProps.assetSubType !== "CHR"){
    if (this.props.expression !== undefined && this.props.expression !== nextProps.expression && this.props.animdata === nextProps.animdata && (nextProps.swapDetails === null || nextProps.swapDetails === undefined)) 
    {

      var changeArr = ["EYEBROW", "EYE", "MOUTH"];
      changeArr.map(function (item, key)
      {
        this.changeExpression(item,nextProps.expression)
      }.bind(this))
    }
  }

    this.currentExpressionType = nextProps.assetSubType;
    this.currentExpression =  nextProps.expression;
    if ((this.props.animdata !== nextProps.animdata || this.props.expression !== nextProps.expression) && (nextProps.swapDetails === null || nextProps.swapDetails === undefined)) 
    {
      this.isPlaying = false;
      if (this.t1 !== null) 
      {
        this.clearTimeLineMax();
      }
      const isAnimDataDifferent = this.props.animdata !== nextProps.animdata;
      this.isLoaded = false;
      this.loadSVGData(nextProps.src, true, nextProps.animdata,null, isAnimDataDifferent);
    }

    if (this.props.isAnimated !== nextProps.isAnimated) 
    {
      this.isPlaying = false;
      if (this.t1 !== null) 
      {
        this.clearTimeLineMax();
      }
      if(nextProps.isAnimated)
      {
        this.isLoaded = false;
        this.loadSVGData(nextProps.animsrc, false);
      }
      else {
        this.isLoaded = false;
        this.loadSVGData(nextProps.src, false);
      }
    }

    

    if(nextProps.swapDetails !== undefined && nextProps.swapDetails !== null && nextProps.swapDetails.id === nextProps.data_id){
        this.isLoaded = false;
        this.clearTimeLineMax();
        this.loadSVGData(nextProps.src, false, undefined, true);
    }
    else if(this.props.colors !== undefined  && this.props.colors !== null && !this.props.colors.equals(nextProps.colors) && document.getElementById(nextProps.data_id).getElementsByTagName("svg")[0] !== null){
        this.setColors(nextProps.colors, document.getElementById(nextProps.data_id).getElementsByTagName("svg")[0]);
        // this.loadSVGData(nextProps.src, false);
    }  
    
  }

  componentDidUpdate(prevProps, prevState)
  {
    if (this.props.selectedItems.size === 1 && this.props.selectedItems.get(0) === this.props.data_id || this.props.isPlay || this.props.isPlayAll)
    {
      if (this.props.assetType !== "SHAPE" && this.props.assetType !== "UPLOADS" && this.props.assetType !== "PROP" && !this.props.isPlay && !this.props.isPlayAll)
      {
      }
      else if (this.props.assetType === "PROP" || this.props.assetType === "UPLOADS")
      {
        if (this.props.selectedItems.get(0) !== prevProps.selectedItems.get(0))
        {
          if(this.props.isAnimated)
          {
            this.isLoaded = false;
            this.loadSVGData(this.props.animsrc, false);
          }
          else
          {
            this.isLoaded = false;
            this.loadSVGData(this.props.src, false);
          }
        }
      }
    }
    else if (this.props.selectedItems.get(0) !== prevProps.selectedItems.get(0) && (this.props.assetType === "PROP" || this.props.assetType === "UPLOADS")){
          this.loadSVGData(this.props.src, false);
    }
    else
    {
      this.isPlaying = false;
      if (this.t1){
        this.t1.pause(0);
        this.clearTimeLineMax();
      }
    }
  }

  componentWillUnmount()
  {
    this.isPlaying = false;
    if (this.t1 !== null)
    {
      this.t1.kill();
      this.t1 = null;
    }
  }

  render()
  {
    var sourceThumb;
    if (this.props.assetType === "CHR")
      sourceThumb = this.assetUrl+config["CCHR"][config["CCHR"]["onload"]] + this.props.completeWorkspaceItems.getIn(["src"]).split(".")[0] + ".png";
    else if (this.props.assetType === "PROP"){
      sourceThumb = this.assetUrl+config[this.props.assetType ][config[this.props.assetType ]["onload"]] + this.props.completeWorkspaceItems.getIn(["src"]).split(".")[0] + ".png";
    }else if (this.props.assetType === "SHAPE"){
      let thumb = this.props.completeWorkspaceItems.getIn(["thumb"]);
      sourceThumb = this.assetUrl+config[this.props.assetType ][config[this.props.assetType ]["onload"]] + thumb;
    }
      

    if (!this.props.isPlay)
    {
      let itemStyle = { width: "inherit", height: "inherit", pointerEvents: "none"};
      if(this.props.assetType === "SHAPE")
        itemStyle.position = "absolute";

      if(this.props.link!==undefined&&this.props.link!==''&&(this.props.isPlayAll||this.props.mode==='slide')){
        itemStyle.pointerEvents='auto';
      }
      return (
        <div style={itemStyle}>
          {this.state.svgElement}
          <div data-html2canvas-ignore="true" className="loaderElement" style={{ width: "100%", height: "100%", position: "absolute" }}>
            {/* <img alt="loader" src={sourceThumb} style={{ width: "100%", objectFit: "scale-down" }} /> */}
            <img alt="loader" src={this.appUrl + "/images/chr-loading.svg"} style={{ width: "100%", objectFit: "scale-down" }} />
          </div>
        </div>
      )
    }
    else
      return (
        <React.Fragment>
          {this.state.svgElement}</React.Fragment>)
  }
}

function _iHSL10(str1, hue, sat, light) {
    var color1 = hex2rgb(str1)
    var hsl1 = rgb2hsl(color1);
    hsl1[0] = Number(hsl1[0]) - Number(hue);
    hsl1[1] = Number(hsl1[1]) - Number(sat);
    hsl1[2] = Number(hsl1[2]) - Number(light);
    hsl1[0] = (hsl1[0] > 1) ? 1 : hsl1[0]
    hsl1[1] = (hsl1[1] > 1) ? 1 : hsl1[1]
    hsl1[2] = (hsl1[2] > 1) ? 1 : hsl1[2]
    hsl1[0] = (hsl1[0] < 0) ? 0 : hsl1[0]
    hsl1[1] = (hsl1[1] < 0) ? 0 : hsl1[1]
    hsl1[2] = (hsl1[2] < 0) ? 0 : hsl1[2]
    var arr3 = hsl2rgb(hsl1)
    return rgb2hex(arr3[0], arr3[1], arr3[2]);
};

function hex2rgb(str) {
    var arr1 = [];
    arr1[0] = parseInt(str.substring(0, 2), 16);
    arr1[1] = parseInt(str.substring(2, 4), 16);
    arr1[2] = parseInt(str.substring(4, 6), 16);
    return arr1;
  }
  
  function rgb2hsl(color) {
    var r = color[0] / 255;
    var g = color[1] / 255;
    var b = color[2] / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max === min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        default: break;
      }
      h /= 6;
    }
    return [h, s, l];
  };
  
  function hsl2rgb(color) {
    var l = color[2];
  
    if (color[1] === 0) {
      l = Math.round(l * 255);
      return [l, l, l];
    } else {
      function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }
      var s = color[1];
      var q = (l < 0.5 ? l * (1 + s) : l + s - l * s);
      var p = 2 * l - q;
      var r = hue2rgb(p, q, color[0] + 1 / 3);
      var g = hue2rgb(p, q, color[0]);
      var b = hue2rgb(p, q, color[0] - 1 / 3);
      return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }
  };
  
  function rgb2hex(red, green, blue) {
    var rgb = blue | (green << 8) | (red << 16);
    return '#' + (0x1000000 + rgb).toString(16).slice(1)
  }

class WorkspaceGrid extends React.Component {
  render() {
    let gridStyle = this.props.styles;

    let cellWidth = this.props.width / this.props.cols;
    let cellHeight = this.props.height / this.props.rows;
    var grid = [];
    for (var i = 0; i < this.props.rows; i++) {
      var rows = [];
      for (var j = 0; j < this.props.cols; j++) {
        var cols = <div key={"columns"+i+j} className={"grid-cols" + (this.props.cols / 2 === j ? " middle-col" : "")} style={{ width: cellWidth + "px", height: cellHeight + "px" }}></div>;
        rows.push(cols);
      }
      grid.push(<div key={"rows"+i} className={"grid-rows" + (this.props.rows / 2 === i ? " middle-row" : "")}>{rows} </div>);
    }

    return (
      <div id="workspace-grid" style={gridStyle}>
        {grid}
      </div>
    );
  }
}

class WorkspaceComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {workspace : {}, worksheet:[{id:0, data:"First Thing"},{id:1,data:"Second Thing"},{id:2,data:"Third Thing"},{id:3,data:"Fourth Thing"},{id:4,data:"Fifth Thing"}],sceenPosition:1, addTransition:false, contextMenu : false,
          direction : '',
          items: [1],
          active: props.selectedScene,
          onWheelEnd : true,
          onclickAction :false,
          applyTransitions : false,
          animakerType : '',
          indicatorX : 0,
          timelineTime : 0,
          isZoomActive : false,
          isZoomDropped : false,
          isBgToolExpanded : false,
          blobPlaying : false,
          seekValue : 0,
          seekTime : null,
          seekX : null,
          videoControl : false,
          isFullScrVideoplay:false,
          //playButton :true
          autoPlay :false,
          bgToolActive : false
        }

        this.runTheLIst       = this.runTheLIst.bind(this);
        this.addTransition    = this.addTransition.bind(this);
        this.moveSelection    = this.moveSelection.bind(this);
        this.initiateResize   = this.initiateResize.bind(this);
        this.resizeSelection  = this.resizeSelection.bind(this);
        this.stopResize       = this.stopResize.bind(this);
        this.initiateRotate   = this.initiateRotate.bind(this);
        this.rotateSelection  = this.rotateSelection.bind(this);
        this.stopRotate       = this.stopRotate.bind(this);
        this.handleMouseDown  = this.handleMouseDown.bind(this);
        this.handleItemClick  = this.handleItemClick.bind(this);
        this.handleRightClick = this.handleRightClick.bind(this);
        this.toggleToolBar    = this.toggleToolBar.bind(this);
        this.mouseStartPosition = { x: null, y: null, width: null, height: null, offsetX: null, offsetY: null };
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.multimoveSelection = null;
        this.anchorAngles     = null;
        this.initiateMultiselect = this.initiateMultiselect.bind(this);
        this.multiselectByBounds  = this.multiselectByBounds.bind(this);
        this.selectingItems = this.selectingItems.bind(this);
        this.stopSelection = this.stopSelection.bind(this);
        this.handleBgDelete = this.handleBgDelete.bind(this);
        this.workspaceItemsAssembler = this.workspaceItemsAssembler.bind(this);
        this.zoomState    = "normal";
        this.imageEditIcon = [];
        this.defaultWidth   = 800;
        this.defaultHeight  = 450;
        this.tintOpacity = 0.1;
        this.isManuallyZoomed = false;
        this.cancelSwap = this.cancelSwap.bind(this);
        this.applySwap = this.applySwap.bind(this);
        this.delta = '';
        this.listenerStatus = true;
        this.scrollDirection = '';
        this.stopProcess = false;
        this.mouseUpTime = 0;
        this.mouseDownTime = 20;
        this.scrollOnce = 0; 
        this.scrollEnd = 0;
        this.currentTime = 0;
        this.fail = true;
        this.showResults = false;
        this.scrollType = '';
        this.workedClick = false;
        this.generateItems = this.generateItems.bind(this);
        this.moveRight = this.moveRight.bind(this);
        this.moveLeft = this.moveLeft.bind(this);
        this.setStates = this.setStates.bind(this);
        this.commonTimeout = this.commonTimeout.bind(this);
        this.reachEnd =false;
        this.checkOnMouseOveraction = false;
        this.onLoadWorkspace = true;
        this.settedListener = false;
        this.loadedContentScrens = false;
        this.flipBG = this.flipBG.bind(this);
        this.fromEnableScreen = false;

        //For Lite..
        this.addOneMoreScene = this.addOneMoreScene.bind(this);
        this.setNewScreen = false;
        this.indexedPosition = 0;
        this.enteredUpdate = 0;
        this.startedScrolling = false;

        //ShortCut scene Scroll handling...
        this.rightKeyShortCut = false;
        this.leftKeyShortCut = false;
        this.setStageLeft = 60;

        this.handleZoomClick = this.handleZoomClick.bind(this);
        this.handleZoomChange = this.handleZoomChange.bind(this);
        this.handleZoomDrop = this.handleZoomDrop.bind(this);
        this.tabChanged   = this.tabChanged.bind(this);
        this.removeBG = this.removeBG.bind(this);
        this.controlVideo = this.controlVideo.bind(this);
        this.videoTimeUpdate  = this.videoTimeUpdate.bind(this);
        this.changeVideoTime  = this.changeVideoTime.bind(this);
        this.seekOver         = this.seekOver.bind(this);
        this.workspaceOver    = this.workspaceOver.bind(this);
        this.exitFullScreen = this.exitFullScreen.bind(this);
        this.enableFullScreen=this.enableFullScreen.bind(this);
        this.handleFullScreenMouseMove=this.handleFullScreenMouseMove.bind(this);
        this.addFont                =   this.addFont.bind(this);
        this.handleFullScreenMouseOver=this.handleFullScreenMouseOver.bind(this);
        this.handleFullScreenMouseOut=this.handleFullScreenMouseOut.bind(this);  
        this.handleSlideClick = this.handleSlideClick.bind(this);
        this.switchFullScreen = this.switchFullScreen.bind(this);
        this.interval;
        this.videoFullscreenTimer;

        this.appUrl = config['APPICONS'][config['APPICONS']['current']]
        this.assetUrl = config['ASSETS'][config['ASSETS']['current']]
        
        this.t1 = new TimelineMax({ paused: true });
        this.indicatorPosition=0;
        this.overflowStyles={};

        this.controlTimer = null;
        this.controlTimeout = 2500;
  }
    
    getCurrentZoom(dontCare, isFit){
      var padding = 0
      if(this.props.isFit || isFit)
      padding = 30
      
      var stageLeft   = this.props.workspaceStage.getIn(["left", "menu"]) + this.props.workspaceStage.getIn(["left", "library"]) + this.props.workspaceStage.getIn(["left", "toggle"]) + this.props.workspaceStage.getIn(["left", "padding"]) + padding;
      var stageTop    = this.props.workspaceStage.getIn(["top", "menu"]) + this.props.workspaceStage.getIn(["top", "zoomControlMargin"]) + this.props.workspaceStage.getIn(["top", "zoomControl"]) + this.props.workspaceStage.getIn(["top", "padding"]) + padding;
      var stageRight  = window.innerWidth - (this.props.workspaceStage.getIn(["right", "maxPropertyWindow"]) + this.props.workspaceStage.getIn(["right", "padding"]) + padding + this.props.workspaceStage.getIn(["workspace", "sceneToolBarMargin"]) + this.props.workspaceStage.getIn(["workspace", "sceneToolbar"]));
      var stageBottom = window.innerHeight - (this.props.workspaceStage.getIn(["bottom", "playerControlMargin"]) + this.props.workspaceStage.getIn(["bottom", "playerControl"]) + padding + this.props.workspaceStage.getIn(["bottom", "padding"]));

      var stageWidth  = stageRight - stageLeft;
      var stageHeight = stageBottom - stageTop;

      var cx = stageLeft + stageWidth / 2;
     
      var cy = stageTop + stageHeight / 2;
      let scale, width = stageWidth, height = stageHeight, actualWidth = width, actualheight = height;
      let workspaceWidth = this.props.workspaceWidth;
      if((!this.props.workspaceStage.get("isLocked") || dontCare !== undefined) && !this.fromEnableScreen){
        var widthScale = stageWidth / workspaceWidth;
        var heightScale = stageHeight / this.props.workspaceHeight;
        this.fromEnableScreen = false;
        scale = Math.min(widthScale , heightScale);
        width = stageWidth; height = stageHeight;

        if (this.props.isFullScreen) {
          let currentInnerWIdth = (window.innerWidth / this.props.workspaceWidth);
          let currentHeight = (window.innerHeight/ this.props.workspaceHeight);
          scale = Math.min(currentInnerWIdth, currentHeight);
           cx = window.innerWidth/ 2;
           cy = (window.innerHeight)/ 2;
           width = window.innerWidth;
           height = window.innerHeight;

          this.fromEnableScreen = false;

        }
      }
      else{
        this.fromEnableScreen = false;
        scale = this.props.zoomFactor;
      }
      return {scale : scale, cx : cx, cy : cy, width : width, height : height};

    }

    handleWindowResize(e, propsReceived=null){
      try {
      if(!this.props.isFit){
        this.props.setZoomFit(true);
      }
      var currentZoom = this.getCurrentZoom(null,propsReceived);
      this.props.setZoom({zoomFactor : currentZoom.scale, workspaceBounds: { cx: currentZoom.cx, cy: currentZoom.cy, width : currentZoom.width, height :  currentZoom.height}});
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-handleWindowResize")
    }
    }

    handleRightClick(e){
      try {
      e.preventDefault();
        var isOnSelBox = this.isMouseOn(e, "selectionBox") || this.isMouseOn(e, "scene-item");
       
        if (isOnSelBox === true) {
          
          this.setState({contextMenu : true, isContextBg : false});
          const clickX = e.clientX;
          const clickY = e.clientY;
          const screenW = window.innerWidth;
          const screenH = window.innerHeight;
          const cmWidth = this.contextMenu.offsetWidth;
          const cmHeight = this.contextMenu.offsetHeight;
          
          const right = (screenW - clickX) > cmWidth;
          const left = !right;
          const top = (screenH - clickY) > cmHeight;
          const bottom = !top;
  
          if (right) { this.contextMenu.style.left = `${clickX + 5}px`; }
          if (left) { this.contextMenu.style.left = `${clickX - cmWidth - 5}px`; }
          if (top) { this.contextMenu.style.top = `${clickY + 5}px`; }
          if (bottom) { this.contextMenu.style.top = `${clickY - cmHeight - 5}px`; }
          if(parseFloat(this.contextMenu.style.top)+cmHeight>window.innerHeight-this.props.timelineHeight-60)
            this.contextMenu.style.top=`${clickY - cmHeight - 5}px`
          if(parseFloat(this.contextMenu.style.left)+cmWidth>window.innerWidth-225)
            this.contextMenu.style.left=`${clickX - cmWidth - 5}px`;
        }
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-handleRightClick")
      }
    }

    isFontLoaded(fontFamily, element) {
      var _aFallbackFonts = ['serif', 'sans-serif', 'monospace', 'cursive', 'fantasy'];
      var wThisFont = 0;
      var wPrevFont = 0;

      for (var ix = 0; ix < _aFallbackFonts.length; ++ix) {
          element.style.fontFamily = '"' + fontFamily + '",' + _aFallbackFonts[ix];
          wThisFont = element.offsetWidth;
          if (ix > 0 && wThisFont !== wPrevFont) {
              return false;
          }

          wPrevFont = wThisFont;
      }

      return true;
  }

  onFontLoad(toAdd, loadStatus) {
     
      let fontFamily = toAdd.get("load");
      
      var span = null;
      var eLang = 'en';
      var aChars = {
          'en': 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
          'fa': 'ابپتجچحخدذرزسشصضططعغفقکگلمنوهی'
      };
      var body = document.body;
      var firstChild = document.body.firstChild;
      var msInterval = 100, msTimeout = 2000;

      var div = document.createElement('div');
      div.id = 'fontdetectHelper';
      span = document.createElement('span');
      span.innerText = aChars[eLang];
      div.appendChild(span);

      body.insertBefore(div, firstChild);

      div.style.position = 'absolute';
      div.style.visibility = 'hidden';
      div.style.top = '-200px';
      div.style.left = '-100000px';
      div.style.width = '100000px';
      div.style.height = '200px';
      div.style.fontSize = '100px';

      if (this.isFontLoaded(fontFamily, span)) {
          div.remove();
          loadStatus({success : true});
          return true;
      }

      var outerThis = this;
      var utStart = new Date().getTime();
      var idInterval = setInterval(
          function () {
              if (outerThis.isFontLoaded(fontFamily, span)) {	// It's now loaded.
                  clearInterval(idInterval);
                  div.remove();
                  loadStatus({success : true});
                  return true;
              }
              else {	// Still not loaded.
                  var utNow = new Date().getTime();
                  if ((utNow - utStart) > msTimeout) {
                      clearInterval(idInterval);
                      div.remove();
                      loadStatus({success : false});
                      return false;
                  }
              }
          },
          msInterval
      );
  }


  addFont(toAdd) {
    try {
      var font = toAdd.get("load");
      if (!document.getElementById(toAdd.get("load")) && font !== undefined) {
        var fontFileName = toAdd.get('font');//font.replace(new RegExp(" ", 'g'), "-"); font.replace(" ", "-");
        var link = document.createElement("link");
        link.id = toAdd.get("load");
        link.rel = "stylesheet";
        link.onload = () => {
          this.loadStyle(font, fontFileName, toAdd);
        }
  
        if (toAdd.get("isPartialFont")) {
  
          link.href = toAdd.get("url");
        }
        else if (toAdd.get("byUser") !== true) {
  
          link.href = this.assetUrl + "animaker/admin-fonts/" + fontFileName + ".css";
        }
        else {
  
          link.href = toAdd.get("url").indexOf("https://") === 0 ? toAdd.get("url") : `${this.userFontUrl}${toAdd.get("url")}`;
        }
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    } catch (error) {
      console.log(error)
    }
  }

  loadStyle(fontFamily, fontFileName, fontData) {

    const dummyNode = document.createElement("span").appendChild(document.createTextNode("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ" + fontFamily)).parentNode;
    dummyNode.style.position = "fixed";
    dummyNode.style.opacity = 0;
    // eslint-disable-next-line
    let fontFamilyToSet = `"${fontFamily.replace(/\"/g, "")}"`;
    dummyNode.style.fontFamily = fontFamilyToSet;
    dummyNode.style.fontSize = "14px";
    dummyNode.setAttribute('data-dummy', 'true');
    document.body.insertBefore(dummyNode, document.body.firstChild);


    let hasLoaded = document.fonts.check(`12px ${fontFamilyToSet}`);
    if (hasLoaded) {
      this.props.fontLoaded({ load: fontFileName });
    } else {
      let maxTries = 6;
      let tries = 0;
      let interval = 500;
      let timer = setInterval(() => {
        hasLoaded = document.fonts.check(`12px ${fontFamilyToSet}`);

        if (hasLoaded || tries >= maxTries) {
          clearInterval(timer);
          this.props.fontLoaded({ load: fontFileName });
        }

        tries = tries + 1;
      }, interval);
    }

    // const throttleStart = Date.now();

    // while (!hasLoaded && (Date.now() - throttleStart) < 3000) {
    //   hasLoaded = this.isFontLoaded(fontFamily, dummyNode);
    // }

    /*  if(!fontData.get('byUser')){
        if(!this.loadBoldItalic.includes(fontFileName)){
            let fontFamData = fontFamilies.getIn(["default", "fonts"]).find(x => x.get("fontFamily") === fontFileName)
            let isBold = false, isItalic = false, isBoldItalic = false;
            if(fontFamData && fontFamData.get("isItalic") && fontFamData.get("isBold"))
                isBoldItalic = true;
            else if(fontFamData && fontFamData.get("isBold"))
                isBold = true
            else if(fontFamData && fontFamData.get("isItalic"))
                isItalic = true
            
            let tempText = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ, ابپتجچحخدذرزسشصضططعغفقکگلمنوهی`

            if(isBoldItalic){
                document.fonts.load(`12px ${fontFileName}-BoldItalic`,tempText)
                document.fonts.load(`12px ${fontFileName}-Bold`,tempText)
                document.fonts.load(`12px ${fontFileName}-Italic`,tempText)
            }else if(isBold){
                document.fonts.load(`12px ${fontFileName}-Bold`,tempText)
            }else if(isItalic){
                document.fonts.load(`12px ${fontFileName}-Italic`,tempText)
            }
            this.loadBoldItalic.push(fontFileName)   
        }
    } */
    // this.props.fontLoaded({ load: fontFileName });
  }

    componentWillMount(){

      this.enteredUpdate = 0; /// For lite scene scroll issue
     
      this.setState({ workspace: { left: (((window.innerWidth - this.props.appState.libraryWidth) / 2) + this.props.appState.libraryWidth - (this.props.workspaceWidth * this.props.zoomFactor) / 2), top: (((window.innerHeight - this.props.appState.menuHeight) / 2) + this.props.appState.menuHeight - (this.props.workspaceHeight * this.props.zoomFactor) / 2), marginleft: (((window.innerHeight - this.props.appState.menuHeight)) + this.props.appState.menuHeight - (this.props.workspaceHeight * this.props.zoomFactor) / 2) } });
    }

    componentWillReceiveProps(nextProps, nextState){

      if(nextProps.draggedFileItem && this.props.draggedFileItem !== nextProps.draggedFileItem){
        this.handledroppedFile(nextProps.draggedFileItem);
        this.props.draggedFile('');
      }
     
      if(nextProps.scenes.size !== this.props.scenes.size){
        let itemArray = [];
        if(nextProps.scenes.size > 1){
          for(let i=1; i <= nextProps.scenes.size; i++){
            itemArray.push(i);
          }
        }else{
          itemArray = this.state.items;
        }
        this.setState({
          items:itemArray
        })
      }
      if((nextProps.isPlay === true || nextProps.isPlayAll === true) && nextProps.isLoaded)
      {
        // setTimeout(function(){ 
          if(document.getElementsByClassName("player-loader-img")[0] !== undefined && document.getElementsByClassName("player-loader-img")[0] !== null)
            document.getElementsByClassName("player-loader-img")[0].style.display = "none"
        // }, 3000);

      }
      if((nextProps.selectedScene !== this.state.active || (nextProps.isPlay === true || nextProps.isPlayAll === true ) ) && (!this.rightKeyShortCut && !this.leftKeyShortCut)){
        // var mainCOmponent = document.getElementsByClassName('item');
        // var asda = document.getElementById('workspace');
       this.scrollType = '';
       this.isSceneClick=true;
        this.setState({
          active : nextProps.selectedScene
        })
      }else if( (nextProps.isPlay !== this.props.isPlay && nextProps.isPlay === false) || (nextProps.isPlayAll !== this.props.isPlayAll && nextProps.isPlayAll === false)||(nextProps.isPreview !== this.props.isPreview && nextProps.isPreview === false)){
          this.scrollType = 'scroll';
          this.checkOnMouseOveraction = true;
      }

      if( (nextProps.isPlay !== this.props.isPlay) || (nextProps.isPlayAll !== this.props.isPlayAll)){
        if(nextProps.isPlay || nextProps.isPlayAll)
          document.body.style.backgroundColor = "#808080"
        else
          document.body.style.backgroundColor = "#ededef"
      }
           


    }

    getCursorPosition(type, timeVal, setStore) {
      let duration = 0;
      if(this.props.isPlay)
        duration = this.props.sceneData.get('duration');
      else if(this.props.isPlayAll)
        duration = this.props.overallDuration;

      const currentTimeScale = ((this.props.workspaceWidth) * this.props.zoomFactor)/ duration;
      var  ValueX = (timeVal - 0) * currentTimeScale;
      let domPlayhead = document.getElementsByClassName('playHeadCls')[0];
          domPlayhead.style.transform = "translate3d(" + parseFloat(ValueX.toFixed(1)) + "px, 0px, 0px)"
    }

   

    mouseOverFunctions(e){
      try {
      let result = this.isMouseOn(e, 'workspace-main-page');
        if(result){
          if(this.props.isPlay || this.props.isPlayAll||this.props.isPreview)
            this.checkOnMouseOveraction = !result;
          else{
            if(this.scrollType === ''){
              this.scrollType = 'scroll';
            }
            this.checkOnMouseOveraction = result;
          }
        }else{
            this.checkOnMouseOveraction = result;
            if(this.scrollType === '' && !this.props.isPlay){
              this.onLoadWorkspace = true;
            }
        }
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-mouseOverFunctions")
      }
    }
  
    applymouseOverAction(){
      window.addEventListener('mouseover',(event)=>this.mouseOverFunctions(event), false);
    }

    getCorner(x, y, a){
      var x2 = Math.cos(a / 180 * Math.PI) * x - Math.sin(a / 180 * Math.PI) * y;
      var y2 = Math.sin(a / 180 * Math.PI) * x + Math.cos(a / 180 * Math.PI) * y;
      return [x2, y2];
    }

    switchFullScreen(e){
      var isFullScreenSwitch = e.keyCode || e.which ;
      if(isFullScreenSwitch == 70){
        window.enableFullScreen();
      }
    }
  

    componentDidMount(){
      this.handleWindowResize(this,true);
      window.addEventListener('mousedown', this.handleMouseDown, false);
 
      window.addEventListener("resize", this.handleWindowResize, false);
      window.addEventListener("contextmenu", this.handleRightClick, false);
      window.addEventListener("blur", this.tabChanged, false);

      
    window.addEventListener('webkitfullscreenchange', this.exitFullScreen, false);
    window.addEventListener('fullscreenchange', this.exitFullScreen, false);
    window.addEventListener('mozfullscreenchange', this.exitFullScreen, false);
    window.addEventListener('msscreenchange', this.exitFullScreen, false);
    // window.addEventListener('mousemove',this.handleFullScreenMouseMove,false);
    window.onSceneMove = this.onSceneMove;
    window.enableFullScreen = this.enableFullScreen;
    window.addEventListener("keydown",this.switchFullScreen,false);

      //if not reponsive for other resolutions...remove
    //  let currentWindowWidth,currentWindowHeight,currentZoomFactor;
    //  currentWindowWidth = (window.screen.width / this.props.workspaceWidth);
    //  currentWindowHeight = (window.screen.height / this.props.workspaceHeight);
    //  currentZoomFactor = Math.min(currentWindowWidth, currentWindowHeight);
    
   
 
    //  this.props.setZoom({ zoomFactor : currentZoomFactor});


  

    if((this.props.loadedFonts.get("fonts").size > 0)){
            
      this.props.loadedFonts.get("fonts").entrySeq().forEach(([key, fontDetail]) => {
          this.addFont(fontDetail);
      });
  }


      //For Scroll scenes...
      // window.addEventListener("mousewheel", (event)=>this.changeLeafsOnScroll(event), false);
     // if (document.readyState === "complete") 
        //document.addEventListener("DOMContentLoaded", this.testing.bind(this), false);
      
      
      HTMLElement.prototype.pseudoStyle = function(selectedDiv,uniqueId,element,prop,value){
        var _this = selectedDiv;
        var _sheetId = "pseudoStyles";
        var _head = document.head || document.getElementsByTagName('head')[0];
        var className = uniqueId + "_bg", sheetIndex = -1, classPresent = false;
      
        _this.className = _this.className.replace(" " + className, "");
        _this.className +=  " " + className;
      
        for( var s in document.styleSheets ){
          if( document.styleSheets[s].title && document.styleSheets[s].title.indexOf("pseudoStyles") === 0 ) {
            sheetIndex = s;
            break;
          }
        }
        let pseudoSheet = document.styleSheets[sheetIndex];
        
        if(sheetIndex > -1)
        {
          for (var i=0; pseudoSheet.cssRules && i<pseudoSheet.cssRules.length; i++){
          if (pseudoSheet.cssRules[i].selectorText.indexOf(className) >= 0)
          {
            pseudoSheet.cssRules[i].style.background = value;
            classPresent = true;
          }
          }
        }
        
        if(!classPresent)
        {
          var _sheet = document.getElementById(_sheetId) || document.createElement('style');
          _sheet.id = _sheetId;
          _sheet.title = _sheetId;
          _sheet.innerHTML += "\n."+className+":"+element+"{"+prop+":"+value+"}";
          _head.appendChild(_sheet);
          return this;
        }
      }.bind(this);
    }

    tabChanged(e){
      try {
        this.ctrlPressed = false;
        if(!this.props.textStatus.get("isFocused"))
          this.enableClick(".selectionBox");
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-tabChanged")
      }
    }

    getColorsFromHtml(textItem, existColors){
     
      var rgbRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/;
      var extractedColors = [];
      var x,elemStyles,styleValue,rgbVal;
      var toGetColors = document.createElement("div");
      toGetColors.setAttribute("id", "toGetColors");
      toGetColors.style.position    = "absolute";
      toGetColors.style.hidden    = "true";
      toGetColors.innerHTML    = textItem.getIn(["textData", "htmlText"]);
      
      document.getElementsByClassName('workspace')[0].appendChild(toGetColors);
      elemStyles = window.getComputedStyle(toGetColors);
      
      var elems = toGetColors.getElementsByTagName('*');
      var total = elems.length;
      let hasColors = false;
      for(x = 0; x < total; x++) {
        elemStyles = window.getComputedStyle(elems[x]);
        
          styleValue = elemStyles.color || elemStyles["color"];
         
          if(styleValue){
            rgbVal = styleValue.match(rgbRegex);
          
            if(rgbVal && !hasColors && rgbVal.input !== "rgb(0, 0, 0)"){
                hasColors = true;
            }else{
              rgbVal.input = textItem.getIn(["textData", "formats", "containerStyle", "color"]);
            }
            if(rgbVal && existColors.indexOf(rgbVal.input) === -1 && extractedColors.indexOf(rgbVal.input) === -1){
              extractedColors.push(rgbVal.input);
            }
          }
      }
  
      toGetColors.remove();
     
      return extractedColors;
    }

    getAllColors(props, id, container, isGrouped){
     
      let textItems;
      var allColors = [];
      if(isGrouped !== undefined && isGrouped){
        let childIds = props.sceneData.getIn(["workspaceItems", id, "groupChildren"]);
        textItems = props.sceneData.get("workspaceChildren").filter(function(obj, key){return childIds.keyOf(key) !== undefined});
        
        textItems.entrySeq().forEach(([key, textItem]) => {
          let colors = this.getColorsFromHtml(textItem, allColors);
          if(colors.length > 0)
            allColors = allColors.concat(colors);
        });

      }else{
        let textItem = props.sceneData.getIn([container, id]);
        let colors = this.getColorsFromHtml(textItem, allColors);
        if(colors.length > 0)
          allColors = allColors.concat(colors);
      }
    
      return allColors;
    }

    getTextFormats(item) {
      
      
      var obj = {textAlign:"left", color:"#fff", lineHeight:1, fontWeight:null, fontStyle:null, textDecoration:null, textTransform:null, wordSpacing:0, letterSpacing : 0, opacity:1, isGrouped : false};
  
      var formats = item.getIn(["textData", "formats"]);
  
      Object.assign(obj, formats.get("containerStyle").toObject());
      
      var bullet  = formats.get("bullet");
      obj.fontSize = parseFloat(obj.fontSize, 10);
      obj.letterSpacing = parseFloat(obj.letterSpacing, 10);
     
      if(bullet){
        obj.isBullet = bullet.get("isBullet");
        obj.bullet = bullet.get("type");
      }
      
      
      if (item.getIn(["textData", "formats", "others", "isRTL"]))
        Object.assign(obj, { isRTL: true });
     
      return obj;
    }

    rotatedPosition(x,y,width,height,rotationAngle, position){
      if(position === undefined)
        position = "topLeft";
      // get the center of the rectangle (==rotation point)
      var cx = x + width/2;
      var cy = y + height/2;
  
      // calc the angle of the unrotated TL corner vs the center point
      var dx = (x + width) - cx;
      var dy = (y) - cy;
      var originalTopLeftAngle = Math.atan2(dy,dx);
  
      // Add the unrotatedTL + rotationAngle to get total rotation
      var rotatedTopLeftAngle = originalTopLeftAngle + rotationAngle;
  
      // calc the radius of the rectangle (==diagonalLength/2)
      var radius=Math.sqrt(width*width+height*height)/2;
  
      // calc the rotated top & left corner
      var rx=cx+radius*Math.cos(rotatedTopLeftAngle);
      var ry=cy+radius*Math.sin(rotatedTopLeftAngle);
  
      // return the results
      return({x:rx, y:ry});
    }

    componentWillUpdate(nextProps, nextState){
      if (nextProps.isFullScreen !== this.props.isFullScreen) {
        if (nextProps.isFullScreen) {this.onFullModeResponsive();}
       else this.closeFullScreen(nextProps);    
      }      
    }
  
    exitFullScreen(e) {
     try{
     
      if (this.props.isFullScreen && (document.webkitFullscreenElement === null || document.mozFullScreenElement === null || document.msFullscreenElement === null || document.fullscreenElement === null)) {
        let currentZoomFactor = this.props.prevZoomFactor;
        this.props.setFullScreen({ status: !this.props.isFullScreen, zoomFactor: currentZoomFactor, prevZoomFactor: this.props.zoomFactor });
      }
    }
    catch (error) {
      errorlog(error, error.message, "WorkspaceComponent-exitFullScreen")
   }
  }
    
    closeFullScreen(nextProps=null) {
      if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();

      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();

      }
      else if (document.fullscreenElement) { /* Firefox */
        document.exitFullscreen()
      }

      // let mainDiv = document.getElementsByClassName('workspace-wrapper')[0];
      // if(mainDiv !== null & mainDiv !== undefined && mainDiv){
      //   var workspaceWidth = nextProps.workspaceWidth * nextProps.zoomFactor, workspaceHeight = nextProps.workspaceHeight * nextProps.zoomFactor;
      //   mainDiv.style.width = "100%";
      //   mainDiv.style.height = workspaceHeight +'px';
      //   mainDiv.style.backgroundColor = 'none';
      //   mainDiv.style.position = 'unset';
      //   mainDiv.style.borderRadius = '0px';
      // }
    }
  
   onFullModeResponsive() {
    var elem = document.documentElement;

    if (elem.requestFullscreen && !this.props.isFullScreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen && !this.props.isFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen && !this.props.isFullScreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen && !this.props.isFullScreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    }
    
   
  }
  handleFullScreenMouseMove() {
    try{
    if(this.props.isFullScreen===true||this.props.mode==='slide'){
      let currentScene = this.state.currentSceneNumber;
   clearInterval(this.interval);
   this.interval = setInterval(function () {  
     if(document.body.contains(document.getElementById('player-controls'))){
      document.getElementById('player-controls').style.opacity = 0;
    }
      if(document.body.contains(document.getElementById('video-controls-'+currentScene)))
      {
        document.getElementById('video-controls-'+currentScene).style.opacity = 0;
      }
     }, 800);
     document.getElementById('player-controls').style.opacity = 1; 
     if(document.body.contains(document.getElementById('video-controls-'+currentScene)))
      {
        document.getElementById('video-controls-'+currentScene).style.opacity = 1;
      }
     } 
    }catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-handleFullScreenMouseMove")
    }
     
}
handleFullScreenMouseOver(e){
 if(this.props.isFullScreen===true||this.props.mode==='slide'){
   const currentSceneNumber = this.state.currentSceneNumber;
    const videoControl = `video-controls-${currentSceneNumber}`; 
 if(e.target.id==='next-slide'||e.target.id==='previous-slide'||e.target.id==='full-screen'||e.target.id==='prevSlide'||e.target.id==='nextSlide' || e.target.id === videoControl ){
   window.removeEventListener('mousemove',this.handleFullScreenMouseMove,false);
 }
}
}
handleFullScreenMouseOut(e){
  if(this.props.isFullScreen===true||this.props.mode==='slide'){
   const currentSceneNumber = this.state.currentSceneNumber;
   const videoControl = `video-controls-${currentSceneNumber}`;
 if(e.target.id==='next-slide'||e.target.id==='previous-slide'||e.target.id==='nextSlide'|| e.target.id==='full-screen' || e.target.id === videoControl){
      window.addEventListener('mousemove',this.handleFullScreenMouseMove,false);  
  }
}
}

enableFullScreen() {
  try {
    let currentInnerWIdth = (window.innerWidth / this.props.workspaceWidth);
    let currentHeight = (window.innerHeight / this.props.workspaceHeight);
    let currentZoomFactor = Math.min(currentInnerWIdth, currentHeight);
    let cx,cy,width,height;
    
  
  
      currentInnerWIdth = (window.screen.width / this.props.workspaceWidth);
      currentHeight = (window.screen.height / this.props.workspaceHeight);
      currentZoomFactor = Math.min(currentInnerWIdth, currentHeight);
      cx = window.screen.width/ 2;
      cy = (window.screen.height)/ 2;
      width = window.screen.width;
      height = window.screen.height;
  

  
      
   let currentScene = this.props.selectedScene; 
   this.props.setScenePosition(this.props.project.getIn(['scenes' , currentScene ]),currentScene,this.props.project.getIn(['scenes',currentScene,'startTime']) , this.props.project.getIn(['scenes',currentScene,'duration']));
   this.props.setPreview(!this.props.isPreview);
   this.fromEnableScreen = false;
   
  //  this.props.setPlayAll(!this.props.isPlayAll && !this.props.fromStart, !this.props.isPlayAll && !this.props.fromStart);
   this.props.setFullScreen({ status: !this.props.isFullScreen, zoomFactor: currentZoomFactor, prevZoomFactor: this.props.zoomFactor });
   this.props.setZoom({ workspaceBounds: { cx: cx, cy: cy, width : width, height : height}});


  }catch (error) {
    errorlog(error, error.message, "WorkspaceComponent-enableFullScreen")
  }
}

componentDidUpdate(prevProps, prevState){
  if(prevState.currentSceneNumber !== this.state.currentSceneNumber){
    this.setState({seekValue:0,isFullScrVideoplay:false,seekTime:null,seekX:null});
  }
    this.flipedItem = false;
      if(document.readyState === 'complete' && !this.settedListener){
        this.applymouseOverAction();
        this.settedListener = true;
      }
    
      if(prevState.isZoomDropped){
        this.setState({isZoomDropped:false})
      }
     
      if((!this.props.workspaceStage.equals(prevProps.workspaceStage) || this.props.workspaceWidth !== prevProps.workspaceWidth) && this.props.isFit ){
        this.handleWindowResize();
      }
       
      if(!this.props.isWorkspaceTextFocus && (this.props.shortcutName !== prevProps.shortcutName) && this.props.shortcutName !== ""){
        this.handleShortcuts(this.props.shortcutName);
      }
      else if(!this.props.isWorkspaceTextFocus && this.props.shortcutName !== prevProps.shortcutName && this.props.shortcutName === "")
      {
        if(this.ctrlPressed)
          this.ctrlPressed = false;
        if(!this.props.textStatus.get("isFocused"))
          this.enableClick(".selectionBox");
      }

  
     
      if (prevProps.selectedItems !== this.props.selectedItems) {
        if (this.state.contextMenu) {
          this.setState({ contextMenu: false });
        }
      }

      if (prevProps.textStatus !== this.props.textStatus ) {
        
        if((prevProps.textStatus.get("isFocused") !== this.props.textStatus.get("isFocused") && this.props.textStatus.get("isFocused")) || (prevProps.textStatus.get("isSelected") !== this.props.textStatus.get("isSelected") && this.props.textStatus.get("isSelected")) || prevProps.textStatus.get("id") !== this.props.textStatus.get("id")){
         
          if(!this.props.textStatus.get("isGrouped") && this.props.textStatus.get("id") !== null){
            
            let textFormats = this.getTextFormats(this.props.sceneData.getIn([this.props.textStatus.get("container"), this.props.textStatus.get("id")]));
            let colors = this.getAllColors(this.props, this.props.textStatus.get("id"), this.props.textStatus.get("container"));
        
            if(colors.length > 0)
              Object.assign(textFormats, {colors: colors});
            
            this.props.setTextOptions(textFormats);
          }
          else if(this.props.textStatus.get("isGrouped") && this.props.textStatus.get("isFocused")){
            let textFormats = this.getTextFormats(this.props.sceneData.getIn([this.props.textStatus.get("container"), this.props.textStatus.get("id")]));
            let colors = this.getAllColors(this.props, this.props.textStatus.get("id"), this.props.textStatus.get("container"));
        
            if(colors.length > 0)
              Object.assign(textFormats, {colors: colors});
            
            this.props.setTextOptions(textFormats);
          }
        }
        else if(prevProps.textStatus.get("fontSize") !== this.props.textStatus.get("fontSize")){
          this.props.setTextOptions({fontSize : this.props.textStatus.get("fontSize")});
        }
      }
      else if(((this.props.textStatus.get("isFocused") || this.props.textStatus.get("isSelected")) && this.props.textStatus.get("id") !== null)){
       
        if(!this.props.textStatus.get("isGrouped")){
          let nextFormats = this.props.sceneData.getIn([this.props.textStatus.get("container"), this.props.textStatus.get("id"), "textData","formats"]);
          let prevFormats = prevProps.sceneData.getIn([this.props.textStatus.get("container"), this.props.textStatus.get("id"), "textData", "formats"]);
          if(nextFormats && prevFormats && !nextFormats.equals(prevFormats)){
            let textFormats = this.getTextFormats(this.props.sceneData.getIn([this.props.textStatus.get("container"), this.props.textStatus.get("id")]));
            let colors = this.getAllColors(this.props, this.props.textStatus.get("id"), this.props.textStatus.get("container"));
            if(colors.length > 0)
              Object.assign(textFormats, {colors: colors});
            this.props.setTextOptions(textFormats);
            
          }
        }
        else if(this.props.textStatus.get("isSelected") && this.props.selectedItems.get(0) === this.props.textStatus.get("id")){
         
          let selectedData = this.props.sceneData.getIn(["workspaceItems", this.props.textStatus.get("id")]);
          let childIds = selectedData.get("groupChildren");
          let textChildren =  this.props.sceneData.getIn(["workspaceChildren"]).filter(function(obj, key){return childIds.keyOf(key) !== undefined && obj.get("type") === "TEXT"});
          
          let textKeys = textChildren.keySeq().toArray();
          let nextFormats = this.props.sceneData.getIn(["workspaceChildren", textKeys[0], "textData", "formats"]);
          let prevFormats = prevProps.sceneData.getIn(["workspaceChildren", textKeys[0], "textData", "formats"]);
  
          if(nextFormats && prevFormats && !nextFormats.equals(prevFormats)){
            let colors = this.getAllColors(this.props, this.props.textStatus.get("id"), this.props.textStatus.get("container"), true);
            this.props.setTextOptions({colors: colors});
          }
        }
      }

      if (this.props.selectedItems !== prevProps.selectedItems) {
        let item = this.props.selectedItems.get(0);
        
        if(item && this.props.selectedItems.size === 1 && (!this.props.textStatus.get("isFocused") || this.props.textStatus.get("id") !== this.props.selectedItems.get(0)) ){
          let selectedData = this.props.sceneData.getIn(["workspaceItems", item]);
          if(selectedData && (selectedData.get("type") === "TEXT" || selectedData.get("type") === "SHAPE")){
            if(selectedData.get("type") === "SHAPE"){
              this.props.updateTextStatus({id:item, isFocused : false, isSelected : true, container : "workspaceItems", isRTL : selectedData.getIn(["textData", "formats", "others", "isRTL"]), isGrouped :false, fontSize : parseFloat(selectedData.getIn(["textData", "formats", "containerStyle", "fontSize"]), 10), type : selectedData.get("type")});
              }
              else if(selectedData.get("type") === "TEXT") {
              this.props.updateTextStatus({id:item,isSelected : true, container : "workspaceItems", isRTL : selectedData.getIn(["textData", "formats", "others", "isRTL"]), isGrouped :false, fontSize : parseFloat(selectedData.getIn(["textData", "formats", "containerStyle", "fontSize"]), 10), type : selectedData.get("type")});
              }
            let textFormats = this.getTextFormats(selectedData);
            let colors = this.getAllColors(this.props, item, "workspaceItems");
            if(colors.length > 0)
              Object.assign(textFormats, {colors: colors});
            this.props.setTextOptions(textFormats);
          }
          else if(selectedData.get("type") === "GROUP" || selectedData.get("type") === "TXTOVLY"){
            let childIds = selectedData.get("groupChildren");
            let textChildren =  this.props.sceneData.get("workspaceChildren").filter(function(obj, key){return childIds.keyOf(key) !== undefined && (obj.get("type") === "TEXT" || obj.get("type") === "SHAPE") });
            let shapeChildren = this.props.sceneData.get("workspaceChildren").filter(function(obj, key){return childIds.keyOf(key) !== undefined && (obj.get("type") === "SHAPE") });

            let fontFamily = null, fontSize = null, colors = [], isAllBold = true, isAllItalic = true, isAllUnderline = true;
            if(textChildren.size > 0){
              let prevFont = null;
              textChildren.entrySeq().forEach(([key, obj]) => {
                let formats = obj.getIn(["textData", "formats"]);
                if((formats.getIn(["containerStyle", "fontFamily"]) === prevFont || prevFont === null) && fontFamily !== "Multiple Fonts")
                  fontFamily = formats.getIn(["containerStyle", "fontFamily"]);
                else
                  fontFamily = "Multiple Fonts";
                prevFont = formats.getIn(["containerStyle", "fontFamily"]);
  
                if(colors.indexOf(formats.getIn(["containerStyle", "color"])) === -1)
                  colors.push(formats.getIn(["containerStyle", "color"]));
  
                let size = parseFloat(formats.getIn(["containerStyle", "fontSize"]), 10);
                
                if(size > fontSize || fontSize === null)
                  fontSize = size;
                
                if((formats.getIn(["containerStyle", "fontWeight"]) === undefined || formats.getIn(["containerStyle", "fontWeight"]) === "normal" || formats.getIn(["containerStyle", "fontWeight"]) === null) && isAllBold){
                  isAllBold = false;
                }
  
                if((formats.getIn(["containerStyle", "fontStyle"]) === undefined || formats.getIn(["containerStyle", "fontStyle"]) === "normal" || formats.getIn(["containerStyle", "fontStyle"]) === null) && isAllItalic){
                  isAllItalic = false;
                }
  
                if((formats.getIn(["containerStyle", "textDecoration"]) === undefined || formats.getIn(["containerStyle", "textDecoration"]) === "none" || formats.getIn(["containerStyle", "textDecoration"]) === null) && isAllUnderline){
                  isAllUnderline = false;
                }
              });
            
              if(shapeChildren.size>0){
                this.props.setIsShapeInGrp(true);
              }
              else{
                this.props.setIsShapeInGrp(false);
                this.props.updateTextStatus({id:item, isFocused : false, isSelected : true, container : "workspaceItems", isRTL : selectedData.getIn(["textData", "formats", "others", "isRTL"]), isGrouped :true, fontSize : fontSize, type : selectedData.get("type")});
                colors = this.getAllColors(this.props, item, "workspaceItems", true);
                this.props.setTextOptions({fontFamily : fontFamily, fontSize : fontSize , colors:colors, lineHeight:1, fontWeight:(isAllBold)?"bold":null, fontStyle:(isAllItalic)?"italic":null, textDecoration:(isAllUnderline)?"underline":null, textTransform:null, wordSpacing:0, opacity:1, isGrouped : true});
                
              }

            }
          }else{
            if(this.props.textStatus.get("id") !== null){
              
              this.props.updateTextStatus({id:null, isFocused : false, isSelected : false, container : null, isRTL : false, isGrouped :false, fontSize : null});
            }
          }
        }
      }
      if(this.props.sceneData !== undefined && this.props.sceneData.size > 0){
        let filterData = this.props.sceneData.getIn(['workspaceBG','bgFilter']);
        
        
        // if(this.props.sceneData.getIn(['workspaceBG','enterStart']) <= this.props.sceneData.get('playHeadValue') && this.props.sceneData.getIn(['workspaceBG','exitEnd']) >= this.props.sceneData.get('playHeadValue') && !this.props.isPlay && !this.props.isPlayAll){
        //   let selectedElem = document.getElementsByClassName('bg-container tintCls')[0], selectedId = "ws-bgImg-" + this.props.selectedScene;
        //   if(this.props.sceneData.getIn(['workspaceBG','type']) === "VIDEO" || this.props.sceneData.getIn(['workspaceBG','type']) === "STOCKVID"){
        //     selectedElem = document.getElementsByClassName('video-container tintCls')[0];
        //     selectedId = "ws-bgVideo-";
        //   }
        // }
        let wrkscData = this.props.sceneData.get("workspaceItems");
        if (!wrkscData.isEmpty()) {
          wrkscData.entrySeq().forEach(([key, value]) => {
            filterData = value.get('filter');
            
          })
        }
      }
      
      
     

      if(this.props.scenes.size !== prevProps.scenes.size){
        ///For transitions on the scene add and delete we dont know so setting state again to rerender component........
        this.setState({
          applyTransitions : !this.state.applyTransitions
        })  
      }

      if((this.props.workspaceHeight !== prevProps.workspaceHeight || this.props.workspaceWidth !== prevProps.workspaceWidth) && this.props.isFit){
        this.handleWindowResize();
      }

      
      if((this.props.selectedItems !== prevProps.selectedItems || (this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]) !== prevProps.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]))) || (this.props.textStatus.get("isFocused") !== prevProps.textStatus.get("isFocused") && this.props.textStatus.get("isFocused"))){
        document.getElementById("highlighter").style.display = "none";
        this.setState({bgToolActive:false})
      }
      if(this.props.sceneData.getIn(["workspaceBG" , "src"])!== prevProps.sceneData.getIn(["workspaceBG" , "src"]))
      {
      if(!this.props.isPlay && !this.props.isPlayAll && this.props.swapDetails === null && this.props.tool !== "converttomp4"){
        if(this.props.sceneData.getIn(["workspaceBG" , "src"]) !== ""){
          this.setState({bgToolActive:true})
        }}
      }
    }

    componentWillUnmount(){
        window.removeEventListener('mousedown', this.handleMouseDown, false);
        window.removeEventListener("resize", this.handleWindowResize, false);
        window.removeEventListener('mousemove',this.handleFullScreenMouseMove,false);
        window.removeEventListener("contextmenu", this.handleRightClick, false);
        window.removeEventListener("blur", this.tabChanged, false);
        window.removeEventListener("mousewheel", (event)=>this.changeLeafsOnScroll(event), false); 
        window.removeEventListener("keydown",this.switchFullScreen,false);

    }
    //For scroll Scenes Starts from here....
    changeLeafsOnScroll(e=null, check= null) {
      try {

      if (!this.props.isPlay && !this.props.isPlayAll && Math.abs(e.wheelDelta) > 20) {
        if (this.props.selectedItems.toJS().length > 0 && this.isMouseOn(e, "workspace-main-page"))
          {
            this.props.setSelectedItems({selectedItems : []}, this.props.socket);
            // this.props.suggestionPopup({
            //   show : false,
            //   type : '',
            //   subType : ''
            // })
          }

        this.onLoadWorkspace = false;
        if (this.checkOnMouseOveraction && (this.props.selectedScene === this.state.active)) {
          // this.startedScrolling = true;
          this.scrollType = 'scroll';
          this.scrollOnce = this.scrollOnce + 1;
          if (e !== null) {
            e = e || window.event;
            this.delta = e.deltaY || e.detail || e.wheelDelta;
          }

          this.fail = true;
          var date = new Date();
          var timestamp = date.getTime();
          this.currentTime = timestamp;
          this.commonTimeout();
          if (this.delta > 0) {
            //Mouse wheel rotation upwards
            if (e)
              this.mouseUpTime = e.timeStamp;
            else
              this.mouseUpTime = new Date().getTime();
            this.scrollDirection = 'up';
            if (this.listenerStatus) this.wheelStart();
            return false;

          } else {
            //mouse wheel rotation downards
            if (e)
              this.mouseDownTime = e.timeStamp;
            else
              this.mouseDownTime = new Date().getTime();
            this.scrollDirection = 'down';
            if (this.listenerStatus) {
              if (this.state.items.length !== this.state.active + 1)
                this.wheelStart();
            }
            return false;
          }
        }
      }
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-changeLeafsOnScroll")
    }
  }

    commonTimeout(){
      try {
      var date = new Date(); 
      //let timeInterval = (this.scrollType === 'scroll') ? 1500 : 1000; 
      let timeInterval =  900; 
      setTimeout(()=>{
        if(this.scrollType === 'scroll'){
          if(date.getTime() >= this.currentTime || this.state.active === this.state.items.length-1 || this.state.active === 0){
            this.fail = false;
              this.setStates(true);
          }else{
              if(this.state.onWheelEnd)
                this.setStates(false);
          }
        }else{
            this.setState({
                onclickAction : true
            }, ()=>{
              ///FOR THE HANDLE SHORT CUT ISSUES ON CLICK RIGHT ARROW BECAUSE SCROLLTYPE BECOMING NULL SOME TIMES....
              this.rightKeyShortCut = false;
              this.leftKeyShortCut = false;
            });
        }
      }, timeInterval);
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-commonTimeout")
    }
    }
    wheelStart() {
      this.listenerStatus = false;
      this.stopProcess = true;
      this.wheelAct();
    }
  
    setStates(value){ 
      this.showResults = value;
      this.setState({
        onWheelEnd :value
      })
    }

    wheelAct() {
      try {
      this.scrollEnd = this.scrollOnce;
      setTimeout(() => {
        if (this.scrollEnd === this.scrollOnce) {
          this.wheelEnd();
        } else {
          if (this.scrollDirection === 'down' && this.stopProcess) {
           // if (Math.abs(this.mouseUpTime - this.mouseDownTime) > 500) {
              if(this.state.items.length !== this.state.active+1){
                this.isSceneClick=false
                this.moveRight();
                this.stopProcess = false;
              }
            //}
          } else if (this.scrollDirection === 'up' && this.stopProcess) {
           // if (Math.abs(this.mouseUpTime - this.mouseDownTime) > 500) {
              this.moveLeft();
              this.isSceneClick=false;
              this.stopProcess = false;
            //}
          }
          this.wheelAct();
        }
      },35);
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-wheelAct")
    }
    }

    wheelEnd() {
        this.listenerStatus = true,
        this.scrollEnd = 0,
        this.scrollOnce = 0;
    }
  
    moveLeft(type = null) {
      try {
      var newActive = this.state.active;
      newActive--;
      if (type === 'click') {
        this.transitionsTodiv();
        this.scrollType = 'click';
        this.workedClick = false;
        
        this.setState({
          // active: newActive < 0 ? this.state.items.length - 1 : newActive,
          active: newActive < 0 ? this.state.active : newActive,
          direction: 'left'
        })
        this.commonTimeout();
      } else {
        this.setState({
          // active: newActive < 0 ? this.state.items.length - 1 : newActive,
          active: newActive < 0 ? this.state.active : newActive,
          direction: 'left'
        })
      }
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-moveLeft")
    }
    }
  transitionsTodiv(){
      var setElement = document.getElementById('workspace');
      var elementItem = document.getElementsByClassName('item');
      if(setElement.style.transition && setElement.style.transition.includes('none')){
          setElement.style.transition = 'all 700ms ease-in-out';
         for(let j=0; j<elementItem.length; j++){
          elementItem[j].style.transition = 'all 700ms ease-in-out';
         }
      } 
  }

  workspaceOver(e, timeout){
    try {
    if(e !== "out"){
      if(this.props.isToolCropping)
      {
        e.preventDefault();
        return false;
      }
      e.stopPropagation();
    }else{
      this.setState({videoControl : false});
    }
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-workspaceOver")
  }
  }

  moveRight(type = null) {
    try {
    var newActive = this.state.active;
    if(this.props.scenes.size===1)
      newActive=-1;
    if (type === 'click') {
      this.transitionsTodiv();
      this.scrollType = 'click';
      this.workedClick = false;
      this.setState({
        active: ((newActive + 1) % this.state.items.length) === 0 ? 0 : (newActive + 1),
        direction: 'right'
      })
      this.commonTimeout();
    } else {
      this.setState({
        active: ((newActive + 1) % this.state.items.length) === 0 ? 0 : (newActive + 1),
        direction: 'right'
      })
    }
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-moveRight")
  }
  }

  isValidFileToUpload = (file) => {
    try{
      let MIM = require('mim'), upMimeType = file.type, uploadType = '';
      if(!file.type){
          let fileArr = file.name.split('.'), fileExt;
          if(fileArr.length){
              fileExt = fileArr.pop();
          }
          if(fileExt)
              upMimeType = MIM.getMIMEType(fileExt);
      }

      var _validFileExtensions = config['UPLOADS']['UP_VID'].split(',');
      for (let i = 0; i < _validFileExtensions.length; i++) {
          let sCurExtension = _validFileExtensions[i].trim();
          if (upMimeType.toLowerCase().includes(sCurExtension.toLowerCase())) {
              uploadType = 'video';
          }
      }

      _validFileExtensions = config['UPLOADS']['UP_IMG'].split(',');
      for (let j = 0; j < _validFileExtensions.length; j++) {
          let sCurExtension = _validFileExtensions[j].trim();
          if (upMimeType.toLowerCase().includes(sCurExtension.toLowerCase())) {
              uploadType = 'image';
          }
      }
      return uploadType;

    }catch(err){
      errorlog('Error in isValidFileToUpload ', err, "WorkspaceComponent-isValidFileToUpload");
    }
  }

  dropCalc = (width, height, ext, src) => {
    try{
      let originalWidth = parseInt(width, 10) * this.props.zoomFactor, dropWidth = 0, dropHeight = 0, 
      originalHeight = parseInt(height, 10) * this.props.zoomFactor, setSpace = 50, finalObj = {};

      let leastVal = Math.min(this.props.workspaceWidth * this.props.zoomFactor, this.props.workspaceHeight * this.props.zoomFactor) - setSpace;
      let aspectRatio = originalWidth / originalHeight;

      if (originalWidth > originalHeight) {
          dropWidth = leastVal;
          dropHeight = Math.round(dropWidth / aspectRatio);
      } else {
          dropHeight = leastVal;
          dropWidth = Math.round(dropHeight * aspectRatio);
      }

      var set_x, set_y, docWrkspc = document.getElementById('workspace'), index = this.props.maxIndex.size

      set_x = (docWrkspc.offsetWidth / 2) - (dropWidth / 2);
      set_y = (docWrkspc.offsetHeight / 2) - (dropHeight / 2);

      finalObj = {
        assetId: Math.random().toString(12).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString(),
        src,
        type: "UPLOADS",
        subType: "UPIMAGE",
        x: set_x / this.props.zoomFactor,
        y: set_y / this.props.zoomFactor,
        width: dropWidth / this.props.zoomFactor,
        height: dropHeight / this.props.zoomFactor,
        displaysizes: "",
        sourceType: ext,
        index,
        item_id: Math.random().toString(12).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString(),
        angle: 0,
        thumb: "",
        svgData: undefined,
        selectedScene: this.props.selectedScene,
        textData: null,
        swapDetails: null,
        emptySwap: true,
        widthRatio: null,
        heightRatio: null,
        xRatio: null,
        yRatio: null,
        isBlob: true
      }
      return finalObj;
    }catch(err){
      errorlog('Error in dropCalc ', err, "WorkspaceComponent-dropCalc");
    }
  }


  handledroppedFile = (file) => {
    try{
      if(['Branding', 'Brand Video', 'Brand Logo'].indexOf(this.props.libCurrentFolder) !== -1){
        this.props.manageToast({action : "add", type : "error", "message" : "n.a.ibr", subMessage : "pl.t.s", formatId: "both"});
        return;
      }
      if(file.type.includes('svg')){
        this.props.manageToast({action : "add", type : "error", "message" : 'svg.n.a', formatId: "msg"});
        return;
      }
      if(!this.isValidFileToUpload(file)){
        this.props.manageToast({action : "add", type : "error", "message" : 'tp.nt.su', formatId: "msg"});
        return;
      }else if (this.props.updateItems || this.props.isUploadInProcess){
        this.props.manageToast({action : "add", type : "error", "message" : 'al.up.pr', formatId: "msg"});
        return;
      }
        var URL = window.URL || window.webkitURL,
        blobSrc = URL.createObjectURL(file);
        if(file.type.match('image')){
          let name = file.name,
          lastDot = name.lastIndexOf('.'),
          ext = name.substring(lastDot + 1);

          let img = new Image();
          img.onload = (function() {
            let width = img.width,
            height = img.height;
            
            if(ext){
              let dropObj = this.dropCalc(width, height, ext, blobSrc);
              this.props.addObj(dropObj, this.props.socket);
              this.props.itemToUpdate({
                item_id : dropObj.assetId,
                selectedScene : dropObj.selectedScene,
                assetId : dropObj.assetId
              })
            }
          }).bind(this);
          img.src = blobSrc;
          
        }else if(file.type.match('video')){
          let videoElm = document.createElement('video');
          videoElm.src = blobSrc;
          videoElm.muted = true;
          videoElm.playsInline = true;
          videoElm.play();

          videoElm.addEventListener('loadedmetadata', (function(){
            let width = videoElm.videoWidth,
            height = videoElm.videoHeight,
            duration = videoElm.duration;
            
            let name = file.name,
            lastDot = name.lastIndexOf('.'),
            ext = name.substring(lastDot + 1);
              if(ext && duration){
                  let assetId = Math.random().toString(12).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
                  this.props.dropVideoBg({ 
                      assetId,
                      sourceType: ext,
                      selectedScene: this.props.selectedScene,
                      selectedItems: fromJS([]),
                      bgType: "UPVIDEO",
                      bgHeight: height,
                      bgWidth: width,
                      thumb: '',
                      source: blobSrc,
                      color: undefined,
                      hasGradient: undefined,
                      isCustomBg: false,
                      duration,
                      subType: "UPVIDEO",
                      videoDuration: duration,
                      bgFilter: "",
                      flipPosition: 0,
                      displaysizes: "",
                      isSample : true,
                      isBlob : true
                  }, [], this.props.socket);
                  this.props.itemToUpdate({
                    selectedScene : this.props.selectedScene,
                    assetId
                  })
              }
            }).bind(this))
        }
      this.props.fileToUpload(file);
    }catch(err){
      errorlog('Error in handledroppedFile ',err, "WorkspaceComponent-handledroppedFile");
    }
  }
  calculateStyles=()=>{
    var workspaceScale = this.props.zoomFactor;
    var workspaceWidth = this.props.workspaceWidth * workspaceScale, workspaceHeight = this.props.workspaceHeight * workspaceScale;

    var workspaceCX = this.props.workspaceBounds.get("cx"), workspaceCY = this.props.workspaceBounds.get("cy");
    var workspaceWidth = this.props.workspaceWidth * workspaceScale, workspaceHeight = this.props.workspaceHeight * workspaceScale;
    if (workspaceCX === undefined) {
      workspaceCX = window.innerWidth / 2;
      workspaceCY = window.innerheight / 2;
    }
    let style = { left: (this.workspaceX).toFixed(2) + "px", top: (this.workspaceY).toFixed(2) + "px", width: (workspaceWidth).toFixed(2) + "px", height: (workspaceHeight).toFixed(2) + "px", backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', border: 'none', borderStyle: 'none' };

    if (this.props.swapDetails !== null) {
      style.zIndex = "unset";
      if (this.props.swapDetails.isBG) {
        style.zIndex = 10;
      }
    }

    if (Math.round(workspaceHeight) > this.props.workspaceBounds.get("height")) {
      style.top = (this.props.workspaceBounds.get("cy") - this.props.workspaceBounds.get("height") / 2).toFixed(2) + "px";
      style.height = (this.props.workspaceBounds.get("height")).toFixed(2) + "px";
      style.overflowY = "scroll";
    }

    if (Math.round(workspaceWidth) > this.props.workspaceBounds.get("width")) {
      style.left = (this.props.workspaceBounds.get("cx") - this.props.workspaceBounds.get("width") / 2).toFixed(2) + "px";
      style.width = (this.props.workspaceBounds.get("width")).toFixed(2) + "px";
      style.overflowX = "scroll";
    }
    this.overflowStyles = { left: style.left, top: style.top, width: style.width, height: style.height, right: parseFloat(style.left) + parseFloat(style.width) + 'px', bottom: parseFloat(style.top) + parseFloat(style.height) + 'px' }

    style.backgroundColor = "#ededef";
    return style;

  }
    //For scroll scenes main generation of the leafs ......
  generateItems() {
    var items = [];
    
    var centerWorkspace = this.runTheLIst();
    let style = this.calculateStyles();
    items.push(<div key={0} id={"workspace"} className={'item level workspace work-list'} style={style}>
      {centerWorkspace}
    </div>);

    if (this.props.isPlay || this.props.isPlayAll) {
      items = [];
      items.unshift(centerWorkspace);
    }
    return items;
  }


    composedPath(el) {
        var path = [];
        while (el) {
          path.push(el);
          if (el.tagName === 'HTML') {
            path.push(document);
            path.push(window);
            return path;
          }
          el = el.parentElement;
        }
    }
    
    isMouseOn(e, value) {
      try {
        var i;
        var path_array = e.path || (e.composedPath && e.composedPath()) || this.composedPath(e.target);
        
        if (path_array.length > 0) {
          for (i = 0; i < path_array.length; i++) {
            if (path_array[i].className !== undefined && typeof (path_array[i].className) !== "object") {
    
              if (path_array[i].className.indexOf(value) !== -1) {
                return true;
              }
            }
            else if (path_array[i].className !== undefined && typeof (path_array[i].className) === "object") {
              if (path_array[i].className.animVal.indexOf(value) !== -1)
                return true;
            }
          }
        }
        return false;
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-isMouseOn")
      }
    }

    handleItemClick(e, id, type, subType, childId) {
      try{
        let existItems = this.props.selectedItems, hasThis = existItems.keyOf(id);
        var selectedItems;

        if(hasThis !== undefined && document.activeElement !== document.querySelector(`#${id} .text-container`)&&this.props.swapDetails===null){
          this.props.initiateMove({currentPosition : { x: e.clientX, y: e.clientY }});
          return;
        }
        if (hasThis === undefined) {
          selectedItems = fromJS([id]);
          if (this.ctrlPressed)
            selectedItems = existItems.push(id);
          var propData = {selectedItems : selectedItems.toArray(), currentPosition : {x : e.clientX, y : e.clientY}};
          if(selectedItems.size === 1){
            propData.type = type;
            propData.subType = subType;
          }
         
          if(propData.type === 'CHR' || propData.type === 'TEXT' || propData.type === 'DEFAULT_TEXT'){
            // this.props.suggestionPopup({
            //   show : true,
            //   type : propData.type,
            //   subType : propData.subType
            // })
          }
          if(!this.props.isPlayAll&&this.props.mode!=='slide'){
          this.props.setSelectedItems(propData, this.props.socket);
          }
          setTimeout(() => {
            if(this.props.selectedItems.size === 2){
                let nextBtn = document.querySelector('.next_step');
                if(nextBtn){
                  nextBtn.classList.remove('disable');
                }
            }
          }, 1000)
          
        }
        else if (hasThis !== undefined && this.props.selectedItems.size > 1) {
          selectedItems = existItems.delete(hasThis);
          var propData = {selectedItems : selectedItems.toArray(), currentPosition : {x : e.clientX, y : e.clientY}};
          if(selectedItems.size === 1){
            propData.type = type;
            propData.subType = subType;
          }
          this.props.setSelectedItems(propData, this.props.socket);
        }
        else if(hasThis !== undefined){
         
          if(this.props.textStatus.get("isFocused") && this.props.textStatus.get("id") !== id ){
            if(childId === undefined || this.props.textStatus.get("id") !== childId){
              if(type !== "TEXT")
                this.props.updateTextStatus({id: null, isSelected : false, isFocused : false, container : null, isRTL : false, isGrouped:false});
            }
          }
        }
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-handleItemClick")
      }
    }

      multiselectByBounds(x, y, width, height) {
   
        if(width >= 5 || height >= 5){
          let allItems = this.props.sceneData.get("workspaceItems")//.filter(function (obj, key) { 
           //return obj.get("enterStart") <= this.props.sceneData.get("playHeadValue") && obj.get("exitEnd") >= this.props.sceneData.get("playHeadValue") }.bind(this));
          let workspaceBoundsX = document.getElementById('workspace').offsetLeft, workspaceBoundsY = document.getElementById('workspace').offsetTop;
        
          allItems.entrySeq().forEach(([key, item]) => {
            let current_item_bounds = document.getElementById(key).getBoundingClientRect();
            let item_x = current_item_bounds.left - workspaceBoundsX, item_y = current_item_bounds.top - workspaceBoundsY;
            if (x < item_x + current_item_bounds.width &&
              x + width > item_x &&
              y < item_y + current_item_bounds.height &&
              height + y > item_y) {
              this.multiSelectedItems.push(key);
            }
          })
          if (this.multiSelectedItems.length > 0) {
            let selectedDetails = {selectedItems : this.multiSelectedItems};
            if(this.multiSelectedItems.length === 1){
              selectedDetails.type = this.props.sceneData.getIn(["workspaceItems", this.multiSelectedItems[0], "type"]);
              selectedDetails.subType = this.props.sceneData.getIn(["workspaceItems", this.multiSelectedItems[0], "subType"]);
            }
            this.props.setSelectedItems(selectedDetails, this.props.socket);
          }
        }
      }
    
    initiateMultiselect(e) {
      try {
      e.preventDefault();

      if(this.props.selectedItems.size > 0 && document.getElementsByClassName("selectionBox")[0]){
        let sBounds = document.getElementsByClassName("selectionBox")[0].getBoundingClientRect();
        if(e.clientX >= sBounds.x && e.clientY >= sBounds.y && sBounds.x + sBounds.width >= e.clientX && sBounds.y + sBounds.height >= e.clientY){
          this.props.initiateMove({currentPosition : {x : e.clientX, y : e.clientY}});
          this.selecting = true;
          return;
        }
      }

        let selection_overlay = document.createElement("div");
        let currentX = e.clientX - document.getElementById('workspace').offsetLeft, currentY = e.clientY - document.getElementById('workspace').offsetTop;
        let mouse_position = { x: currentX, y: currentY };
        selection_overlay.setAttribute("id", "selection-overlay");
        selection_overlay.style.left = (mouse_position.x) + "px";
        selection_overlay.style.top = (mouse_position.y) + "px";
        selection_overlay.style.width = "0px";
        selection_overlay.style.height = "0px";
        selection_overlay.style.position = "absolute";
        selection_overlay.style.border = "2px solid #c94a75";
        selection_overlay.style.backgroundColor = "rgba(201,74,117,0.5)";
        this.mouseStartPosition = Object.assign(this.mouseStartPosition, { x: mouse_position.x, y: mouse_position.y });
        document.getElementsByClassName('workspace')[0].appendChild(selection_overlay);
        this.multiSelectedItems = [];
        window.addEventListener('mousemove', this.selectingItems, false);
        window.addEventListener('mouseup', this.stopSelection, false);
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-initiateMultiselect")
      }
    }

    selectingItems(e) {
      try {
      e.preventDefault();
      let currentX = e.clientX - document.getElementById('workspace').offsetLeft, currentY = e.clientY - document.getElementById('workspace').offsetTop;
      let mouse_position = { x: currentX, y: currentY };
      let selection_overlay = document.getElementById('selection-overlay');
      if(selection_overlay !== undefined && selection_overlay !== null){
        let boundX = this.mouseStartPosition.x, boundY = this.mouseStartPosition.y;
        if (mouse_position.x < boundX)
          selection_overlay.style.left = (mouse_position.x) + "px";
    
        if (mouse_position.y < boundY)
          selection_overlay.style.top = (mouse_position.y) + "px";
    
        selection_overlay.style.width = Math.abs(mouse_position.x - boundX) + "px";
        selection_overlay.style.height = Math.abs(mouse_position.y - boundY) + "px";
      }
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-selectingItems")
    }
    }
  
    stopSelection(e) {
      try {
      e.preventDefault();
      let selection_overlay = document.getElementById('selection-overlay');
      if(selection_overlay !== undefined && selection_overlay !== null){
        let boundX = Math.round(selection_overlay.getBoundingClientRect().x - document.getElementById('workspace').offsetLeft), boundY = Math.round(selection_overlay.getBoundingClientRect().y - document.getElementById('workspace').offsetTop), boundW = Math.round(selection_overlay.getBoundingClientRect().width), boundH = Math.round(selection_overlay.getBoundingClientRect().height);
        this.multiselectByBounds(boundX, boundY, boundW, boundH);
        selection_overlay.remove();
      }
      window.removeEventListener('mousemove', this.selectingItems, false);
      window.removeEventListener('mouseup', this.stopSelection, false);
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-stopSelection")
    }
    }

    isRightMouse(e) {
      try {
      var isRightMB;
      e = e || window.event;
      if ("which" in e)
        isRightMB = e.which === 3;
      else if ("button" in e)
        isRightMB = e.button === 2;
  
      return isRightMB;
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-isRightMouse")
      }
    }

    handleSlideClick(e,link){
      e.preventDefault();
      let objLink =link;
      if((this.props.isPlayAll)&&(objLink!==undefined&&objLink!=="")){
      let curSlide=objLink.replace(/[^0-9\.]+/g, "");
      this.props.setSlideJump(curSlide);

      if (this.props.isFullScreen && this.props.isPlayAll) {
            if (this.props.t1.currentLabel() >= this.props.t1.getLabelsArray().length-1) {
              document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next-disable.svg";
              document.getElementById('nextSlide').style.cursor = 'auto';
              document.getElementById('next-slide').style.cursor = 'auto';
            }
            if (this.props.t1.currentLabel() !== null) {
              document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous.svg";
              document.getElementById('prevSlide').style.cursor = 'pointer';
              document.getElementById('previous-slide').style.cursor = 'pointer';

            }
            if (this.props.t1.currentLabel() === null) {
              document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous-disable.svg";
              document.getElementById('prevSlide').style.cursor = 'auto';
              document.getElementById('previous-slide').style.cursor = 'auto';
            }
            if (this.props.t1.currentLabel() < this.props.t1.getLabelsArray().length) {
              document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next.svg";
              document.getElementById('nextSlide').style.cursor = 'pointer';
              document.getElementById('next-slide').style.cursor = 'pointer';
            }
      }

    
     }
     else if(!this.props.isPlayAll&&this.props.isPreview&&(objLink!==undefined&&objLink!=="")){
        let curSlide=parseInt(link.replace(/[^0-9\.]+/g, ""));
        this.props.setSelectedScene(curSlide-1, this.props.scenes.getIn([curSlide-1,'startTime']), [curSlide-1], this.props.socket); 
       this.props.setScenePosition(curSlide-1,curSlide-1,this.props.project.getIn(['scenes',curSlide-1,'startTime']) , this.props.project.getIn(['scenes',curSlide-1,'duration']));

        let currentScene = this.props.currentSceneNumber;
        if(this.props.scenes.count()>1){
        
            if(currentScene < this.props.project.get('scenes').count()-1) 
                {
                document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous.svg";
                document.getElementById('prevSlide').style.cursor = 'pointer';
                document.getElementById('previous-slide').style.cursor = 'pointer';
                }
            if(currentScene+1 >= this.props.project.get('scenes').count()-1){
                document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next-disable.svg";
                document.getElementById('nextSlide').style.cursor = 'auto';
                document.getElementById('next-slide').style.cursor = 'auto';
            }
            if(currentScene< this.props.project.get('scenes').count()){
              document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next.svg";
              document.getElementById('nextSlide').style.cursor = 'pointer';
              document.getElementById('next-slide').style.cursor = 'pointer';
            }
            if(currentScene===0 || currentScene ===1 || currentScene ===null){
              document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous-disable.svg";
              document.getElementById('prevSlide').style.cursor = 'auto';
              document.getElementById('previous-slide').style.cursor = 'auto';
            }
          
          }
           
     }

    }

    handleMouseDown(e) {
      try {
        if (!this.props.isPlay && !this.props.isPlayAll && this.props.mode !== 'slide') {
            var stateToUpdate = {};
            if (this.props.selectedItems.size === 0) {
                if (this.state.contextMenu) {
                  stateToUpdate.contextMenu = false;
                }
            }

            if(this.state.isZoomDropped){
              stateToUpdate.isZoomDropped = false;
            }
            
            if (Object.keys(stateToUpdate).length !== 0 && stateToUpdate.constructor === Object) {
                this.setState(stateToUpdate);
            }
           
            if((!this.isMouseOn(e, "bg-container") && !this.isMouseOn(e, "video-container") )&& !this.isMouseOn(e,'filter-bg') && !this.isMouseOn(e,'bg-crop') && !this.isMouseOn(e,'swap-bg')&& !this.isMouseOn(e,'flip-bg') && !this.isMouseOn(e,'remove-bg')  && !this.isMouseOn(e,'delete-bg') && !this.isMouseOn(e,'bg-toggle') &&  !this.isMouseOn(e,'tick-bg') && !this.isMouseOn(e,'bgvideo-close')&& !this.isMouseOn(e,'color-bg') ) {
              if((this.props.sceneData.getIn(['workspaceBG','src']) !== "")  ||  (this.props.sceneData.getIn(["workspaceBG" , "type"]) === "UPVIDEO" || this.props.sceneData.getIn(["workspaceBG" , "type"]) === "STOCKVID" || this.props.sceneData.getIn(["workspaceBG" , "type"]) === "VIDEO")){
                this.setState({bgToolActive:false})
              }
            }

            if(this.isMouseOn(e,'tick-bg') || this.isMouseOn(e,'bgvideo-close'))
            {
              this.setState({isBgToolExpanded : false});
            }
            
            if(((this.isMouseOn(e, "bg-container") || this.isMouseOn(e, "video-container"))|| this.isMouseOn(e, "bg-video"))|| this.isMouseOn(e,'filter-bg')|| this.isMouseOn(e,'bg-crop') || this.isMouseOn(e,'swap-bg') || this.isMouseOn(e,'flip-bg') || this.isMouseOn(e,'remove-bg')  || this.isMouseOn(e,'delete-bg') || this.isMouseOn(e,'bg-toggle') || this.isMouseOn(e,'tick-bg') || this.isMouseOn(e,'bgvideo-close') || this.isMouseOn(e,'color-bg')){
              if(this.props.sceneData.getIn(['workspaceBG','src']) !== "" ||  (this.props.sceneData.getIn(["workspaceBG" , "type"]) === "UPVIDEO" || this.props.sceneData.getIn(["workspaceBG" , "type"]) === "STOCKVID" || this.props.sceneData.getIn(["workspaceBG" , "type"]) === "VIDEO")){
                this.setState({bgToolActive:true})
              }
            }

           
            if (!this.isMouseOn(e, "popup-component") && !this.isMouseOn(e, "editicon-container") && !this.isMouseOn(e, "bezier-path") && !this.isMouseOn(e, "scene-item") && !this.isMouseOn(e, "tool-bar") && !this.isMouseOn(e, "handle") && !this.isMouseOn(e, "keyframe-item") && !this.isMouseOn(e, "selectionBox") && !this.isMouseOn(e, "cropBox") && !this.isMouseOn(e, "cropSelectionBox") && !this.isMouseOn(e, "unCroppedBox") && !this.isMouseOn(e, "slide-dropdown")) {
              
                if(this.props.isToolCropping)
                  this.props.toggleBgCrop();
                if(this.props.propertyWindow.get("component") === "bgColor" || this.props.propertyWindow.get("component") === "animate" || this.props.propertyWindow.get("component") === "color")
                {
                  this.props.setPropertyWindow({component:''})
                //   this.props.suggestionPopup({
                //     show : false,
                //     type : '',
                //     subType : ''
                // })
                }
                if (this.props.selectedItems.size > 0) {

                    var elements = document.querySelectorAll(".type-scr");
                    for (var i = 0; i < elements.length; i++) {
                        elements[i].style.display = "none";
                    }
                    if(this.props.swapDetails!==null){
                      this.props.undoProp.isBG===true?
                      this.props.dropBG({selectedScene:this.props.selectedScene, value:this.props.undoProp, socket:this.props.socket, deleteId :'', deletedData:[], subType : "BG_SETTINGS"}):
                      this.props.addObj(this.props.undoProp, this.props.socket);
                      this.props.swapItem("");
                      this.props.swapItemUndo("");
                    }
                    this.props.setSelectedItems({selectedItems : [],  currentPosition : {x : e.clientX, y : e.clientY}}, this.props.socket);
                  //  this.props.suggestionPopup({
                  //     show : false,
                  //     type : '',
                  //     subType : ''
                  // })
                  
                    if(this.isRightMouse(e)){
                      this.setState({contextMenu : true, isContextBg : true});
                      const clickX = e.clientX;
                      const clickY = e.clientY;
                      const screenW = window.innerWidth;
                      const screenH = window.innerHeight;
                      const cmWidth = this.contextMenu.offsetWidth;
                      const cmHeight = this.contextMenu.offsetHeight;
              
                      const right = (screenW - clickX) > cmWidth;
                      const left = !right;
                      const top = (screenH - clickY) > cmHeight;
                      const bottom = !top;
              
                      if (right) { this.contextMenu.style.left = `${clickX + 5}px`; }
                      if (left) { this.contextMenu.style.left = `${clickX - cmWidth - 5}px`; }
                      if (top) { this.contextMenu.style.top = `${clickY + 5}px`; }
                      if (bottom) { this.contextMenu.style.top = `${clickY - cmHeight - 5}px`; }
                    }
                }
                else {
                  if(!this.isRightMouse(e)){
                   
                   if((this.props.sceneData.getIn(['workspaceBG','src']) === "" ) && (this.isMouseOn(e, "bg-container")))
                    {
                      if(this.props.isToolCropping)
                        this.props.toggleBgCrop();
                        this.props.setPropertyWindow({component: "bgColor"});
                   }
                    

                  }
                  else{
                    this.setState({contextMenu : true, isContextBg : true});
                    const clickX = e.clientX;
                    const clickY = e.clientY;
                    const screenW = window.innerWidth;
                    const screenH = window.innerHeight;
                    const cmWidth = this.contextMenu.offsetWidth;
                    const cmHeight = this.contextMenu.offsetHeight;
            
                    const right = (screenW - clickX) > cmWidth;
                    const left = !right;
                    const top = (screenH - clickY) > cmHeight;
                    const bottom = !top;
            
                    if (right) { this.contextMenu.style.left = `${clickX + 5}px`; }
                    if (left) { this.contextMenu.style.left = `${clickX - cmWidth - 5}px`; }
                    if (top) { this.contextMenu.style.top = `${clickY + 5}px`; }
                    if (bottom) { this.contextMenu.style.top = `${clickY - cmHeight - 5}px`; }
                  }
                }

                  this.initiateMultiselect(e);
               
        }
        
    }
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-handleMouseDown")
  }
  }

  openLink=(e,link)=>{
      e.preventDefault(); 
      if(!link.match("^Slide")){
               
            let linkVal=link;
            const newWindow = (linkVal.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null)? window.open('/','_self'):window.open('/');

            if (linkVal.indexOf("https://") !== 0&&linkVal.indexOf("http://") !== 0){
              if(linkVal.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null)
              linkVal='mailto:' + linkVal;
              else
              linkVal='http://' + linkVal;


             }
        
              newWindow.location=linkVal;    
        }
       
  }

    getItem(item, key, groupId, sceneData){
        var innerElem = null;
        var configPath = this.assetUrl+config[item.get("type")][config[item.get("type")][(item.get('subType')) ? 'workspace_' + item.get('subType') : 'workspace']];
        var onLoadPath = this.assetUrl+config[item.get("type")][config[item.get("type")][(item.get('subType')) ? 'onload_' + item.get('subType') : 'onload']];
        let innerStyle = {};
        
        if(item.get('subType') === 'EPROP' || item.get('subType') === 'GETTYICON'){
          configPath = this.assetUrl+config[item.get('subType')][config[item.get("subType")]['workspace']];
          onLoadPath = this.assetUrl+config[item.get("subType")][config[item.get("subType")]['workspace']];
        }
        if(item.get("type") === "UPLOADS"){
          configPath = config[item.get("type")][config[item.get("type")][(item.get('subType')) ? 'workspace_' + item.get('subType') : 'workspace']];
          onLoadPath = config[item.get("type")][config[item.get("type")][(item.get('subType')) ? 'onload_' + item.get('subType') : 'workspace']];
        }
        if(item.get("subType") === "GIPHY"){
          configPath = config[item.get("subType")][config[item.get("subType")]['workspace']];
          onLoadPath = config[item.get("subType")][config[item.get("subType")]['onload']];
        }
        else if(item.get("type") === "STOCKIMG"  || item.get("type") === "PEXELS"|| item.get("type") === "PIXABAY" || item.get("type") === "UNSPLASH"){
          configPath = "";
          onLoadPath = "";
        }
        else if(item.get('subType') === 'OBGIMG' || item.get('subType') === 'OBGVID'){
          configPath = this.assetUrl+config["BG"]['obgsrc'];
          onLoadPath = this.assetUrl+ config['BG']['obgsrc'];
        }
        else if(item.get("type") === "CHR"){
          if(item.get('subType') === 'CCHR' || item.get('subType') === 'ECHR')
            configPath =this.assetUrl+ config[item.get("subType")][config[item.get("subType")]['workspace']];
          else
            configPath =this.assetUrl+ config[item.get("type")][config[item.get("type")]['workspace']];
            
          onLoadPath = "";
        }
        if(item.get('subType') === 'GRAD'){
          configPath = this.assetUrl+config[item.get('subType')][config[item.get("subType")]['workspace']];
          onLoadPath = this.assetUrl+config[item.get("subType")][config[item.get("subType")]['workspace']];
        }

        var parentItem;
        if(groupId !== undefined){
          parentItem = this.props.sceneData.getIn(["workspaceItems", groupId]);
        }
        let isHyperlinkClickable = ( // sometimes browser initiates some default behaviour when dragging transform manager, so mount anchor tags only when required
        this.props.isPlay
        || this.props.isPlayAll
        || this.props.isPreview
        || this.props.isFullScreen
      );

        switch(item.get("type")){
            case "IMG":
            case "UPLOADS":
            case "STOCKIMG":
            case "PEXELS":
            case "PIXABAY":
            case "GIPHY":
            case "UNSPLASH":
            if(item.get("isCropped")){
              
              innerStyle.left = (item.getIn(["original", "x"]) * item.get("width")) * this.props.zoomFactor + "px";
              innerStyle.top = (item.getIn(["original", "y"]) * item.get("height")) * this.props.zoomFactor + "px";
              innerStyle.width = (item.getIn(["original", "width"]) * item.get("width")) * this.props.zoomFactor + "px";
              innerStyle.height = (item.getIn(["original", "height"]) * item.get("height")) * this.props.zoomFactor + "px";
            
            }
            if(item.get('isBlob')){
              configPath = '';
              onLoadPath = '';
            }
            if(item.get('type') === 'UPLOADS' && item.get('sourceType') && item.get('sourceType').includes('svg') && item.get('colors')){
              innerElem = <CustomSVGRender key = {key} uploadSVG={true} parentId={item.get('parentId')} charId={item.get("charId")} scenStart={sceneData.get("startTime")} workspaceWidth={this.props.workspaceWidth} workspaceHeight={this.props.workspaceHeight} animakerType = {this.props.animakerType} parentItem = {parentItem} completeWorkspaceItems={item} startPlay={this.props.startPlay} addTween={this.props.addTween} workspaceItems={this.props.sceneData.get("workspaceItems")} changePlayTime={this.props.changePlayTime} playHeadValue={this.props.playHeadValue} pose={item.get("pose")} expression={item.get("expression")} zoomFactor = {this.props.zoomFactor} assetType={item.get("type")} assetSubType={item.get("subType")} data_id={key} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} key={key} selectedItems={this.props.selectedItems} src={configPath + item.get("src")} colors={item.get("colors")} parts={item.get("parts")} animdata={item.get("animdata")} swapDetails = {this.props.swapDetails} animsrc={configPath + item.get("animsrc")} expFlag={item.get("expFlag")} isRepeated={item.get("isRepeated")} isAnimated={item.get("isAnimated")} repeatLoop={item.get("repeatLoop")} mouthAction={item.get("mouthAction")} socket={this.props.socket} updateItem={this.props.updateItem} selectedScene={this.props.selectedScene}/>
            }else{
              innerElem = <ProgressiveImage src={configPath + item.get("src")} placeholder={onLoadPath + item.get("thumb")}>
                          {(image, loading) =>
                          {
                            if (isHyperlinkClickable && item.get('link') && item.getIn('link') !== '') {
                              return <a href={item.get('link')} target="_blank" onClick={(e) => { ((!this.props.isPlayAll && this.props.mode !== 'slide') || (item.get('link').match("^Slide"))) ? this.handleSlideClick(e, item.get('link')) : this.openLink(e, item.get('link')); }} style={{ pointerEvents: 'auto' }}><img alt="scene-items" data-id={key} src={image} className={"scene-item-inner"} style={{ ...innerStyle, filter: (item.get("filter") !== undefined && item.get("filter") !== "" && item.get("filter") !== "6464646464640032") ? `url(#filter_${key}_${item.get("filter")})` : null }} /></a>
                            }
                            else {
                              return <img alt="scene-items" data-id={key} src={image} className={"scene-item-inner"} style={{ ...innerStyle, filter: (item.get("filter") !== undefined && item.get("filter") !== "" && item.get("filter") !== "6464646464640032") ? `url(#filter_${key}_${item.get("filter")})` : null }} />
                            }
                          }
                        }
                        </ProgressiveImage>
            }
            break;
            case "TEXT":
                var itemId = null;
                if(groupId !== undefined)
                {
                  itemId = key;
                  key = groupId; 
                }
                if(item.get("subType") === "BANNER"){
                innerElem =  <Callout key = {key} startPlay={this.props.startPlay} selectedScene = {this.props.selectedScene} data={item} itemId={key} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} data_id = {key} itemId = {itemId} isGrouped = {groupId !== undefined} parentItem = {parentItem} zoomFactor = {this.props.zoomFactor} workspaceItems={this.props.sceneData.get("workspaceItems")} animakerType = {this.props.animakerType} playHeadValue={this.props.playHeadValue} selectedItems={this.props.selectedItems} socket = {this.props.socket}/>
                }
                else {
                  if(isHyperlinkClickable && item.getIn(['textData','link'])!==''&&item.getIn(['textData','link'])!==undefined&&item.getIn(['textData','htmlText']).indexOf('href') === -1 ){
                    innerElem = <a href={item.getIn(['textData','link'])} style={{textDecorationColor:item.getIn(["textData", "formats", "containerStyle","color"])}} target="_blank" onClick={(e)=>{((!this.props.isPlayAll&&this.props.mode!=='slide')||(item.getIn(['textData','link']).match("^Slide")))?e.preventDefault():this.openLink(e,item.getIn(['textData','link']));}}><Text text = {item} key ={key} linkEnabled = {false} data_id = {key} itemId = {itemId} currentScene = {this.props.selectedScene} isGrouped = {groupId !== undefined} socket={this.props.socket}/></a>

                  }
                  else
                   innerElem = <Text text = {item} key ={key} linkEnabled = {false} data_id = {key} itemId = {itemId} currentScene = {this.props.selectedScene} isGrouped = {groupId !== undefined} socket={this.props.socket}/>
                }
              
            break;
           
            case "CCHR":
            case "CHR":
            case "PROP":
            case "OVLYSVG":
            case "SHAPE":
            if(item.get("type") === "SHAPE"){
              var itemId = null;
              if(groupId !== undefined)
                {
                  itemId = key;
                  key = groupId; 
                }
                innerElem =  <Callout startPlay={this.props.startPlay} key = {key} selectedScene = {this.props.selectedScene} data={item} itemId={key} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} data_id = {key} itemId = {itemId} isGrouped = {groupId !== undefined} parentItem = {parentItem} zoomFactor = {this.props.zoomFactor} workspaceItems={this.props.sceneData.get("workspaceItems")} animakerType = {this.props.animakerType} playHeadValue={this.props.playHeadValue} selectedItems={this.props.selectedItems} socket = {this.props.socket}/>
            }else{        
              let canPlayAnimation = item.get("isAnimated");
              if (!this.props.isPlay && !this.props.isPlayAll) {
                canPlayAnimation = groupId === undefined && item.get("isAnimated"); // dont play animation when a group child is selected
              }      
              if(isHyperlinkClickable && item.get('link')&&item.get('link')!==''){
                innerElem =  <a href={item.get('link')} target="_blank" onClick={(e)=>{((!this.props.isPlayAll&&this.props.mode!=='slide')||((item.get('link').match("^Slide"))))?this.handleSlideClick(e,item.get('link')):this.openLink(e,item.get('link'));}} ><CustomSVGRender key = {key} link={item.get('link')} uploadSVG={false} parentId={item.get('parentId')} charId={item.get("charId")} scenStart={sceneData.get("startTime")} workspaceWidth={this.props.workspaceWidth} workspaceHeight={this.props.workspaceHeight} animakerType = {this.props.animakerType} parentItem = {parentItem} completeWorkspaceItems={item} startPlay={this.props.startPlay} addTween={this.props.addTween} workspaceItems={this.props.sceneData.get("workspaceItems")} changePlayTime={this.props.changePlayTime} playHeadValue={this.props.playHeadValue} pose={item.get("pose")} expression={item.get("expression")} zoomFactor = {this.props.zoomFactor} assetType={item.get("type")} assetSubType={item.get("subType")} data_id={key} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} key={key} selectedItems={this.props.selectedItems} src={configPath + item.get("src")} colors={item.get("colors")} parts={item.get("parts")} animdata={item.get("animdata")} swapDetails = {this.props.swapDetails} animsrc={configPath + item.get("animsrc")} expFlag={item.get("expFlag")} isRepeated={item.get("isRepeated")} isAnimated={canPlayAnimation} repeatLoop={item.get("repeatLoop")} mouthAction={item.get("mouthAction")} socket={this.props.socket} updateItem={this.props.updateItem} selectedScene={this.props.selectedScene} mode={this.props.mode}/></a>
                }
                else{
                  innerElem= <CustomSVGRender key = {key} link={item.get('link')} uploadSVG={false} parentId={item.get('parentId')} charId={item.get("charId")} scenStart={sceneData.get("startTime")} workspaceWidth={this.props.workspaceWidth} workspaceHeight={this.props.workspaceHeight} animakerType = {this.props.animakerType} parentItem = {parentItem} completeWorkspaceItems={item} startPlay={this.props.startPlay} addTween={this.props.addTween} workspaceItems={this.props.sceneData.get("workspaceItems")} changePlayTime={this.props.changePlayTime} playHeadValue={this.props.playHeadValue} pose={item.get("pose")} expression={item.get("expression")} zoomFactor = {this.props.zoomFactor} assetType={item.get("type")} assetSubType={item.get("subType")} data_id={key} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} key={key} selectedItems={this.props.selectedItems} src={configPath + item.get("src")} colors={item.get("colors")} parts={item.get("parts")} animdata={item.get("animdata")} swapDetails = {this.props.swapDetails} animsrc={configPath + item.get("animsrc")} expFlag={item.get("expFlag")} isRepeated={item.get("isRepeated")} isAnimated={canPlayAnimation} repeatLoop={item.get("repeatLoop")} mouthAction={item.get("mouthAction")} socket={this.props.socket} updateItem={this.props.updateItem} selectedScene={this.props.selectedScene}/>;
                }
            }
            break;
            case "FRAME":
              innerElem = <Frames key={key} id={key} frameItem={item} grouped={groupId? true: false} groupId={groupId} isPlay = {this.props.isPlay} isPlayAll = {this.props.isPlayAll} setPlay = {this.props.setPlay} socket={this.props.socket} frameCount = {undefined} isFullScreen = {this.props.isFullScreen}/>
              
              if(isHyperlinkClickable && item.get('link')&&item.get('link')!==''){
                innerElem = <a style={{pointerEvents: 'auto'}} href={item.get('link')} target="_blank" onClick={(e)=>{((!this.props.isPlayAll&&this.props.mode!=='slide')||((item.get('link').match("^Slide"))))?this.handleSlideClick(e,item.get('link')):this.openLink(e,item.get('link'));}} >{innerElem}</a>
              }
            break;
            case "GRID":
              innerElem = <Grid key={key} id={key} gridItemData={item} grouped={groupId ? true : false} groupId={groupId} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} setPlay={this.props.setPlay} socket={this.props.socket} slide={this.props.selectedScene} selectedItems={this.props.selectedItems} browserName={this.props.browserName} zoomFactor={this.props.zoomFactor} />

              if(isHyperlinkClickable && item.get('link')&&item.get('link')!==''){
                innerElem = <a style={{pointerEvents: 'auto'}} href={item.get('link')} target="_blank" onClick={(e)=>{((!this.props.isPlayAll&&this.props.mode!=='slide')||((item.get('link').match("^Slide"))))?this.handleSlideClick(e,item.get('link')):this.openLink(e,item.get('link'));}} >{innerElem}</a>
              }
            break;
            default :
                innerElem = "none";
            break;
        }
        
        return innerElem;
    }

  setAsBg(){
    try {
    if(this.props.selectedItems.size === 1){
      let selectedItem = this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]), subType,isBlob = false;
     
      let bgType = selectedItem.get("type");
      if(bgType !== "STOCKIMG" && bgType !== "PEXELS" && bgType !== "UNSPLASH" && bgType !== "PIXABAY" && bgType !== 'IMG' && selectedItem.get("subType") !== undefined && selectedItem.get("subType") !== "" && selectedItem.get("subType") !== null)
        bgType = selectedItem.get("subType");
      
      if(bgType === "STOCKIMG" || bgType === 'IMG')
        subType = selectedItem.get("subType");
      

      if(bgType === "PEXELS" || bgType === "PIXABAY" || bgType === "UNSPLASH") {
        subType = selectedItem.get("subType");
      }

      if(selectedItem.get("subType") === "GIPHY"){
        bgType = selectedItem.get("subType");
      }
  
      
      let bgFilter = "";
      
      if(this.props.sceneData.getIn(["workspaceBG", "bgFilter"]) !== "")
        bgFilter = "";
      if(selectedItem.get("filter") !== undefined && selectedItem.get("filter") !== "")
        bgFilter = selectedItem.get("filter");
    
        if(selectedItem.get('isBlob')){
          isBlob = true;
        }

        this.props.changeBg({selectedScene : this.props.selectedScene, selectedItems : this.props.selectedItems, isBlob, assetId : selectedItem.get("assetId"), stockId : selectedItem.get("assetId"), bgType : bgType, subType : subType, sourceType : selectedItem.get("sourceType"), bgHeight : document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalHeight, bgWidth : document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalWidth, source : selectedItem.get("src"), thumb : selectedItem.get("thumb"), color : [], isCustomBg : true, bgFilter : bgFilter, flipPosition : selectedItem.get("flipPosition")}, this.props.socket);
      }
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-setAsBg")
    }
  }

  pasteItem(e){
    try {
    e.stopPropagation();
    this.setState({contextMenu : false, isContextBg : false});
    if(!this.props.textStatus.get("isFocused")){
      var toPaste = this.props.copiedItem;
      if(!this.props.updateItems){
        let isInProcess = false,
        wrkspcItems = toPaste.data.workspaceItems;
        for(let i=0; i<wrkspcItems.length; i++){
          if(wrkspcItems[i].isBlob){
            isInProcess = true;
            break;
          }
        }
        if(isInProcess){
            this.props.manageToast({action : "add", type : "error", "message" : 'ct.dup', formatId: "msg"});
            return;
        }
      }
  
      if(toPaste !== null){
        toPaste.selectedScene = this.props.selectedScene;
        this.props.pasteItems(toPaste, this.props.socket);
      }
    }else{
      document.execCommand("paste");
    }
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-pasteItem")
  }
  }
 
  workspaceItemsAssembler(workspaceItems, workspaceChildren, workspaceScale, sceneData) {
    var workspaceObjects = [], svgFilters =[];
    if (workspaceItems.size > 0) {
      workspaceItems.entrySeq().forEach(([key, value]) => {
        var flip = getFlipPosition(value.get("flipPosition")), item = null;
        
        var item_styles = { transform: "translate(" + parseFloat((value.get("x") * workspaceScale).toFixed(2)) + "px, " + parseFloat((value.get("y") * workspaceScale).toFixed(2)) + "px) rotateZ(" + value.get("angle") + "deg)" + flip, position: "absolute", width: parseFloat((value.get("width") * workspaceScale).toFixed(2)), height: parseFloat((value.get("height") * workspaceScale).toFixed(2)), overflow : "hidden" };
        if(value.get('opacity') !== undefined)
          item_styles.opacity = value.get('opacity');
        let isHidden = false;
        // if (this.props.isPlay || this.props.isPlayAll || (value.get('enterStart') <= this.props.sceneData.get("playHeadValue") && value.get('exitEnd') >= this.props.sceneData.get("playHeadValue") && ((value.get('isVisible') === undefined || value.get('isVisible')) ))){
          item_styles.willChange = "transform, opacity";
          item_styles.opacity = value.get('opacity');

        if (this.props.swapDetails !== null && this.props.swapDetails.id === key)
          item_styles.zIndex = 10;

     
        if (value.get("type") !== "GROUP" && value.get("type") !== "TXTOVLY") {
        
            

          if ((!this.props.isCropping && !this.props.isFraming) || key !== this.props.selectedItems.get(0)) {
            let filterValue = {};

            var itemKey = key;

            if ((value.get("type") === "IMG" || value.get("type") === "STOCKIMG" || value.get("type") === "PEXELS" || value.get("type") === "PIXABAY" || value.get("type") === "UNSPLASH" || (value.get("type") === "UPLOADS" && value.get("subType") === "UPIMAGE")) && value.get("isCropped")) {
              let cropPosition = { left: (value.getIn(["original", "x"]) * value.get("width")) * this.props.zoomFactor + "px", top: (value.getIn(["original", "y"]) * value.get("height")) * this.props.zoomFactor + "px", width: (value.getIn(["original", "width"]) * value.get("width")) * this.props.zoomFactor + "px", height: (value.getIn(["original", "height"]) * value.get("height")) * this.props.zoomFactor + "px" };

              Object.assign(filterValue, cropPosition);

              item_styles.overflow = "hidden";
              // itemKey += Math.random();
            }

            if (value.get("type") === "FRAME") {
              item_styles.overflow = "hidden";
              item_styles.WebkitClipPath = "url(#clip-" + key + ")";
              item_styles.clipPath = "url(#clip-" + key + ")";
            }

            if (value.get("type") === "TEXT" || value.get("type") === "SHAPE") {
              item_styles.overflow = "unset";
            }
            if (value.get("type") === "CHR")
              value = value.setIn(["parentId"], key)


            item = this.getItem(value, key, undefined, sceneData);
          }
          if (value.get("type") === "IMG" || (value.get("type") === "UPLOADS" || value.get("type") === "UPIMAGE") || value.get("type") === "STOCKIMG" || value.get("type") === "PEXELS" || value.get("type") === "PIXABAY" || value.get("type") === "UNSPLASH" ){
            let vignetteItemId = key + "-vignette-" + this.props.selectedScene;
            
            svgFilters.push(
              <svg className="image-filter" id={`svgFilter_${key}`} key={key + "-vignette-" + this.props.selectedScene}>
                <defs>
                    <filter colorInterpolationFilters="sRGB" id={`filter_${key}_${value.get("filter")}`}>
                        
                        <ReturnSvgFilter data-id={key} filterCode={(value.get("filter") === "")? "6464646464640032": value.get("filter") } vignetteId={vignetteItemId}/>
                    </filter>
                </defs>
              </svg>
            );
          }
        }
        else {
          var groupElements = [];
            item = [];
            value.get("groupChildren").entrySeq().forEach(([childKey, itemId]) => {

              let childItem = workspaceChildren.get(itemId);
            
              var groupItemX = parseFloat((childItem.get("x") - value.get("x")) * workspaceScale).toFixed(2), groupItemY = parseFloat((childItem.get("y") - value.get("y")) * workspaceScale).toFixed(2), groupItemWidth = parseFloat(childItem.get("width") * workspaceScale).toFixed(2), groupItemHeight = parseFloat(childItem.get("height") * workspaceScale).toFixed(2);

              var flip = getFlipPosition(childItem.get("flipPosition"));

              var groupStyle = {willChange:"transform", transform: "translate(" + groupItemX + "px, " + groupItemY + "px) rotateZ(" + childItem.get("angle") + "deg)"+flip, position: "absolute", width: groupItemWidth + "px", height: groupItemHeight + "px", overflow : "hidden" };
              
              if(childItem.get('opacity') !== undefined)
                groupStyle.opacity = childItem.get('opacity');
              
              let filterValue = {};
              
              let itemKey = key + "-" + itemId;
              if (childItem.get("type") === "IMG" || childItem.get("type") === "STOCKIMG" || childItem.get("type") === "PEXELS" || childItem.get("type") === "PIXABAY" || childItem.get("type") === "UNSPLASH") {
                if (childItem.get("isCropped")) {
                  let cropPosition = { left: (childItem.getIn(["original", "x"]) * childItem.get("width")) * this.props.zoomFactor + "px", top: (childItem.getIn(["original", "y"]) * childItem.get("height")) * this.props.zoomFactor + "px", width: (childItem.getIn(["original", "width"]) * childItem.get("width")) * this.props.zoomFactor + "px", height: (childItem.getIn(["original", "height"]) * childItem.get("height")) * this.props.zoomFactor + "px" };

                  Object.assign(filterValue, cropPosition);
                  groupStyle.overflow = "hidden";
                  
                }
              }

              if (childItem.get("type") === "FRAME") {
                groupStyle.overflow = "hidden";
                groupStyle.WebkitClipPath = "url(#clip-" + itemId + ")";
                groupStyle.clipPath = "url(#clip-" + itemId + ")";
              }

              if (childItem.get("type") === "TEXT" || childItem.get("type") === "SHAPE") {
                groupStyle.overflow = "unset";
                item_styles.overflow = "unset";
              }
             
              if (childItem.get("type") === "CHR")
                childItem = childItem.setIn(["parentId"], itemId)


              groupElements.push(
                <div key={key + "-" + itemId} onMouseDown={(e) => this.handleItemClick(e, key, childItem.get("type"), childItem.get("subType"), itemId)} id={itemId} data-id={key} data-group-id={itemId} data-elem_id={childItem.get("elem_id")} className={"scene-item group-scene-item type-" + childItem.get("type").toLowerCase() + " tintCls"} style={groupStyle}>
                  {
                    this.getItem(childItem, itemId, key, sceneData)
                  }
                </div>
              );
              if (childItem.get("type") === "IMG" || (childItem.get("type") === "UPLOADS" && childItem.get("subType") === "UPIMAGE") ||childItem.get("type") === "STOCKIMG" || childItem.get("type") === "PEXELS" || childItem.get("type") === "PIXABAY" || childItem.get("type") === "UNSPLASH" ){
                let vignetteItemId = itemId + "-vignette-" + this.props.selectedScene;
                svgFilters.push(
                  <svg className="image-filter" id={`svgFilter_${itemId}`}>
                    <defs>
                        <filter colorInterpolationFilters="sRGB" id={"filter_"+ itemId +"_" + childItem.get("filter")}>
                            
                            <ReturnSvgFilter data-id={itemId} filterCode={ (childItem.get("filter") === "")? "6464646464640032": childItem.get("filter") } vignetteId={vignetteItemId}/>
                        </filter>
                    </defs>
                  </svg>
                );
              }

            });
          

          item = groupElements;
        }


        let vignetteContainer = [];
        let loaderElem ;

        var collaborateClass = "";
        if(this.props.selectedItems.size === 0 && !this.props.isPlay && !this.props.isPlayAll){
          this.props.connections.entrySeq().forEach(([keyVal, connectDetail]) => {
            if(connectDetail.get("selectedItems") === key)      
            {
              collaborateClass = " colSelected";
              var rightPosition = this.rotatedPosition(value.get("x"), value.get("y"), value.get("width"), value.get("height"), value.get("angle") * (Math.PI / 180));
              
              this.collaborativeUsers.push(<div key = "outline" className = "collaborative-user-selection" data-html2canvas-ignore="true" style = {{position:"absolute", left : (value.get("x") * this.props.zoomFactor) + "px", top : (value.get("y") * this.props.zoomFactor) + "px", width : (value.get("width") * this.props.zoomFactor) + "px", height : (value.get("height") * this.props.zoomFactor) + "px", transform : "rotate("+ value.get("angle") +"deg)", boxShadow : "0px 0px 0px 2px rgba(0,0,0,0.1)", display : item_styles.display, opacity : !isHidden?1:0}}><span style = {{backgroundColor : connectDetail.get("color")}}></span><span style = {{backgroundColor : connectDetail.get("color")}}></span><span style = {{backgroundColor : connectDetail.get("color")}}></span><span style = {{backgroundColor : connectDetail.get("color")}}></span></div>);

              this.collaborativeUsers.push(<span key = "user-name" data-html2canvas-ignore="true" style = {{position:"absolute", left : (rightPosition.x * this.props.zoomFactor) + "px", top : (rightPosition.y * this.props.zoomFactor) - 30 + "px", backgroundColor : connectDetail.get("color"), padding : "4px 10px", borderRadius : "2px", pointerEvents : "none", display : "inline-table", opacity : !isHidden?1:0}}>{connectDetail.get("projectUsr")}</span>);
            }

          });
        }

        if(value.get("type") === "IMG" || value.get("type") === "STOCKIMG" || value.get("type") === "UPLOADS" || value.get("type") === "PEXELS" || value.get("type") === "PIXABAY" || value.get("type") === "UNSPLASH")
          vignetteContainer.push(<div key={key + "-vignette"} id={key + "-vignette-" + this.props.selectedScene} className="vignette"></div>);

          if(value.get("type")==="GROUP" && value.get("subType")==="TXTGRP" && key === this.props.selectedItems.get(0)){
            loaderElem= <img className="loader-img" alt="loader" src={this.appUrl + "/images/chr-loading.svg"} style={{ width: "100%", height: "100%", objectFit: "scale-down" ,display:this.props.isfontLoadedTxtGrp?'block':'none',zIndex:"2"}} />   
         }
        workspaceObjects.push(<div key={key} id={key} data-id={key} onMouseDown={(e) => (value.get("type") !== "GROUP" || !this.props.textStatus.get("isFocused"))?this.handleItemClick(e, key, value.get("type"), value.get("subType")):false} data-elem_id={value.get("elem_id")} className={"scene-item type-" + value.get("type").toLowerCase() + " tintCls" + collaborateClass} style={item_styles} >{loaderElem}{vignetteContainer}{item}</div>);
      });
    }
    return [workspaceObjects, svgFilters];
  }

  highlightItem(value){
    if(value !== false && !this.props.textStatus.get("isFocused") && this.props.selectedItems.size === 0){ 
      let ix = (this.props.workspaceBounds.get("cx") - (this.props.workspaceWidth * this.props.zoomFactor) / 2) + (value.get("x") * this.props.zoomFactor);
      let iy = (this.props.workspaceBounds.get("cy") - (this.props.workspaceHeight * this.props.zoomFactor) / 2) + (value.get("y") * this.props.zoomFactor);
      document.getElementById("highlighter").style.display = "block";
      document.getElementById("highlighter").style.left = ix+"px";
      document.getElementById("highlighter").style.top = iy+"px";
      document.getElementById("highlighter").style.width = (value.get("width") * this.props.zoomFactor)+"px";
      document.getElementById("highlighter").style.height = (value.get("height") * this.props.zoomFactor)+"px";
      document.getElementById("highlighter").style.transform = "rotatez("+ value.get("angle") +"deg)";
    }else{
      document.getElementById("highlighter").style.display = "none";
    }
  }

  workspaceBGColorAssembler(workspaceBG,bgStyles){
   
    var bgColors = [];
    var bgColor = workspaceBG.get("color");
    if(bgColor !== undefined && bgColor.size > 0){
      if(bgColor.size > 1){
          var gradient, isRadial = workspaceBG.get("isRadial"), gradientType = "linear";
          if(isRadial === undefined || !isRadial)
            gradient = (workspaceBG.get("direction") !== undefined)?"to " + workspaceBG.get("direction")+", ":"to right, ";
          else {

            gradient = "";
            gradientType = "radial";

            if (workspaceBG.get("radius") !== "")
              bgColor = bgColor.set(0, bgColor.get(0) + " " + workspaceBG.get("radius") + "%");

          }
          
          bgColor.map(function(color, index){
            gradient += color+", ";
          });

          bgStyles.backgroundImage = gradientType+"-gradient("+ gradient.replace(/,\s*$/, "") +")";
        
      }else{
       
          bgStyles.backgroundColor = bgColor.get(0);//(workspaceBG.get("src") === undefined || workspaceBG.get("src") === null || workspaceBG.get("src") === "")?bgColor.get(0):"#ededef";
      }

      bgColors.push(<div key="color" className="bg-container" style={bgStyles}></div>);
      bgColors.push(<div key="bgPreview" className="bg-container bg-preview" id="bgWrkspcPreview" style={bgStyles}></div>)
      return bgColors;
    }
    else
    {
      bgStyles.backgroundColor = "#ffffff";
      bgColors.push(<div key="color" className="bg-container" style={bgStyles}></div>);
      bgColors.push(<div key="bgPreview" className="bg-container bg-preview" id="bgWrkspcPreview" style={bgStyles}></div>)
      return bgColors;
    }
  }

  enableBgSettings(e){
    try {
    e.stopPropagation();
      this.initiateMultiselect(e);
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-enableBgSettings")
    } 
  }

  enableBgColor(e){
    try {
    e.stopPropagation();
    if(this.props.isToolCropping)
      this.props.toggleBgCrop();
    this.props.setPropertyWindow({component: "bgColor"});
      if(!this.props.videoTool&&!this.props.isFullScreen)
      this.initiateMultiselect(e);
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-enableBgColor")
    }
  }

    controlVideo(){
      try {
      this.setState((state, props) => ({
        isFullScrVideoplay : true
      }))
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-controlVideo")
    }
    }

    playPausevideo(event){
      try {
      event.stopPropagation()
      // let video=document.getElementById('bg-video-'+videoIndex);
          let videoIndex=event.target.dataset.id;
         if(document.getElementById('bg-video-'+videoIndex).paused||document.getElementById('bg-video-'+videoIndex).ended){
           if(this.state.seekValue > 0){
            document.getElementById('bg-video-'+videoIndex).currentTime = this.state.seekValue;
           }
           else{
          document.getElementById('bg-video-'+videoIndex).currentTime = this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoStart"]); 
           }
            document.getElementById('bg-video-'+videoIndex).play();
            this.setState({isFullScrVideoplay:true});
         }
         else{
           document.getElementById('bg-video-'+videoIndex).pause();
            this.setState({isFullScrVideoplay:false});
         }
        } catch (error) {
          //Error Severity: LOW
          errorlog(error, error.message, "WorkspaceComponent-playPausevideo")
        }
    
    }

    videoTimeUpdate(e){
      try {
      let videoIndex=this.state.currentSceneNumber;
      let currentTime = e.target.currentTime;
      if(currentTime >= this.props.project.getIn(['scenes',this.state.currentSceneNumber,'workspaceBG','videoEnd']) && e.target.dataset.id === this.state.currentSceneNumber){
      this.setState({isFullScrVideoplay:false})
      }
      if(e.target.dataset.id !== videoIndex){
        currentTime = 0 ;
      }
      this.setState({seekValue : currentTime});
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-videoTimeUpdate")
    }
    }

    changeVideoTime(e){
      try {
      let currentTime = e.target.value;
      let videoIndex=this.state.currentSceneNumber;
      if(this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoStart"]) && currentTime < this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoStart"])){
        currentTime = this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoStart"]);
        e.target.currentTime = currentTime;
        document.getElementById("bg-video-"+videoIndex).pause();
      }
      
      if(this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoEnd"]) && currentTime >= this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoEnd"])){
        currentTime = this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoStart"])?this.props.project.getIn(['scenes',this.state.currentSceneNumber,"workspaceBG", "videoStart"]):0;
        e.target.currentTime = currentTime;
        document.getElementById("bg-video-"+videoIndex).pause();
      }
      document.getElementById("bg-video-"+videoIndex).currentTime = currentTime;
      this.setState({seekValue : currentTime});
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-changeVideoTime")
    }
    }

    videoLoaded(e){
    try {
    let videoIndex=this.state.currentSceneNumber;

      if(this.props.sceneData.getIn(["workspaceBG", "videoStart"]))
        document.getElementById("bg-video-"+videoIndex).currentTime = this.props.sceneData.getIn(["workspaceBG", "videoStart"]);
      if(this.props.sceneData.getIn(["workspaceBG", "volume"]))
        document.getElementById("bg-video-"+videoIndex).volume = this.props.sceneData.getIn(["workspaceBG", "volume"]) / 100;
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-videoLoaded")
    }
    }

    secondsToHms(d) {
      d = Number(d);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);
  
      var mDisplay = m > 0 ? m + (m === 1 ? "" : "") : "";
      var sDisplay = s > 0 ? s + (s === 1 ? "" : "") : "";
      if(sDisplay !== null && sDisplay.length >=1){
          sDisplay =  sDisplay.length > 1 ? sDisplay : '0'+sDisplay;
      }else{
          sDisplay = '00';
      }
      if(mDisplay !== null && mDisplay !== ""){
          mDisplay =  mDisplay.length > 1 ? mDisplay : '0'+mDisplay;
      }else{
          mDisplay = '00';
      }
      return mDisplay+':'+sDisplay; 
  }
  
    seekOver(e, min, max){
      try {
      if(e !== "out"){
        let cont = document.getElementsByClassName("seek-container")[0].getBoundingClientRect();
        let contX = (e.clientX - cont.x) - 10;
        let contW = cont.width - 20;
        if(contX >= 0 && contX <= contW){
          let currentTime = ((contX/contW) * (max - min));
          this.setState({seekTime : this.secondsToHms(currentTime), seekX : contX - 10});
        }else{
          this.setState({seekTime : null, seekX : null});
        }
      }
      else{
        this.setState({seekTime : null, seekX : null});
      }
     } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-seekOver")
    }
    }
    changeVideoIndex=(index)=>{
      if(index !== undefined)
      {
        setTimeout(()=>{this.setState({currentSceneNumber:index,isFullScrVideoplay:false})},0)
      }

    }
    runTheLIst(){
      
      let workspaceObjects = [], workspaceScale = this.props.zoomFactor;
      var workspaceDisplay = null;
      if (this.props.sceneData !== undefined && this.props.sceneData.size > 0) {

        var sceneData = this.props.sceneData, bgStyles = {}, bgItems = [], bgColors = [], onLoadBg = null, bgImgStyles = {}, configBasePath = null;
        var workspaceWidth = this.props.workspaceWidth * workspaceScale, workspaceHeight = this.props.workspaceHeight * workspaceScale;
        bgStyles = { position: "absolute", width: workspaceWidth + 'px', height: workspaceHeight + 'px', overflow: 'hidden' };
        var workspaceBG = sceneData.get("workspaceBG");
      
       
        bgStyles.backgroundColor = sceneData.getIn(["workspaceBG", "color"]);
        bgItems.push(<div key="color" className="bg-container" style={bgStyles}></div>);
       
        var sceneData = this.props.sceneData, bgStyles = {}, bgItems = [], onLoadBg = null, bgImgStyles = {}, configBasePath = null;
        var workspaceWidth = this.props.workspaceWidth * workspaceScale, workspaceHeight = this.props.workspaceHeight * workspaceScale;
        var workspaceCX = this.props.workspaceBounds.get("cx"), workspaceCY = this.props.workspaceBounds.get("cy");
        if(workspaceCX === undefined){
          workspaceCX = window.innerWidth / 2;
          workspaceCY = window.innerHeight / 2;
        }
        this.workspaceX = (workspaceCX - workspaceWidth / 2);
        this.workspaceY = (workspaceCY - workspaceHeight / 2);
        let svgFilters = [];
       
        bgStyles = { position: "absolute", width: (workspaceWidth).toFixed(2) +'px', height: (workspaceHeight).toFixed(2) +'px', overflow:'hidden'};
        
        if(workspaceBG !== undefined){
          bgColors = this.workspaceBGColorAssembler(workspaceBG,bgStyles);

          if (workspaceBG.get("src") !== undefined && workspaceBG.get("src") !== null && workspaceBG.get("src") !== "") {
            
            let mediaBgStyles = {};
            
            mediaBgStyles.position = "absolute";
            mediaBgStyles.overflow = "hidden";
           
            mediaBgStyles.width = (this.props.workspaceWidth  * this.props.zoomFactor).toFixed(2) + "px";
            mediaBgStyles.height = (this.props.workspaceHeight * this.props.zoomFactor).toFixed(2) + "px";

            var flip = getFlipPosition(workspaceBG.get("flipPosition"), workspaceBG.get("angle"));
            var bgAngle = workspaceBG.get("angle") !== undefined ? workspaceBG.get("angle") : 0;

            let bgImgStyles = { willChange: "transform, opacity",width: (this.props.workspaceWidth * workspaceBG.get("width") * workspaceScale).toFixed(2) + 'px', height: (this.props.workspaceHeight * workspaceBG.get("height") * workspaceScale).toFixed(2) + 'px', transform: 'translate(' + (this.props.workspaceWidth * workspaceBG.get("x") * workspaceScale).toFixed(2) + 'px, ' + (this.props.workspaceHeight * workspaceBG.get("y") * workspaceScale).toFixed(2) + 'px) rotate('+ bgAngle +'deg)' + flip};

            let bgType = workspaceBG.get("type" || bgType === "PEXELS" || bgType === "PIXABAY" || bgType === "UNSPLASH" || bgType === "IMAGE");
            
            if(bgType === "STOCKIMG"){
              onLoadBg = workspaceBG.get('thumbnail');
              configBasePath = "";
            }
            else if (bgType !== "UPLOADS") {
              
              if(bgType === 'UPVIDEO'){
                let typrToSet = 'UPLOADS';
                onLoadBg = config[typrToSet][config[typrToSet].onload_UPVIDEO]+ workspaceBG.get('thumbnail');
                configBasePath = config[typrToSet][config[typrToSet].workspace_UPVIDEO];
                if(workspaceBG.get('isBlob')){
                  configBasePath = "";
                  onLoadBg = `${config['APPICONS'][config['APPICONS']['current']]}/images/chr-loading.svg`;
                }
              }
              else if(bgType === 'UPIMAGE'){
                let typrToSet = 'UPLOADS';
                onLoadBg = config[typrToSet][config[typrToSet].onload_UPIMAGE] + workspaceBG.get('thumbnail');
                configBasePath = config[typrToSet][config[typrToSet].workspace_UPIMAGE];
              }
              else if(bgType==="BG"){
              onLoadBg = this.assetUrl+ config[bgType][config[bgType].onload] + workspaceBG.get('thumbnail');
              configBasePath = this.assetUrl+config[bgType][config[bgType].workspace];
              }
              else if(workspaceBG.get('subType') === 'OBGIMG' || workspaceBG.get('subType') === 'OBGVID'){
                  onLoadBg = this.assetUrl+ config['BG']['obgsrc'] + workspaceBG.get('src');
                  if(workspaceBG.get('subType') === 'OBGVID') onLoadBg = this.assetUrl+ config['BG']['obgsrc'] + workspaceBG.get('thumbnail');
                  configBasePath = this.assetUrl+config["BG"]['obgsrc'];
              }else{
                  onLoadBg = config[bgType][config[bgType].onload] + workspaceBG.get('thumbnail');
                  configBasePath = config[bgType][config[bgType].workspace]; 
              }
            }
            else{
              onLoadBg = this.assetUrl+ config[bgType][config[bgType].onload_IMG] + workspaceBG.get('thumbnail');
              configBasePath =this.assetUrl+ config[bgType][config[bgType].workspace_IMG];
            }
            let backgroundSource = configBasePath + workspaceBG.get('src');
            if(workspaceBG.get('isBlob')){
              backgroundSource = workspaceBG.get('src');
            }
            if(bgType === 'UPVIDEO'){
              if(workspaceBG.get('displaysizes')){
                backgroundSource = backgroundSource.substr(0, backgroundSource.lastIndexOf(".")) + ".mp4";
              }
            }
              mediaBgStyles.backgroundRepeat = 'no-repeat';
              mediaBgStyles.backgroundPosition = 'center center';
              mediaBgStyles.backgroundSize = 'cover';
              mediaBgStyles.display = 'block';
              mediaBgStyles.filter = "";
              

              // if(workspaceBG.get("bgFilter") !== undefined && workspaceBG.get("bgFilter") !== ""){

                // mediaBgStyles.filter = "brightness(" + (parseInt(workspaceBG.get("bgFilter").substr(2,2),16)) + "%) contrast(" + (parseInt(workspaceBG.get("bgFilter").substr(4,2),16)) + "%) hue-rotate(" + parseInt(workspaceBG.get("bgFilter").substr(6,3),16) + "deg) blur(" + parseInt(workspaceBG.get("bgFilter").substr(14,2),16) + "px) saturate(" + (parseInt(workspaceBG.get("bgFilter").substr(9,2),16)) + "%";
               
                let vignetteItemId = "ws-vignette-" + this.props.selectedScene;
                svgFilters.push(
                  <svg className="image-filter" id={`svgFilter_${sceneData.get("id")}`} key={"vignette-" + this.props.selectedScene} style={this.props.browserName.get(1) === "Firefox"?{width:"0", height : "0", display:"block"}:{display : "none"}}>
                    <defs>
                        <filter colorInterpolationFilters="sRGB" id={"filter_"+ sceneData.get("id") + "_"+ workspaceBG.get("bgFilter")}>
                            
                            <ReturnSvgFilter data-id={this.props.sceneData.get("id")} filterCode={(workspaceBG.get("bgFilter") === "")? "6464646464640032": workspaceBG.get("bgFilter") } vignetteId={vignetteItemId}/>
                        </filter>
                    </defs>
                  </svg>
                );
    
                
                
              // }

              if(this.props.isBgCropping)
                mediaBgStyles.display = "none";
              if(this.props.isToolCropping)
                mediaBgStyles.overflow = "unset";
              let isVideo = workspaceBG.get("type") === "VIDEO" || workspaceBG.get("type") === "STOCKVID" || workspaceBG.get("type") === "UPVIDEO" || workspaceBG.get("type") === "ZOOM";
              if(!isVideo){
                let bgSource ;
                if((workspaceBG.get("type") === "BG") && workspaceBG.get('subType') !== 'OBGIMG'){
                  
                  bgSource = <CustomBGRender key={workspaceBG.get("assetId") + workspaceBG.get("bgFilter")} completeWorkspaceItems={sceneData} assetType="BG" proxyImg={onLoadBg} data_id={"scenebg" + this.props.selectedScene} bgImgStyles = {{...bgImgStyles, filter: workspaceBG.get("bgFilter") || workspaceBG.get("bgFilter") !== ""?`url(#filter_${sceneData.get("id")}_${workspaceBG.get("bgFilter")})`:null}} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} key={key} src={backgroundSource} colors={workspaceBG.get("bgColor")} hasGradient={workspaceBG.get("hasGradient")}/>
                  bgItems.push(<div key={"bg-img-"+workspaceBG.get("assetId")} className="bg-container tintCls" style={mediaBgStyles}><div id={"ws-vignette-" + this.props.selectedScene} className="vignette"></div>{bgSource}</div>);
                  
                }else{
                  bgSource = <ProgressiveImage src={backgroundSource} placeholder={onLoadBg}>
                    {(image) => <img alt="bg" className="bg-image" key={workspaceBG.get('src')} src={image} style={{...bgImgStyles, filter: workspaceBG.get("bgFilter") || workspaceBG.get("bgFilter") !== ""?`url(#filter_${sceneData.get("id")}_${workspaceBG.get("bgFilter")})`:null}} />}
                  </ProgressiveImage>
                  bgItems.push(<div key={"bg-img-"+workspaceBG.get("assetId")} className="bg-container tintCls" style={mediaBgStyles}><div id={"ws-vignette-" + this.props.selectedScene} className="vignette"></div> {bgSource}</div>);
                }
                let bgPreview = document.getElementById('bgWrkspcPreview');
                if(bgPreview)
                  bgPreview.style.display = 'none';
              }
              else{ 
                bgImgStyles.position = "absolute";
                let bgSource;
               
                  bgSource = <video key={"bg-img-"+workspaceBG.get("assetId")} preload="auto" id={"workspacebg" + this.props.selectedScene} className={"bg-video "+workspaceBG.get('type')} style={{...bgImgStyles, filter: workspaceBG.get("bgFilter") || workspaceBG.get("bgFilter") !== ""?`url(#filter_${sceneData.get("id")}_${workspaceBG.get("bgFilter")})`:null}} poster={onLoadBg} src={backgroundSource} onMouseDown = {(e) => {this.enableBgSettings(e)}} ></video>

                bgItems.push(<div key={"bg-img-"+workspaceBG.get("assetId")} className="video-container tintCls bg-video-index" style={mediaBgStyles}><div style={{pointerEvents:'auto'}} id={"ws-vignette-" + this.props.selectedScene} className="vignette"></div>
                              <img alt="bg" className="bg-image" src={onLoadBg} style={{...bgImgStyles, filter: workspaceBG.get("bgFilter") || workspaceBG.get("bgFilter") !== ""?`url(#filter_${sceneData.get("id")}_${workspaceBG.get("bgFilter")})`:null}} />
                              
                              {bgSource}
                            </div>);
              
            }
          }
        }

      
          
            var workspaceItems = [], workspaceChildren = [], scenes = [], playAllScene = [], transitions = [];
            if (this.props.isPlayAll) {
              for (var j = this.props.scenes.size - 1; j >= 0; j--) {
                let sceneData = this.props.scenes.get(j);
                workspaceItems = sceneData.get("workspaceItems");
                workspaceChildren = sceneData.get("workspaceChildren");
                let workspaceBG = sceneData.get("workspaceBG");
                bgColors = []
                bgStyles = { position: "absolute", width: workspaceWidth +'px', height: workspaceHeight +'px', overflow:'hidden'};

                bgItems=[]


              

                var workspaceBG = sceneData.get("workspaceBG");
                if(workspaceBG !== undefined){
                  bgColors = this.workspaceBGColorAssembler(workspaceBG,bgStyles);
        
                  if (workspaceBG.get("src") !== undefined && workspaceBG.get("src") !== null && workspaceBG.get("src") !== "") {
                    
                    
                    let mediaBgStyles = {};

                    mediaBgStyles.position = "absolute";
                    mediaBgStyles.overflow = "hidden";
                  
                    mediaBgStyles.width = (this.props.workspaceWidth  * this.props.zoomFactor) + "px";
                    mediaBgStyles.height = (this.props.workspaceHeight * this.props.zoomFactor) + "px";
                    
                    var flip = getFlipPosition(workspaceBG.get("flipPosition"), workspaceBG.get("angle"));
                    var bgAngle = workspaceBG.get("angle") !== undefined ? workspaceBG.get("angle") : 0;
        
                    let bgImgStyles = { width: (this.props.workspaceWidth * workspaceBG.get("width") * workspaceScale) + 'px', height: (this.props.workspaceHeight * workspaceBG.get("height") * workspaceScale) + 'px', transform: 'translate(' + (this.props.workspaceWidth * workspaceBG.get("x") * workspaceScale) + 'px, ' + (this.props.workspaceHeight * workspaceBG.get("y") * workspaceScale) + 'px) rotate('+ bgAngle +'deg)' + flip};

                    if(this.props.workspaceHeight * workspaceScale > this.props.workspaceBounds.get("height")){
                      bgImgStyles.height = (this.props.workspaceBounds.get("height") * workspaceBG.get("height")) + "px";
                    }
                    
                    if(this.props.workspaceWidth * workspaceScale > this.props.workspaceBounds.get("width")){
                      bgImgStyles.width = (this.props.workspaceBounds.get("width") * workspaceBG.get("width")) + "px";
                    }
        
                    if(this.props.isPlay || this.props.isPlayAll)
                    mediaBgStyles.opacity = 1;

                    {
                      let bgType = workspaceBG.get("type");
                      if(bgType === "STOCKIMG" || bgType === "PEXELS" || bgType === "PIXABAY" || bgType === "UNSPLASH"){
                        onLoadBg = workspaceBG.get('thumbnail');
                        configBasePath = "";
                      }
                      
                      else if (bgType !== "UPLOADS") {
                        
                        if(bgType === 'UPVIDEO'){
                          let typrToSet = 'UPLOADS';
                          onLoadBg = config[typrToSet][config[typrToSet].onload_UPVIDEO]+ workspaceBG.get('thumbnail');
                          configBasePath = config[typrToSet][config[typrToSet].workspace_UPVIDEO];
                          if(workspaceBG.get('isBlob')){
                            onLoadBg = workspaceBG.get('thumbnail');
                            configBasePath = "";
                          }
                        }
                        else if(bgType === 'UPIMAGE'){
                          let typrToSet = 'UPLOADS';
                          onLoadBg = config[typrToSet][config[typrToSet].onload_UPIMAGE] + workspaceBG.get('thumbnail');
                          configBasePath = config[typrToSet][config[typrToSet].workspace_UPIMAGE];
                        }
                        else if(bgType==="BG"){
                          onLoadBg = this.assetUrl+ config[bgType][config[bgType].onload] + workspaceBG.get('thumbnail');
                          configBasePath = this.assetUrl+config[bgType][config[bgType].workspace];
                        }
                        else if(workspaceBG.get('subType') === 'OBGIMG' || workspaceBG.get('subType') === 'OBGVID'){
                          onLoadBg = this.assetUrl+ config['BG']['obgsrc'] + workspaceBG.get('src');
                          configBasePath = this.assetUrl+config["BG"]['obgsrc'];
                      }
                        else{
                          onLoadBg = config[bgType][config[bgType].onload] + workspaceBG.get('thumbnail');
                          configBasePath = config[bgType][config[bgType].workspace];
                        }
                      }
                      
                      else{
                        onLoadBg = this.assetUrl+ config[bgType][config[bgType].onload_IMG] + workspaceBG.get('thumbnail');
                        configBasePath =this.assetUrl+ config[bgType][config[bgType].workspace_IMG];
                      }
                      let backgroundSource = configBasePath + workspaceBG.get('src');
                      if(bgType === 'UPVIDEO'){
                        if(workspaceBG.get('displaysizes')){
                          backgroundSource = backgroundSource.substr(0, backgroundSource.lastIndexOf(".")) + ".mp4";
                        }
                      }
        
                      mediaBgStyles.backgroundRepeat = 'no-repeat';
                      mediaBgStyles.backgroundPosition = 'center center';
                      mediaBgStyles.backgroundSize = 'cover';
                      mediaBgStyles.filter = "";
                      let svgFilters = null;

                      if(workspaceBG.get("bgFilter") !== undefined && workspaceBG.get("bgFilter") !== ""){
                        let vignetteItemId = "ws-vignette-" + j;
                        svgFilters = <svg className="image-filter" id={`svgFilter_${sceneData.get("id")}`} key={"vignette-" + j} style={this.props.browserName.get(1) === "Firefox"?{width:"0", height : "0", display:"block"}:{display : "none"}}>
                            <defs>
                                <filter colorInterpolationFilters="sRGB" id={"filter_" + sceneData.get("id") + "_" + workspaceBG.get("bgFilter")}>
                                    
                                    <ReturnSvgFilter data-id={j} filterCode={(workspaceBG.get("bgFilter") === "")? "6464646464640032": workspaceBG.get("bgFilter") } vignetteId={vignetteItemId}/>
                                </filter>
                            </defs>
                          </svg>
                      }
                      let isVideo = workspaceBG.get("type") === "VIDEO" || workspaceBG.get("type") === "STOCKVID" || workspaceBG.get("type") === "UPVIDEO" || workspaceBG.get("type") === "ZOOM";
                   
      
                      if(!isVideo){
                        let bgSource = (workspaceBG.get("type") === "BG" && workspaceBG.get('subType') !== "OBGIMG")?<CustomBGRender completeWorkspaceItems={sceneData} assetType="BG" data_id={"scenebg" + this.props.selectedScene} bgImgStyles = {{...bgImgStyles, filter: workspaceBG.get("bgFilter") || workspaceBG.get("bgFilter") !== ""?`url(#filter_${sceneData.get("id")}_${workspaceBG.get("bgFilter")})`:null}}  isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} key={key} src={backgroundSource} colors={workspaceBG.get("bgColor")} hasGradient={workspaceBG.get("hasGradient")}/>:<ProgressiveImage src={backgroundSource} placeholder={onLoadBg}>{(image) => <img alt="bg" className="bg-image" key={workspaceBG.get('src')} src={image} style={{...bgImgStyles, filter: workspaceBG.get("bgFilter") || workspaceBG.get("bgFilter") !== ""?`url(#filter_${sceneData.get("id")}_${workspaceBG.get("bgFilter")})`:null}} />}</ProgressiveImage>
        
                        bgItems.push(<div key={workspaceBG.get('src')} className="bg-container tintCls" style={mediaBgStyles}><div id={"ws-vignette-" + this.props.selectedScene} className="vignette"></div>{svgFilters}{bgSource}</div>);
                      }
                      else{
   
                                   
                        let bgSource =<video preload="auto" id={"bg-video-"+j} data-id={j} className={"bg-video "+workspaceBG.get('type')} style={{...bgImgStyles, filter: workspaceBG.get("bgFilter") || workspaceBG.get("bgFilter") !== ""?`url(#filter_${sceneData.get("id")}_${workspaceBG.get("bgFilter")})`:null}} poster={onLoadBg} src={backgroundSource}  onPlay={this.controlVideo}  onTimeUpdate = {this.videoTimeUpdate}></video>

                        bgItems.push(<div key={workspaceBG.get("isBlob")?"blob":workspaceBG.get('src')} className="video-container tintCls" style={mediaBgStyles}  ><div id={"ws-vignette-" + this.props.selectedScene} className="vignette"></div>
                                     
                                {svgFilters}
                                {bgSource}
                                
                                </div>);
                      }

                    }
                  }
                }

                workspaceObjects = this.workspaceItemsAssembler(workspaceItems, workspaceChildren, workspaceScale, sceneData);
               
                
                let playControl = null, seekBar = null;
                let videoControls = [];
                if(sceneData.getIn(['workspaceBG','type'])=== "VIDEO" || sceneData.getIn(['workspaceBG','type']) === "STOCKVID" || sceneData.getIn(['workspaceBG','type']) === "UPVIDEO" || sceneData.getIn(['workspaceBG','type']) === "ZOOM"){
                // playControl = <img key="video-tool-play" id={'video-tool-play'+j} data-id={j} className = {"video-tool-play"} style = {{opacity :'1',pointerEvents:'auto'}} onMouseMove={(e)=>{clearInterval(this.videoFullscreenTimer)}} onMouseOver={(e) => {e.stopPropagation();}} 
                // onClick = {this.playPausevideo.bind(this)} alt = "play-control"  src = {this.appUrl + "/images/player_2_0/scene-"+ (this.state.isFullScrVideoplay ? "pause" : "play") +".svg"} />;
                // seekBar = <div key="video-tool-seek" id={'video-tool-seek'+j} className = {"seek-container"} style = {{opacity :'1',pointerEvents:'auto'}} onClick = {(e) => {e.stopPropagation(); }}  onMouseMoveCapture = {(e) => {e.stopPropagation();this.seekOver(e, sceneData.getIn(["workspaceBG", "videoStart"])?sceneData.getIn(["workspaceBG", "videoStart"]):0, sceneData.getIn(["workspaceBG", "videoEnd"])?sceneData.getIn(["workspaceBG", "videoEnd"]):sceneData.getIn(["workspaceBG", "duration"]))}} onMouseOutCapture ={(e)=>{e.stopPropagation();this.seekOver("out")}} onMouseMove={(e)=>{clearInterval(this.videoFullscreenTimer)}} onMouseDown = {(e) => {e.stopPropagation()}} ><input id="seek-bar" type="range" step="any" min={sceneData.getIn(["workspaceBG", "videoStart"])?sceneData.getIn(["workspaceBG", "videoStart"]):0} defaultValue = {sceneData.getIn(["workspaceBG", "videoStart"])?sceneData.getIn(["workspaceBG", "videoStart"]):0} value = {this.state.seekValue} max={sceneData.getIn(["workspaceBG", "videoEnd"])?sceneData.getIn(["workspaceBG", "videoEnd"]):sceneData.getIn(["workspaceBG", "duration"])} onChange ={this.changeVideoTime}  onMouseMove={(e)=>{e.stopPropagation()}}></input>{this.state.seekTime !== null?<div style={{left : this.state.seekX +"px"}} className = "seek-time">{this.state.seekTime}</div>:null}</div>
                  videoControls = <div data-id={j} id={'video-controls-' + j} style={{width:"100%", height:"100%"}} onMouseMove={(e) => {if(this.state.currentSceneNumber !== e.target.dataset.id)this.setState({currentSceneNumber : e.target.dataset.id})}} onMouseOver={(e)=>{this.handleFullScreenMouseOver(e)}} onMouseOut={(e)=>{this.handleFullScreenMouseOut(e)}} >
                    <img key="video-tool-play" id={'video-tool-play' + j} data-id={j} className={"video-tool-play"} style={{ opacity: '1', pointerEvents: 'auto' }} onMouseMove={(e) => { clearInterval(this.videoFullscreenTimer) }} 
                      onClick={this.playPausevideo.bind(this)} alt="play-control" src={this.appUrl + "/images/player_2_0/scene-" + (this.state.isFullScrVideoplay ? "pause" : "play") + ".svg"} />
                    <div key="video-tool-seek" id={'video-tool-seek' + j} className={"seek-container"} style={{ opacity: '1', pointerEvents: 'auto' }} onClick={(e) => { e.stopPropagation(); }} onMouseMoveCapture={(e) => { e.stopPropagation(); this.seekOver(e, sceneData.getIn(["workspaceBG", "videoStart"]) ? sceneData.getIn(["workspaceBG", "videoStart"]) : 0, sceneData.getIn(["workspaceBG", "videoEnd"]) ? sceneData.getIn(["workspaceBG", "videoEnd"]) : sceneData.getIn(["workspaceBG", "duration"]))}} onMouseOutCapture={(e) => { e.stopPropagation(); this.seekOver("out") }} onMouseMove={(e) => { clearInterval(this.videoFullscreenTimer) }} onMouseDown={(e) => { e.stopPropagation() }}>
                      <input id="seek-bar" type="range" step="any" min={sceneData.getIn(["workspaceBG", "videoStart"]) ? sceneData.getIn(["workspaceBG", "videoStart"]) : 0} defaultValue={sceneData.getIn(["workspaceBG", "videoStart"]) ? sceneData.getIn(["workspaceBG", "videoStart"]) : 0} value={this.state.seekValue} max={sceneData.getIn(["workspaceBG", "videoEnd"]) ? sceneData.getIn(["workspaceBG", "videoEnd"]) : sceneData.getIn(["workspaceBG", "duration"])} onChange={this.changeVideoTime} onMouseMove={(e) => { e.stopPropagation()}} >
                      </input>{this.state.seekTime !== null ? <div style={{ left: this.state.seekX + "px" }} className="seek-time">{this.state.seekTime}</div> : null}
                      </div>
                  </div>
                }
              
                scenes.push(
                  <div id={"scene" + j} key={"scene" + j} style={{ width: "100%", height: "100%", position: "absolute", overflow: "hidden" }}>
                    <div className="scenes pointer-events-none">
                      {bgColors}
                      {bgItems}
                     
                      {workspaceObjects[0]}

                    </div>
                    <div className="svg-filters pointer-events-none" style={this.props.browserName.get(1) === "Firefox"?{width:"0", height : "0", display:"block"}:{display : "none"}}>
                      {workspaceObjects[1]}
                    </div>
                    {videoControls}
                  </div>);
          
                var item = fromJS({
                  "angle": 0,
                  "animdata": sceneData.get("transEffect") + ".json",//"scene-transition1.json",
                  "assetId": "scenetransition" + j,
                  "colors": sceneData.get("transColor") ? sceneData.get("transColor"):{},
                  "defaultColor": {},
                  "enterEffectName": "no_Effect",
                  "enterEnd":0,
                  "enterStart":sceneData.get("startTime")+sceneData.get("duration"),
                  "expression": "happy",
                  "src": sceneData.get("transEffect") + ".svg",//"scene-transition1.svg",
                  "flipPosition": 0,
                  "height": this.props.workspaceHeight,
                  "index": 0,
                  "thumb": "",
                  "type": "SCREEN",
                  "voiceOver": {},
                  "width": this.props.workspaceWidth,
                  "x": 0,
                  "y": 0
                })

                var item_styles = {willChange : "transform, opacity",transform: "translate(" + parseFloat((item.get("x") * workspaceScale).toFixed(2)) + "px, " + parseFloat((item.get("y") * workspaceScale).toFixed(2)) + "px)", position: "absolute", width: parseFloat((item.get("width") * workspaceScale).toFixed(2)), height: parseFloat((item.get("height") * workspaceScale).toFixed(2)) , visibility:'hidden',pointerEvents:'none' };

                if(sceneData.get("transEffect") && sceneData.get("transEffect").indexOf("tr-") !== -1)
                  transitions.push(<div key={"scenetransition" + j} id={"scenetransition" + j} data-id={"scenetransition" + j} className={"scene-item type-" + "screen" + " tintCls"} style={item_styles}><CustomSVGRender scenStart={sceneData.get("startTime")} uploadSVG={false} workspaceWidth={this.props.workspaceWidth} workspaceHeight={this.props.workspaceHeight} animakerType = {this.props.animakerType} parentItem = {null} completeWorkspaceItems={item} startPlay={this.props.startPlay} addTween={this.props.addTween} workspaceItems={this.props.sceneData.get("workspaceItems")} changePlayTime={this.props.changePlayTime} playHeadValue={this.props.playHeadValue} pose={item.get("pose")} expression={item.get("expression")} zoomFactor = {this.props.zoomFactor} assetType={item.get("type")} data_id={"scenetransition" + j} isPlay={this.props.isPlay} isPlayAll={this.props.isPlayAll} key={"scenetransition" + j} selectedItems={this.props.selectedItems} src={this.assetUrl + config["SCREEN"]["src"] + (this.props.workspaceWidth > this.props.workspaceHeight?"horizontal":this.props.workspaceHeight > this.props.workspaceWidth?"vertical":"square") + "/" + item.get("src")} colors={item.get("colors")} parts={item.get("parts")} animdata={item.get("animdata")} swapDetails = {this.props.swapDetails} animsrc={item.get("animsrc")} expFlag={item.get("expFlag")} isRepeated={item.get("isRepeated")} isAnimated={item.get("isAnimated")} repeatLoop={item.get("repeatLoop")} mouthAction={item.get("mouthAction")} socket={this.props.socket} updateItem={this.props.updateItem} selectedScene={this.props.selectedScene}/></div>)
                
              }
           
              playAllScene.push(
                <div key="player-main" style={{ width: "100%", height: "100%", position: "relative" }}>
                  <div id="video-container" style={{ width: "100%", height: "100%", position: "absolute", overflow: "hidden" }}>
                    {/* {videoItems} */}
                  </div>
                  {scenes}
                
                    
                    
                  {transitions}
                </div>)
            }
            else {
              workspaceItems = this.props.sceneData.get("workspaceItems");
              workspaceChildren = this.props.sceneData.get("workspaceChildren");
              this.collaborativeUsers = [];
              workspaceObjects = this.workspaceItemsAssembler(workspaceItems, workspaceChildren, workspaceScale, sceneData);
            }
          
            let transformManagers = [];
            if(!this.props.isCropping && (!this.props.isBgCropping || this.props.isToolCropping) && !this.props.isFraming && !this.props.isVideoCropping && !this.props.isPlayAll && !this.props.isPlay){
              if(this.props.selectedItems.size > 0 || this.props.selectedCamera !== "" || this.props.isToolCropping){
                
                let selectedObjects = (this.props.selectedItems.size>0)?this.props.sceneData.get("workspaceItems").filter(function(obj, key){return this.props.selectedItems.keyOf(key) !== undefined;}.bind(this)):(this.props.selectedCamera !== "")?this.props.sceneData.get("workspaceCameras").filter(function(obj, key){return this.props.selectedCamera === key;}.bind(this)):null;
                if(this.props.isToolCropping){
                  let workspaceBg = this.props.sceneData.get("workspaceBG");
                  let croppedBg = {x : workspaceBg.get("x") * this.props.workspaceWidth, y : workspaceBg.get("y") * this.props.workspaceHeight, width : workspaceBg.get("width") * this.props.workspaceWidth, height : workspaceBg.get("height") * this.props.workspaceHeight, angle : workspaceBg.get("angle"), flipPosition : workspaceBg.get("flipPosition")};
                  selectedObjects = fromJS({"workspacebg0":croppedBg});
                }
                      transformManagers.push(<TransformManager key={0} socket = {this.props.socket} cornerResize = {true} lockTransform={(this.props.swapDetails !== null) ? true : false}  moveItem = {this.moveSelection} initiateResize = {this.initiateResize} resizeSelection = {this.resizeSelection} stopResize = {this.stopResize} initiateRotate = {this.initiateRotate} rotateSelection = {this.rotateSelection} stopRotate = {this.stopRotate} shortcutName = {this.props.shortcutName} selectedObjects = {selectedObjects}/>);
              }
            }

            var cameraItems = [];

            if (this.props.selectedCamera !== undefined && this.props.selectedCamera !== "") {
              var key = this.props.selectedCamera;
              var cameraItem = sceneData.getIn(["workspaceCameras", key]);
              var cameraStyles = { transform: "translate(" + cameraItem.get("x") * workspaceScale + "px, " + cameraItem.get("y") * workspaceScale + "px)", position: "absolute", width: cameraItem.get("width") * workspaceScale, height: cameraItem.get("height") * workspaceScale, opacity: "0.4" };
              cameraItems.push(
                <div key={key} id={key} data-id={key} className={"scene-item type-" + cameraItem.get("type").toLowerCase()} style={cameraStyles}>
                  {
                    <img alt="scene-items" className="scene-item-inner camera" src={this.appUrl + "/images/camera-focus.png"} data-id={key} />
                  }
                </div>
              )
            }

            let indexElement = null, selectedItem = this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]);
    
            if(this.state.contextMenu === true){
              var indexItems = [];
              if(this.props.selectedItems.size === 1){
                var currentItem  = sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]);
                let currentIndex  = currentItem.get("index");
              
                let itemsSize     = sceneData.get("workspaceItems").size;
                
                  indexItems.push(<div key={0}><div className={(itemsSize > 1 && currentIndex < itemsSize - 1) ? 'options' : 'options disabled'} onClick = {(e) => this.props.setZIndex({to : "front", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)}, this.props.socket)} ><FormattedMessage id="br.to.fr"></FormattedMessage></div><div className={(itemsSize > 1 && currentIndex > 0) ? 'options' : 'options disabled'} onClick = {(e) => this.props.setZIndex({to : "back", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)}, this.props.socket)} ><FormattedMessage id="mo.to.bc"></FormattedMessage></div><div className={(itemsSize > 1 && currentIndex !== itemsSize - 1) ? 'options' : 'options disabled'} onClick = {(e) => this.props.setZIndex({to : "first", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)}, this.props.socket)} ><FormattedMessage id="br.to.fi"></FormattedMessage></div><div className={(itemsSize > 1 && currentIndex !== 0) ? 'options' : 'options disabled'} onClick = {(e) => this.props.setZIndex({to : "last", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)}, this.props.socket)} ><FormattedMessage id="mo.to.la"></FormattedMessage></div></div>);

              }
              indexElement = <div ref={ref => { this.contextMenu = ref }} className = "contextMenu context-tool-bar unselectable">
                {indexItems}
                {(this.props.selectedItems.size === 1 && (currentItem.get("type") === "IMG" || currentItem.get("type") === "STOCKIMG" || currentItem.get("type") === "UPLOADS"))?<div key={1} className = 'options' onClick = {this.setAsBg.bind(this)}><FormattedMessage id="s.a.bg"></FormattedMessage></div>:null}
                {!this.props.textStatus.get("isFocused") && this.state.isContextBg !== true?<div className={'options'} onClick = {(e) => this.handleShortcuts("COPY_ITEM", "btnClick")} ><FormattedMessage id="r.c.co"></FormattedMessage></div>:null}
                {(this.props.copiedItem !== null && (this.props.copiedItem.dataType === "ITEMS" || this.props.copiedItem.dataType === "SCENES"))?<div className={'options'} onMouseDown = {(e) => this.pasteItem(e)} ><FormattedMessage id="r.c.pa"></FormattedMessage></div>:null}
                {this.state.isContextBg === true && this.props.sceneData.getIn(["workspaceBG", "src"]) !== "" && (this.props.sceneData.getIn(["workspaceBG", "type"]) === "IMG" || this.props.sceneData.getIn(["workspaceBG", "type"]) === "STOCKIMG" || this.props.sceneData.getIn(["workspaceBG", "type"]) === "UPLOADS")?<div className={'options'} onMouseDown = {(e) => this.removeBG(e)} ><FormattedMessage id="re.f.bg"></FormattedMessage></div>:null}
                {this.state.isContextBg !== true && (this.props.selectedItems.size > 0)?<div className={'options'} onClick = {(e) => this.props.deleteItem({selectedItems : this.props.selectedItems.toArray(), selectedScene : this.props.selectedScene}, this.props.socket)} ><FormattedMessage id="r.c.de"></FormattedMessage></div>:this.state.isContextBg === true && this.props.sceneData.getIn(["workspaceBG", "src"]) !== ""?<div className={'options'} onMouseDown = {(e) => this.handleBgDelete(e)} ><FormattedMessage id="r.c.de"></FormattedMessage></div>:null}
                </div>
            }

            if(this.props.isPlayAll)
            {
              workspaceBG.get("type") === "VIDEO" || workspaceBG.get("type") === "STOCKVID" || workspaceBG.get("type") === "UPVIDEO" || workspaceBG.get("type") === "ZOOM";
              workspaceDisplay = this.state.worksheet.map((each, i) =>
                (this.state.sceenPosition === i) ?
                <React.Fragment key = {i}>
                <div id="workspace" key={i} className="workspace work-list playing " style={{left : this.workspaceX.toFixed(2) + "px", top : this.workspaceY.toFixed(2) + "px", width : workspaceWidth.toFixed(2) + "px", height : workspaceHeight.toFixed(2) + "px",overflow:"hidden" }}>
                  <img className="player-loader-img" alt="loader" src={this.appUrl + "/images/chr-loading.svg"} style={{ width: "100%", height: "100%", objectFit: "scale-down" }} />
                      <Player changeVideoIndex={this.changeVideoIndex} userId={this.props.userId}/>
                      {playAllScene} 
                </div>
                </React.Fragment>: null );
            }
            else if(this.props.isPlay)
            {
              var zoomFactorVal =this.getCurrentZoom(true);
              workspaceDisplay = this.state.worksheet.map((each, i) =>
                (this.state.sceenPosition === i) ?
                <React-Fragment key = {i}>

                <div id="workspace" key={i} className="workspace work-list playing pointer-events-none" style={{left : this.workspaceX.toFixed(2) + "px", top : this.workspaceY.toFixed(2) + "px", width : workspaceWidth.toFixed(2) + "px", height : workspaceHeight.toFixed(2) + "px", overflow:"hidden" }}>
                <img className="player-loader-img" alt="loader" src={this.appUrl + "/images/chr-loading.svg"} style={{ width: "100%", height: "100%", objectFit: "scale-down" }} />
                    <Player zoomFactor={zoomFactorVal.scale} userId={this.props.userId}/>
                    <div className="scenes">
                      {bgColors}
                      {bgItems}
                      {svgFilters}
                      {workspaceObjects[0]}
                      {transformManagers}
                    </div>
                    <div className="svg-filters" style={this.props.browserName.get(1) === "Firefox"?{width:"0", height : "0", display:"block"}:{display : "none"}}>
                      {workspaceObjects[1]}
                    </div>
                  </div></React-Fragment>
                  : null);
            }
            else {
              let transitionPreview = null;
              let sceneStyle = {left : 0, top : 0, position : "absolute", width : (this.props.workspaceWidth * this.props.zoomFactor).toFixed(2) + "px", height : (this.props.workspaceHeight * this.props.zoomFactor).toFixed(2) + "px"};
              if(Math.round(this.props.workspaceWidth * this.props.zoomFactor) > this.props.workspaceBounds.get("width")){
                sceneStyle.overflow = "hidden";
              }
              if(Math.round(this.props.workspaceHeight * this.props.zoomFactor) > this.props.workspaceBounds.get("height")){
                sceneStyle.overflow = "hidden";
              }
              if(this.props.propertyWindow.get("component") === "transition"){
                
                transitionPreview = <TransitionPreview effect = {this.props.sceneData.get("transEffect")} colors = {this.props.sceneData.get("transColor")} width = {this.props.workspaceWidth} height = {this.props.workspaceHeight} zoomFactor = {this.props.zoomFactor} browserName = {this.props.browserName} />
              }
              let playControl = null, seekBar = null;
              workspaceDisplay = this.state.worksheet.map((each, i) =>
                (this.state.sceenPosition === i) ?
                  <React.Fragment key={"workspaceDisplay"}> 
                      <div className={"scenes pointer-events-none"} id = "scene-one" style={sceneStyle}>
                        {bgColors}
                        {bgItems}
                        {svgFilters}
                        {workspaceObjects[0]}
                        {this.collaborativeUsers}
                        {cameraItems}
                        {transitionPreview}
                      </div>
                      <div className={"svg-filters pointer-events-none"} style={this.props.browserName.get(1) === "Firefox"?{width:"0", height : "0", display:"block"}:{display : "none"}}>
                        {workspaceObjects[1]}
                      </div>
                      {transformManagers}
                      {playControl}
                      {seekBar}
                      <CSSTransition in={!this.props.showLibrary} timeout={500} classNames="lib-add-btn" unmountOnExit>
                        <div className="lib-add">
                          <img src={this.appUrl + "/images/lib-icons/lib-add.png"} alt="Continue" style={{width:"100%", height: "100%"}} onClick={(e) => this.props.showLibraryTab(true)}></img>
                        </div>
                      </CSSTransition>
                    {indexElement}
                  </React.Fragment>
                  : null);
            }
          }
        return workspaceDisplay;

    }

    addTransition(){
        this.setState({addTransition:!this.state.addTransition});
    }

   

    
  moveSelection(x, y){
    var selectedItem = this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]);
    var dX = selectedItem.get("x") - x, dY = selectedItem.get("y") - y, workspaceX = document.getElementById("workspace").offsetLeft, workspaceY = document.getElementById("workspace").offsetTop;
  }

  initiateResize(anchorBounds){
    this.multimoveSelection = anchorBounds;
  }

  resizeSelection(x, y, width, height){
    var selectedItem = this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]);
    var workspaceX = document.getElementById("workspace").offsetLeft, workspaceY = document.getElementById("workspace").offsetTop;
    
  }

  stopResize(){
    this.multimoveSelection = null;
  }

  initiateRotate(anchorAngles){
   
    this.anchorAngles = anchorAngles;
  }

  rotateSelection(cx, cy, angle){
    
    var selectedItem = this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]);
    var workspaceX = document.getElementById("workspace").offsetLeft, workspaceY = document.getElementById("workspace").offsetTop;
    
  }

  stopRotate(){
    this.anchorAngles = null;
  }

  enableClick(selector) {
    var elements = document.querySelectorAll(selector);
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].className.indexOf("pointer-events-none") !== -1)
        elements[i].classList.remove("pointer-events-none");
    }
  }
  
  disableClick(selector) {
      var elements = document.querySelectorAll(selector);
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].className.indexOf("pointer-events-none") === -1)
          elements[i].classList.add("pointer-events-none");
      }
  }

  copyToClipboard(string) {
    if (window.clipboardData) {
      window.clipboardData.setData('Text', string);
    }
    else {
      var aux = document.createElement("input");
      aux.style.top = 0;
      aux.style.left = 0;
      aux.style.position = "absolute";
      aux.setAttribute("value", string);
      document.getElementById("root").appendChild(aux);
      aux.select();
      document.execCommand("copy", false, null);
      aux.remove();
    }
  }

  isBase64(str) {
    try {
        return btoa(unescape(encodeURIComponent(decodeURIComponent(escape(atob(str)))))) === str;
    } catch (err) {
        return false;
    }
  }

  handlePaste(e) {
    try{
   
    var clipboardData, pastedData;

    e.stopPropagation();
    e.preventDefault();

    clipboardData = e.clipboardData || window.clipboardData;

    if (clipboardData && clipboardData.getData('Text') !== "" && this.isBase64(clipboardData.getData('Text'))) {
      
      pastedData = JSON.parse(decodeURIComponent(escape(atob(clipboardData.getData('Text')))));
     
      if (typeof pastedData === "object" && pastedData.key !== undefined && pastedData.key === "ANIMAKER_CLIPBOARD") {
        if(!this.props.updateItems){
          let isInProcess = Utility.canPaste(pastedData, this.props.updateItems);
          if(isInProcess){
              this.props.manageToast({action : "add", type : "error", "message" : 'ct.dup', formatId: "msg"});
              return;
          }
        }
        pastedData.selectedScene = this.props.selectedScene;
        this.props.pasteItems(pastedData, this.props.socket);
      }
    }
    e.target.remove();
    document.designMode = "off";
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-handlePaste")
  }
  }

  pasteFromClipboard() {
   
    if (window.clipboardData) {
      
      // var data = window.clipboardData.getData('Text');
    }
    else {
      var aux = document.createElement("input");
      // aux.style.display = "none";
      aux.style.top = 0;
      aux.style.left = 0;
      aux.style.position = "absolute";
      aux.setAttribute("id", "copytoclips");
      document.getElementById("root").appendChild(aux);
      aux.addEventListener('paste', this.handlePaste);
      // document.designMode = "on";
      aux.focus();
      // document.execCommand("paste");
    }
  }

  cancelSwap(){
    try{
    this.props.undoProp.isBG===true?
    this.props.dropBG({selectedScene:this.props.selectedScene, value:this.props.undoProp, socket:this.props.socket, deleteId :'', deletedData:[], subType : "BG_SETTINGS"}):
    this.props.addObj(this.props.undoProp, this.props.socket);
    this.props.swapItem("");
    this.props.swapItemUndo("");
    document.getElementById("app-overlay").style.display = "none";
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-cancelSwap")
    }
  }
  
  applySwap(){
    try{
    let nextBtn = document.querySelector('.next_step');
    if(nextBtn){
        this.props.nextBtnClicked(true);
        nextBtn.classList.remove('disable');
        nextBtn.click();
    }
    if(this.props.swapDetails !== null){
      this.props.swapItem("");
      this.props.swapItemUndo("");
      document.getElementById("app-overlay").style.display = "none";
    }else if(this.props.isToolCropping){
      this.props.toggleBgCrop();
    }
   } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-applySwap")
  }
  }


  handleShortcuts(option,type)
  {
     try{
    var project, a = 0, copyChildren = {}, currentItem, currentIndex, itemsSize;
      this.ctrlPressed = false;
      if(!this.props.textStatus.get("isFocused"))
      this.enableClick(".selectionBox");

      if(this.props.selectedItems.size === 1)
      {
          currentItem  = this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0)]);
          currentIndex  = currentItem.get("index");
          itemsSize     = this.props.sceneData.get("workspaceItems").size;
      }

      // Verifying if any popup is opened or not....(BgVideo / LipSync / Audio / CreateFolder )
      // if(this.props.commonPopup.get('show')){
      //   option = 'STOP_SHORTCUTS';
      // }

      switch(option)
      {
          case "SELECT_ALL_OBJECT":
              if(this.props.sceneData.get('workspaceItems').size > 0)
              {
                  let item = [];
                  this.props.sceneData.get("workspaceItems").entrySeq().forEach(([key, value]) => {
                      item.push(key);
                  });
                  this.props.setSelectedItems({selectedItems : item}, this.props.socket);
              }
              break;
          case "DESELECT_ALL_OBJECT":
              if(this.props.selectedItems.size > 0){
                  this.props.setSelectedItems({selectedItems : []}, this.props.socket);
                  // this.props.suggestionPopup({
                  //   show : false,
                  //   type : '',
                  //   subType : ''
                  // })
              }
              break;
          case "COPY_ITEM":
            if(type === "btnClick")
              this.setState({contextMenu : false});
              if (!this.props.textStatus.get("isFocused")) {
                
                  if(this.props.selectedItems.size > 0){
                      var copyItems = []; copyChildren = {};
                      for (a = 0; a < this.props.selectedItems.size; a++) {
                        copyItems.push(this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(a)]).toJS())
                        if (this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(a), "type"]) === "TXTOVLY" || this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(a), "type"]) === "GROUP") {
                            this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(a), "groupChildren"]).map(function (item, index) {
                            copyChildren[item] = this.props.sceneData.getIn(["workspaceChildren", item]).toJS()
                            }.bind(this));
                        }
                      }
                      
                      project = { data : { workspaceChildren: copyChildren, workspaceItems: copyItems }, dataType : "ITEMS", key : "ANIMAKER_CLIPBOARD"};
                      let encoded = btoa( unescape(encodeURIComponent(JSON.stringify(project))));
                      
                      this.copyToClipboard(encoded);
                     
                      this.props.setCopyItemType(project);
                  }
                  else if(this.props.selectedMedias.size === 0 && this.props.selectedCamera === ""){
                      
                      let selectedScenes = (this.props.selectedScenes.size > 0) ? this.props.selectedScenes : [this.props.selectedScene];
                      let scenes =  this.props.scenes.filter(function(obj, key){
                      return selectedScenes.indexOf(key) !== -1;
                      }).toJS();
                      
                      project = { data : scenes, width : this.props.workspaceWidth, height : this.props.workspaceHeight, dataType : "SCENES", key : "ANIMAKER_CLIPBOARD"};
                      
                      let encoded = btoa(unescape(encodeURIComponent(JSON.stringify(project))));
                      this.copyToClipboard(encoded);
                      this.props.setCopyItemType(project);          
                  }
                  if(type === "btnClick"){
                      this.props.copyObjects(false);
                      this.setState({contextMenu : false});
                  }
              }else if(type === "btnClick"){
                let textSelected = false;
    
                if (window.getSelection) {
                  textSelected = !(window.getSelection().focusOffset === window.getSelection().anchorOffset);
                } else if (document.getSelection) {
                  textSelected = !(document.getSelection().focusOffset === document.getSelection().anchorOffset);
                } else if (document.selection) {
                  textSelected = document.selection.createRange().text !== "";
                }

                if(textSelected)
                  document.execCommand("copy");
              }
          break;
          case "CUT_ITEM":
              if (!this.props.textStatus.get("isFocused")) {
                if(this.props.selectedItems.size > 0){
                    var cutItems = [], cutId = []; copyChildren = {};
                    for (a = 0; a < this.props.selectedItems.size; a++) {
                      var cutTemp = this.props.selectedItems.get(a);
                      cutItems.push(this.props.sceneData.getIn(["workspaceItems", cutTemp]).toJS());
                      cutId.push(cutTemp);
                      if (this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(a), "type"]) === "TXTOVLY" || this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(a), "type"]) === "GROUP") {
                          this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(a), "groupChildren"]).map(function (item, index) {
                          copyChildren[item] = this.props.sceneData.getIn(["workspaceChildren", item]).toJS();
                          }.bind(this));
                      }
                    }
                    project = { data : { workspaceChildren: copyChildren, workspaceItems: cutItems }, dataType : "ITEMS", key : "ANIMAKER_CLIPBOARD"};
                    let encoded = btoa(unescape(encodeURIComponent(JSON.stringify(project))));
                    this.props.deleteItem({ selectedItems: this.props.selectedItems.toArray(), selectedScene: this.props.selectedScene },this.props.socket);
                    this.copyToClipboard(encoded);
                    this.props.setCopyItemType(project);
                    if(type === "btnClick")
                      this.props.cutObjects(false);
                }
              }
          break;
          case "PASTE_ITEM":
              if (!this.props.textStatus.get("isFocused")) {
                this.pasteFromClipboard();
              }else{
                document.execCommand("paste");
              }
          break;
          case "CTRL_PRESS":
          case "CTRL_PRESS_AGAIN":
              this.ctrlPressed = true;
              this.disableClick(".selectionBox");
              break;
          case "BRING_FRONT":
          case "BRING_FRONT_AGAIN":
              if(this.props.selectedItems.size === 1 && currentIndex < itemsSize - 1)
              this.props.setZIndex({to : "front", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)},this.props.socket);
              break;
          case "MOVE_BACK":     
          case "MOVE_BACK_AGAIN":     
              if(this.props.selectedItems.size === 1 && currentIndex > 0) 
              this.props.setZIndex({to : "back", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)},this.props.socket);
              break;
          case "BRING_FIRST":
              if(this.props.selectedItems.size === 1 && currentIndex !== itemsSize - 1)
              this.props.setZIndex({to : "first", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)},this.props.socket);
              break;
          case "MOVE_LAST":
              if(this.props.selectedItems.size === 1 && currentIndex !== 0) 
              this.props.setZIndex({to : "last", selectedScene : this.props.selectedScene, selectedItem : this.props.selectedItems.get(0)},this.props.socket);
              break;

          case "RIGHT_ARROW":
              if(this.props.selectedItems.size === 0 && this.props.scenes.size -1 > this.props.selectedScene && this.state.active === this.props.selectedScene && !this.rightKeyShortCut){
                this.rightKeyShortCut = true;
                this.moveRight('click');
              }
              break;
          case "LEFT_ARROW":
              if(this.props.selectedItems.size === 0 && this.props.selectedScene > 0 && this.state.active === this.props.selectedScene && !this.leftKeyShortCut){
                this.leftKeyShortCut = true;
                this.moveLeft('click');
              }
              break;
          case "OPEN_SETTINGS":
            if(this.props.selectedItems.size === 1){
              this.props.setPropertyWindow({component : this.props.propertyWindow.get("component") !== "settings"?"settings":"", type : this.props.sceneData.getIn(["workspaceItems", this.props.selectedItems.get(0), "type"]), isOpened : this.props.propertyWindow.get("component") !== "settings"});
            }
          break;
          case "ZOOMIN":
          case "ZOOMIN_AGAIN":
            this.props.setZoom({ zoomFactor : this.props.zoomFactor + 0.01, fromUser : true});
          break;
          case "ZOOMOUT":
          case "ZOOMOUT_AGAIN":
            this.props.setZoom({ zoomFactor : this.props.zoomFactor - 0.01, fromUser : true});
          break;
          default: 
      } 
    } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "WorkspaceComponent-handleShortcuts")
      }
  }

  handleBgDelete(e){
    try{
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteBG({selectedScene: this.props.selectedScene}, this.props.socket);
    let nextBtn = document.querySelector('.next_step');
    if(nextBtn){
        this.props.nextBtnClicked(true);
        nextBtn.classList.remove('disable');
        nextBtn.click();
    }
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-handleBgDelete")
  }
  }

  handleCutEvent(){
    try{
    if (this.props.sceneData.getIn(["workspaceBG", "type"]) === "VIDEO")
      this.props.openCommonPopup("VIDEO");
    else if ( (this.props.sceneData.getIn(["workspaceBG", "type"]) === "STOCKVID") || (this.props.sceneData.getIn(["workspaceBG", "type"]) === "UPVIDEO") )
      this.props.openCommonPopup("VIDEO");
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-handleCutEvent")
    }
  }

  addOneMoreScene(){
    try{
      let data = {selectedScene: this.props.selectedScene, setStatus:true};
      this.props.addLiteScene(data, this.props.socket);
      this.setNewScreen = true;
      this.scrollType = '';
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-addOneMoreScene")
    }
  }

  changeImgSrc(e, src){
    try{
      e.currentTarget.src = src;
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-changeImgSrc")
    }
  }

  handleZoomClick(e){
    try{
    e.preventDefault();
    e.stopPropagation();
    this.setState({isZoomActive : !this.state.isZoomActive, isZoomDropped : !this.state.isZoomDropped});
    }catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-handleZoomClick")
    }
  }

  handleZoomDrop(e){
  try {
    e.preventDefault();
    e.stopPropagation();
    let stateToUpdate = {isZoomDropped : !this.state.isZoomDropped};
    this.setState(stateToUpdate);
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent- handleZoomDrop")
  }
  }

  handleZoomChange(e, value, checkToggle){
    try{
    e.preventDefault();
    e.stopPropagation();
    if(value !== "fit"){
      this.props.setZoom({ zoomFactor : value / 100, fromUser : true});
      this.props.setZoomFit(false);
    }
    else{
      this.props.setZoomFit(true);
      let currentZoom = this.getCurrentZoom(true, true);
      this.props.setZoom({ zoomFactor : currentZoom.scale, fromUser : true});
    }
    if(this.state.isZoomDropped){
      this.setState({isZoomDropped : false});
    }
  }catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-handleZoomChange")
  }
  }

  segmentToString(x, y){
    return [x.b.toFixed(2), y.b.toFixed(2), x.c.toFixed(2), y.c.toFixed(2)].join(",");
  }

  toggleToolBar(){
  try{
    this.setState({isBgToolExpanded : !this.state.isBgToolExpanded}, () => {
      let nextBtn = document.querySelector('.next_step');
			if(nextBtn){
        this.props.nextBtnClicked(true);
				nextBtn.classList.remove('disable');
				nextBtn.click();
			}
    });
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-toggleToolBar")
  }
  }

  flipBG(value, angle){
    try {
    var flip = value + 1;

    if(flip > 3)
      flip = 0;
    this.props.flipBG({selectedScene : this.props.selectedScene, toUpdate : {flipPosition : flip}}, this.props.socket);
    this.flipedItem = true;
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-flipBG")
    }
  }

  onDuplicateScene=(e, index)=>{
    if(e)
        e.stopPropagation();
    this.props.onDuplicateScene(index,this.props.socket);
}

  removeBG(){
    try{
    let workspaceBg = this.props.sceneData.get("workspaceBG");
    let isRemoveFrmBg=true;
    let itemToAdd = {id : Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString(), assetId : workspaceBg.get("assetId"), selectedScene : this.props.selectedScene, angle : 0, src : workspaceBg.get("src"), thumb : workspaceBg.get("thumbnail"), type : workspaceBg.get("type"), subType : workspaceBg.get("subType"), flipPosition : workspaceBg.get("flipPosition"), emptySwap : true};
    if(workspaceBg.get("type") === "UPIMAGE"){
      itemToAdd.type = "UPLOADS";
      itemToAdd.subType = "UPIMAGE";
    }
    if(workspaceBg.get("type") === "GIPHY"){
      itemToAdd.type = "IMG";
      itemToAdd.subType = "GIPHY";
    }
    if(workspaceBg.get("bgFilter") !== ""){
      itemToAdd.filter = workspaceBg.get("bgFilter");
    }
    if(workspaceBg.get("sourceType") !== ""){
      itemToAdd.sourceType = workspaceBg.get("sourceType");
    }
    let bgWidth = workspaceBg.get("width") * this.props.workspaceWidth;
    let bgHeight = workspaceBg.get("height") * this.props.workspaceHeight;
    if(bgWidth > bgHeight){
      itemToAdd.width = this.props.workspaceWidth/2;
      itemToAdd.height = bgHeight * (itemToAdd.width / bgWidth);
    }else{
      itemToAdd.height = this.props.workspaceHeight/2;
      itemToAdd.width = bgWidth * (itemToAdd.height / bgHeight);
    }
    
    itemToAdd.x = (this.props.workspaceWidth / 2) - (itemToAdd.width / 2);
    itemToAdd.y = (this.props.workspaceHeight / 2) - (itemToAdd.height / 2);
    
    if(workspaceBg.get('isBlob')){
      itemToAdd.isBlob = true;
      itemToAdd.id = this.props.updateItems.get('item_id');
    }
    
    if(workspaceBg.get('type') === 'UPIMAGE' && workspaceBg.get('sourceType').includes('svg') && workspaceBg.get('bgColor') && workspaceBg.get('bgColor').size){
      itemToAdd.colors = workspaceBg.get('bgColor');
      itemToAdd.defaultColor = workspaceBg.get('defaultColor');
    }
    this.props.changeBg({itemToAdd,isRemoveFrmBg,selectedScene: this.props.selectedScene,selectedItems : this.props.selectedItems}, this.props.socket);
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "WorkspaceComponent-removeBG")
  }
  }

  rotateBG(bgData){
  try {
    let angle = bgData.get("angle");
    if(angle === 0)
      angle = 270;
    else if(angle === 270)
      angle = 180;
    else if(angle === 180)
      angle = 90;
    else
      angle = 0;
    
    var toUpdate =  {angle : angle};
    let dataWidth = this.props.workspaceWidth * bgData.get("width"), dataHeight = this.props.workspaceHeight * bgData.get("height");
      let bgWidth = null, bgHeight = null, bgScale = null, bgWidthScale = null, bgHeightScale = null;
      var workspaceWidth  = this.props.workspaceWidth;
      var workspaceHeight = this.props.workspaceHeight;

      if(angle === 90 || angle === 270){
        if(dataWidth >= dataHeight){
          bgWidth = workspaceHeight;
          bgHeight = dataHeight * (bgWidth / dataWidth);
          if (bgHeight <= workspaceWidth)
          {
            bgHeight = workspaceWidth;
            bgWidth = dataWidth * (bgHeight / dataHeight);
          }
        }else{
          bgHeight = workspaceWidth;
          bgWidth = dataWidth * (bgHeight / dataHeight);
          if(bgWidth <= workspaceHeight){
            bgWidth = workspaceHeight;
            bgHeight = dataHeight * (bgWidth / dataWidth);
          }
        }
      }else{
        if (workspaceWidth >= workspaceHeight)
        {
          bgWidth = workspaceWidth;
          bgHeight = dataHeight * (bgWidth / dataWidth);
          if (bgHeight <= workspaceHeight)
          {
            bgHeight = workspaceHeight;
            bgWidth = dataWidth * (bgHeight / dataHeight);
          }
        } 
        else
        {
          bgHeight = workspaceHeight;
          bgWidth = dataWidth * (bgHeight / dataHeight);
          if (bgWidth <= workspaceWidth)
          {
            bgWidth = workspaceWidth;
            bgHeight = dataHeight * (bgWidth / dataWidth);
          }
        }
      }

      bgWidthScale = bgWidth / workspaceWidth;
      bgHeightScale = bgHeight / workspaceHeight;
      
      let dW = workspaceWidth - bgWidth, dH = workspaceHeight - bgHeight;
      if(isNaN(dW))
        dW = 0

      if(isNaN(dH))
        dH = 0

      var x = (dW / 2) / workspaceWidth, y = (dH / 2) / workspaceHeight, width = bgWidthScale, height = bgHeightScale;

      toUpdate.x  = x;
      toUpdate.y  = y;
      toUpdate.width  = width;
      toUpdate.height  = height;
      this.props.flipBG({selectedScene : this.props.selectedScene, toUpdate : toUpdate}, this.props.socket);
    
     
      } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-rotateBG")
      }

  }

  onAnimateClick =() =>{
    try {
    this.props.setPropertyWindow({component:'animate',type:'ANIM'})
    }catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-onAnimateClick")
      }
  }

  handlePauseAndPlay=(e)=>{
    try {
    // e.stopPropagation();
    e.preventDefault();
    this.props.setAutoPlay();
    }catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "WorkspaceComponent-handlePauseAndPlay")
      }
  }

  handleControlsClick=(e)=>{
  try {
    e.preventDefault();
    e.stopPropagation();
   
    if(this.props.mode==='slide'&&!this.props.isPreview)
    this.props.setPreview(true);

   if(e.target.id === 'nextSlide'||e.target.id === 'next-slide')
   {
      this.props.setPlayerPosition();
      if (this.props.isFullScreen && this.props.isPlayAll) {
        if (this.props.t1.currentLabel() >= this.props.t1.getLabelsArray().length-1) {
          document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next-disable.svg";
          document.getElementById('nextSlide').style.cursor = 'auto';
          document.getElementById('next-slide').style.cursor = 'auto';
        }
         if (this.props.t1.currentLabel() !== null) {
          document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous.svg";
          document.getElementById('prevSlide').style.cursor = 'pointer';
          document.getElementById('previous-slide').style.cursor = 'pointer';

        }
      }
      if(this.props.isPreview && !this.props.isPlayAll){  
        let currentScene = this.props.currentSceneNumber;
        if(this.props.scenes.count()>1){
    if(currentScene < this.props.project.get('scenes').count()-1) 
        {
         this.props.setScenePosition(this.props.project.getIn(['scenes' , currentScene+1 ]),currentScene+1,this.props.project.getIn(['scenes',currentScene+1,'startTime']) , this.props.project.getIn(['scenes',currentScene+1,'duration']));
         document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous.svg";
         document.getElementById('prevSlide').style.cursor = 'pointer';
         document.getElementById('previous-slide').style.cursor = 'pointer';
        }
    if(currentScene+1 >= this.props.project.get('scenes').count()-1){
      document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next-disable.svg";
          document.getElementById('nextSlide').style.cursor = 'auto';
          document.getElementById('next-slide').style.cursor = 'auto';
    }
  }
    }   
   }
   if(e.target.id === 'prevSlide'||e.target.id === 'previous-slide')
   {
    
      this.props.setPlayerPosition('Prev');
      if (this.props.isFullScreen && this.props.isPlayAll) {
        if (this.props.t1.currentLabel() === null) {
          document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous-disable.svg";
          document.getElementById('prevSlide').style.cursor = 'auto';
          document.getElementById('previous-slide').style.cursor = 'auto';
        }
         if (this.props.t1.currentLabel() < this.props.t1.getLabelsArray().length) {
          document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next.svg";
          document.getElementById('nextSlide').style.cursor = 'pointer';
          document.getElementById('next-slide').style.cursor = 'pointer';
        }
      }
      if(this.props.isPreview && !this.props.isPlayAll){
        if(this.props.scenes.count()>1){
        if(this.props.currentSceneNumber>0)
        {
          this.props.setScenePosition(this.props.project.getIn(['scenes' , this.props.currentSceneNumber-1 ]),this.props.currentSceneNumber-1,this.props.project.getIn(['scenes',this.props.currentSceneNumber-1,'startTime']) , this.props.project.getIn(['scenes',this.props.currentSceneNumber-1,'duration']));
         }
        if(this.props.currentSceneNumber< this.props.project.getIn(['scenes',this.props.currentSceneNumber]).count()){
          document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next.svg";
          document.getElementById('nextSlide').style.cursor = 'pointer';
          document.getElementById('next-slide').style.cursor = 'pointer';
        }
        
       if(this.props.currentSceneNumber===0 || this.props.currentSceneNumber ===1 || this.props.currentSceneNumber ===null){
        document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous-disable.svg";
        document.getElementById('prevSlide').style.cursor = 'auto';
        document.getElementById('previous-slide').style.cursor = 'auto';
       }
      }
     } 
  }
}catch (error) {
  errorlog(error, error.message, "WorkspaceComponent-handleControlsClick")
  }
}

  onSceneMove=(ind = 0)=>{
      if(ind <= this.props.scenes.size-1)
      this.props.setSelectedScene(ind, this.props.scenes.getIn([ind,'startTime']), [ind], this.props.socket);
  }
  
  onShoenableFullScreenSlidePanel=(e)=>{
    this.props.showSlides({ show: true });
    this.props.setWorkspaceStage(this.props.libSection);
  }

   calculateZoomPosition=()=>{
     let zoomPosition = {right:'308px',bottom:'10px',slideRight:'9px'};
     const propertyWindow = this.props.propertyWindow.get('component');
     const slidePanel = this.props.showSlidePanel;
      if(slidePanel && propertyWindow===""){
        zoomPosition.right='308px';
        return zoomPosition;
      }
     else if(!slidePanel){
       if(propertyWindow!==""){
        zoomPosition.right='420px';
        zoomPosition.slideRight = '306px';
       }
       else{
       zoomPosition.right='120px';
       }
       return zoomPosition;
     }
     return zoomPosition;
   }

    render() {
      if(this.props.scenes.size > 0 && !this.loadedContentScrens){
          let itemArray = [];
          if(this.props.scenes.size > 1){
            for(let i=1; i <= this.props.scenes.size; i++){
              itemArray.push(i);  
            }
          }else{
            itemArray = this.state.items;
          }
          this.setState({
            items:itemArray
          })
          this.loadedContentScrens = true;
        }
        let selectedItem = null, svgPath = null, imageEditIcon = [], filterSettings = [];
        if(this.props.sceneData !== undefined && this.props.sceneData.size > 0){

            let workspaceItems =  this.props.sceneData.get("workspaceItems");
          
            
            if(!this.props.isPlay && !this.props.isPlayAll && this.props.swapDetails === null && this.props.tool !== "converttomp4"){
              if(this.props.sceneData.getIn(["workspaceBG" , "src"]) !== ""){
                var currentFlip = this.props.sceneData.getIn(["workspaceBG" , "flipPosition"]) !== undefined ? this.props.sceneData.getIn(["workspaceBG" , "flipPosition"]) : 0;
                var currentAngle = this.props.sceneData.getIn(["workspaceBG" , "angle"]) !== undefined ? this.props.sceneData.getIn(["workspaceBG" , "angle"]) : 0;

                var itemToolStyle = {left: (this.props.workspaceBounds.get("cx") + (this.props.workspaceWidth * this.props.zoomFactor) / 2) - 92 + "px", top : (this.props.workspaceBounds.get("cy") - (this.props.workspaceHeight * this.props.zoomFactor) / 2) + "px", display: (this.props.isBgCropping) ? "none" : "unset"};

                if(Math.round(this.props.workspaceHeight * this.props.zoomFactor) > this.props.workspaceBounds.get("height"))
                  itemToolStyle.top = ((this.props.workspaceBounds.get("cy") - this.props.workspaceBounds.get("height") / 2).toFixed(2)) + "px";
                if(Math.round(this.props.workspaceWidth * this.props.zoomFactor) > this.props.workspaceBounds.get("width"))
                  itemToolStyle.left = ((this.props.workspaceBounds.get("cx") - 92 + this.props.workspaceBounds.get("width") / 2).toFixed(2)) + "px";
               
                
              }
            }
            
          
        }
         var workspaceCY = this.props.workspaceBounds ? this.props.workspaceBounds.get('cy') : window.innerHeight/2 ;
         let workspaceCX = this.props.workspaceBounds ? this.props.workspaceBounds.get('cx') : window.innerWidth/2 ;
         

       var displayResult =  this.generateItems();
       let workspaceStyles = this.calculateStyles();
       let toolbarStyle = {};
       toolbarStyle.width = workspaceStyles.width;
       toolbarStyle.height = '33px';
       toolbarStyle.top = workspaceStyles.top.substr(0,workspaceStyles.top.indexOf('p'))-38+"px";
       toolbarStyle.left = workspaceStyles.left;
       toolbarStyle.position = 'absolute';
       toolbarStyle.minWidth = '240px';
        
     
       
        //var upDownArrowStyle = {top : arrowTop-28+"px",left:arrowLeft+"px"};
        let playerComponent = '';
       
        
        let zoomLeft = 29;
        if(this.state.isZoomActive)
          zoomLeft = 52;

        let zoomDropDown = null;
        let zoomPosition = this.calculateZoomPosition();
      if(this.state.isZoomDropped){
          var zoomVlaues = [25, 50, 63, 100, 125, 150, 200, 300];
          var zoomList = [];
          const currentZoomFactor =  Math.round(this.props.zoomFactor*100);
          let zoomSet = false;
          let greenTick = null;
          let boldStyle = null ; 
          zoomVlaues.map(function(index, value){ 
            if(currentZoomFactor===index){
              zoomSet = true;
              greenTick = <img style={{float:'right'}} src={this.appUrl+'/images/green-tick.svg'} alt='Green tick'></img>;
              boldStyle = {fontWeight:'bold'};
            }
            else{
              greenTick = null;
              boldStyle = null;
            }
           return(zoomList.push(<li style={boldStyle} key = {index} onMouseDown = {(e) => this.handleZoomChange(e, index)}>
          {index + "%"} 
          {greenTick}
          </li>))}.bind(this))

          if(!zoomSet){
            boldStyle = {fontWeight:'bold'};
            greenTick = <img style={{float:'right'}} src={this.appUrl+'/images/green-tick.svg'} alt='Green tick'></img>;
          }
          else{
            greenTick = null;
            boldStyle = null;
          }
          zoomList.push(<li style={boldStyle} key = {zoomVlaues.length } onMouseDown = {(e) => this.handleZoomChange(e, "fit")}><FormattedMessage id="z.fit"></FormattedMessage>
          {greenTick}
          </li>);
          let listRight = zoomPosition.right.substr(0,zoomPosition.right.indexOf('p'))-6;
          zoomDropDown = <ul style={{right:`${listRight}px`,bottom:'53px'}} className = "zoom-drop-down" >{zoomList}</ul>;
        }
        let zoomControl ='';

        
        if(this.props.isPlayAll ||this.props.isPreview)
          zoomControl = "";

        let contentRight = '6px';
        if((this.props.selectedScene+1)>9){
          contentRight = '3px';
        }
        else if((this.props.selectedScene+1)>99)
        {
          contentRight = '-1px';
        } 
        const slidesShow = !this.props.showSlidePanel ? <div onClick={(e)=>this.onShowSlidePanel()} style={{right:zoomPosition.slideRight,bottom:'10px'}} className='slidesShow'>
        <div className='slide-main'>
        <div className='slide-first'> <span style={{right:contentRight}}  className='slide-content'>{this.props.selectedScene+1}</span></div>
        <div className='slide-second'></div>
        </div>
         <span className='slidesShow-child'><FormattedMessage id='sl.sc'/></span>
          </div> :null;
       
       const upArrowSrc = this.props.scenes.size > 1 ? `${this.appUrl + "/images/slide-icons/down-arrow-ws.svg"}`: `${this.appUrl + "/images/slide-icons/down-arrow-disable-ws.svg"}`;
       //const downArrowSrc = (this.props.selectedScene === this.props.scenes.size-1) ?
        let isClick = false; 
          if(this.props.scenes.size === 1){
           
        let onWPClickItems = this.props.scenes.getIn([0,'workspaceItems']).filter(function(obj, key){return obj.get("animType") === "On Click"});
        let onWCClickItems = this.props.scenes.getIn([0,'workspaceChildren']).filter(function(obj, key){return obj.get("animType") === "On Click"});
       
          if(onWPClickItems.count()>0 || onWCClickItems.count()>0){
            isClick = false;
          }
          else{
            isClick = true;
          }
        }
        if(this.props.mode === 'slide' && this.props.scenes.size === 1){
            isClick = true;
        }
         let isPrevClick = false; 
         if(this.props.scenes.size === 1 || this.props.selectedScene === 0){
          isPrevClick = true;
         }
        return (
            <React.Fragment>
                {(this.props.sceneData !== undefined && this.props.sceneData.size > 0)&&<div className="workspace-wrapper">
                                                        
                
                    {displayResult}
            {/* {((this.props.isFullScreen===true) || (this.props.mode==='slide') )?<React.Fragment><div id='player-controls'  onMouseMove={(e)=>{clearInterval(this.interval)}} onMouseOver={(e)=>{this.handleFullScreenMouseOver(e)}} onMouseOut={(e)=>{this.handleFullScreenMouseOut(e)}} style={{ top:((this.workspaceY+(this.props.workspaceHeight * this.props.zoomFactor))-50) +"px"}}>
               {/* <div id="play-present" onClick={(e)=>this.handlePauseAndPlay(e)} ><img alt="play-pause"  src={this.appUrl + "/images/playerControls-icons/"+ (this.props.autoPlay?"pause":"play") +".svg"} /> <span>{this.props.autoPlay?'Pause':'Play'}</span></div>   */}
                 {/* <div style={{display:'flex'}}>
                 <div  id="previous-slide" onClick={(e)=>this.handleControlsClick(e) } style={{cursor:'auto'}}>{<img src={this.appUrl + "/images/playerControls-icons/"+(isPrevClick ? "previous-disable":"previous")+".svg"} id="prevSlide" style={{cursor: isPrevClick ?'auto':'pointer'}}/>}</div>
                 <div id="next-slide" onClick={(e)=>this.handleControlsClick(e)}>{<img src={this.appUrl +"/images/playerControls-icons/"+ (isClick ? "next-disable":"next") +".svg"} id="nextSlide" style={{cursor: isClick ?'auto':'pointer'}}/>}</div>
                 </div>
                 <div id="full-screen"  onClick={()=>{this.enableFullScreen()}}> <img id='fullScreen' alt="fullScreen"  src={this.appUrl + "/images/playerControls-icons/"+ (this.props.isFullScreen===true?"notFullscreen":"fullscreen") +".svg"} />  </div>

                    </div></React.Fragment>:''} */} 

                    
                    {playerComponent}
                    
                    {(this.props.workspaceGrid) ? <ErrorHandler component="WorkspaceGrid"><WorkspaceGrid styles={{left : this.workspaceX + "px", top : this.workspaceY + "px", width : (this.props.workspaceWidth * this.props.zoomFactor) + "px", height :  (this.props.workspaceHeight * this.props.zoomFactor) + "px", borderRadius : "10px" }} width = {this.props.workspaceWidth * this.props.zoomFactor} height={this.props.workspaceHeight * this.props.zoomFactor} cols={8} rows={8} /></ErrorHandler> : ""}
                    {/* {<PlayerControl/>} */}
                    { this.props.animakerType==='full'?svgPath:null}
                    {((this.props.isCropping || this.props.isBgCropping || this.props.isFraming || this.props.isVideoCropping) && (!this.props.isPlayAll && !this.props.isPlay))?<ErrorHandler key="crop" component="Crop"><Crop key="crop" userId={this.props.userId} socket={this.props.socket} config={config}/></ErrorHandler>:null}
                    {filterSettings}
                    
                    {/* {((this.props.selectedItems.size > 0&& !this.state.contextMenu && !this.props.transformStatus.get("transforming") && !this.props.isCropping && !this.props.isFraming && !this.props.isPlay && !this.props.isPlayAll && !this.props.isVideoCropping && this.props.swapDetails === null&&this.props.mode!=='slide') || (this.props.selectedCamera !== "" && !this.props.transformStatus.get("transforming") && !this.props.isPlay && !this.props.isPlayAll&&this.props.mode!=='slide'))?<ItemToolBar camera = {this.props.selectedCamera} socket = {this.props.socket} suggestionPopup ={this.props.suggestionPopup}  setPropertyWindow={this.props.setPropertyWindow}  shortcutName={this.props.shortcutName}/>:null} */}
                    {/* {((this.props.sceneData.getIn([this.props.textStatus.get('container'),this.props.textStatus.get('id'),'textData','link'])&&this.props.selectedItems.size > 0&& !this.state.contextMenu && !this.props.transformStatus.get("transforming") && !this.props.isCropping && !this.props.isFraming && !this.props.isPlay && !this.props.isPlayAll && !this.props.isVideoCropping && this.props.swapDetails === null&&this.props.mode!=='slide') ||(this.props.sceneData.getIn(['workspaceItems',this.props.selectedItems.get(0),'link'])&&this.props.selectedItems.size > 0&& !this.state.contextMenu && !this.props.transformStatus.get("transforming") && !this.props.isCropping && !this.props.isFraming && !this.props.isPlay && !this.props.isPlayAll && !this.props.isVideoCropping && this.props.swapDetails === null) || (this.props.selectedCamera !== "" && !this.props.transformStatus.get("transforming") && !this.props.isPlay && !this.props.isPlayAll&&this.props.mode!=='slide'))?<HyperLinkToolBar htmlText={this.props.sceneData.getIn([this.props.textStatus.get('container'),this.props.textStatus.get('id'),'textData','htmlText'])} hyperlinkText={(this.props.sceneData.getIn([this.props.textStatus.get('container'),this.props.textStatus.get('id'),'textData','link'])&&this.props.sceneData.getIn([this.props.textStatus.get('container'),this.props.textStatus.get('id'),'textData','htmlText']))?this.props.sceneData.getIn([this.props.textStatus.get('container'),this.props.textStatus.get('id'),'textData','link']):(this.props.sceneData.getIn(['workspaceItems',this.props.selectedItems.get(0),'link']))?this.props.sceneData.getIn(['workspaceItems',this.props.selectedItems.get(0),'link']):''}  isaddLinkToObj={(this.props.sceneData.getIn(['workspaceItems',this.props.selectedItems.get(0),'link'])!==''&&this.props.sceneData.getIn(['workspaceItems',this.props.selectedItems.get(0),'link'])!==undefined)?true:false}  socket = {this.props.socket} sceneData={this.props.sceneData}/>:null} */}

                  
                    {(this.props.swapDetails !== null || this.props.isToolCropping)?<div className = "multimove-controls confirm-tool-bar" style={{left : this.workspaceX + "px", top : (this.workspaceY + (this.props.workspaceHeight * this.props.zoomFactor) + 10) + "px", position : "absolute", width : (this.props.workspaceWidth * this.props.zoomFactor) + "px", zIndex : 12, pointerEvents : "none"}}><div className = "confirmation"><span className="confirmation-icon" style = {{display : this.props.isToolCropping?"none":"inline-block"}} onClick = {this.cancelSwap}></span><span className = "confirmation-text" onClick = {this.applySwap}><FormattedMessage id="rec.apply"/></span></div></div>:null}
                    { 
                      <React.Fragment>
                        {zoomControl}
                        <FormattedMessage id="zm.cl.t.t" children={(val) => (
                          <div className="zoom_control_tool_tip" style={{'display' : 'none', left : (window.innerWidth / 2) - zoomLeft + 10}}>{val}</div>
                        )}></FormattedMessage>
                        {((this.props.isFullScreen) || this.props.mode==='slide')?null:slidesShow}
                      </React.Fragment>
                    }
                </div>}
                
                {/* <div className="add-transition hand-cursor" style={{fontSize : "14px"}} onClick={()=>this.setState({addTransition:!this.state.addTransition})}>  Add Transition</div> */}
                <CSSTransition in={this.state.addTransition}  timeout={500}  classNames="bottomTransition" unmountOnExit >
                 {
                     <div data-html2canvas-ignore="true" className="transition-showBlock" >
                     <span id='close' className="hand-cursor" onClick={()=>this.setState({addTransition:!this.state.addTransition})}>x</span>
                        <div className="transition-container">
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.no.tr"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.sw"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.sw.in"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.sw.ot"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.zm.in"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.zm.ot"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.3d"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.fp.ot"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.fp.in"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.ro.180"/></div>
                                <div className="transition-show"></div>    
                            </div>
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.ro.360"/></div>
                                <div className="transition-show"></div>    
                            </div>                                                        
                            <div>
                                <div className="transition-name"><FormattedMessage id="wr.ro.0"/></div>
                                <div className="transition-show"></div>    
                            </div>

                        </div>
                        
                    </div>
                }
                </CSSTransition>
            </React.Fragment>
        );
    }
}
  
export default WorkspaceComponent;






// WEBPACK FOOTER //
// ./src/components/WorkspaceComponent.js